const messages = {
  'app.pages.versions.excludeArchived': 'Excluir arquivadas',
  'app.pages.applications.openingOptions': 'Opções de abertura',
  'app.pages.applications.readOnly': 'Somente leitura',
  'app.pages.versions.openInNewInstance': 'Abrir em nova instância',
  'app.pages.versions.openInNewInstanceHelp':
    'Inicia um processo independente das sessões abertas. Usa recursos adicionais.',
  'app.pages.versions.searchVersions': 'Pesquisar versões',
  'app.pages.applications.openWithOptions': 'Abrir com opções…',
  'app.pages.applications.recommended': 'Recomendado',
  'app.pages.applications.useDefaultConfiguration': 'Usar configuração padrão',
  'app.pages.applications.recommendedResources': 'Opções de recursos',
  'app.pages.applications.recommendedResourcesHelp':
    'Ao abrir com opções, somente estes recursos serão oferecidos. Se ficar vazio, todos serão oferecidos.',
  'app.pages.applications.recommendedResourcesUnavailable':
    'Nenhum recurso permitido está disponível. O aplicativo será aberto com a configuração padrão.',
  'app.pages.applications.resourcesLoadError':
    'Não foi possível carregar os recursos. O aplicativo pode ser aberto com a configuração padrão ou o carregamento pode ser repetido.',
  'app.pages.applications.resourceUnavailable': 'Indisponível',
  'app.pages.applications.retry': 'Tentar novamente',
  'common.code': 'Código',
  'common.diagram': 'Diagrama',
  'common.preview': 'Pré-visualização',
  'common.result': 'Resultado',
  'common.shortcuts': 'Atalhos',
  'common.app': 'Aplicativo',
  'common.apps': 'Aplicativos',
  'common.confirm': 'Confirmar',
  'common.close': 'Fechar',
  'common.cancel': 'Cancelar',
  'common.run': 'Rodar',
  'common.stop': 'Parar',
  'common.home': 'Início',
  'common.error': 'Erro',
  'common.console': 'Console',
  'common.all': 'Todos',
  'common.allPlural': 'Todos',
  'common.apply': 'Aplicar',
  'common.noResultsFound': 'Nenhum resultado encontrado',
  'common.options': 'Opções',
  'common.goToNode': 'Ir ao nó',
  'common.goToInterface': 'Ir à interface',
  'common.goToModule': 'Ir ao módulo',
  'common.goToApplicationFiles': 'Ir aos arquivos do aplicativo',
  'common.goToVersionFiles': 'Ir aos arquivos da versão',
  'common.top': 'Superior',
  'common.bottom': 'Inferior',
  'common.left': 'Esquerda',
  'common.right': 'Direita',
  'common.default': 'Padrão',
  'common.custom': 'Personalizado',
  'common.none': 'Nenhum',
  'common.interface': 'Interface',
  'common.text': 'Texto',
  'common.true': 'Verdadeiro',
  'common.false': 'Falso',
  'common.hide': 'Ocultar',
  'common.show': 'Mostrar',
  'common.position': 'Posição',
  'common.inside': 'Dentro',
  'common.outside': 'Fora',
  'common.running': 'Executando',
  'common.general': 'Geral',
  'common.value': 'Valor',
  'common.edit': 'Editar',
  'common.username': 'Usuário',
  'common.password': 'Senha',
  'common.invalidPassword': 'Senha inválida',
  'common.required': 'Obrigatório',
  'common.copy': 'Copiar',
  'common.cut': 'Cortar',
  'common.pasteBelow': 'Colar abaixo',
  'common.about': 'Sobre',
  'common.documentation': 'Documentação',
  'common.addDocumentation': 'Adicionar documentação',
  'common.editDocumentation': 'Editar documentação',
  'common.hasDocumentation': 'Tem documentação',
  'common.documentationUpdated': 'Documentação atualizada com sucesso',
  'common.help': 'Ajuda',
  'common.from': 'De',
  'common.to': 'Até',
  'common.color': 'Cor',
  'common.values': 'Valores',
  'common.applyTo': 'Aplicar a',
  'common.save': 'Salvar',
  'common.paste': 'Colar',
  'common.total': 'Total',
  'common.totals': 'Totais',
  'common.row': 'Linha',
  'common.rows': 'Linhas',
  'common.column': 'Coluna',
  'common.columns': 'Colunas',
  'common.measures': 'Medidas',
  'common.labels': 'Rótulos',
  'common.read': 'Ler',
  'common.properties': 'Propriedades',
  'common.selectInterface': 'Selecionar interface',
  'common.yes': 'Sim',
  'common.no': 'Não',
  'common.table': 'Tabela',
  'common.tables': 'Tabelas',
  'common.cube': 'Cubo',
  'common.discard': 'Descartar',
  'common.settings': 'Ajustes',
  'common.resetView': 'Restaurar vista',
  'common.viewError': 'Ver erro',
  'common.reloadComponent': 'Recarregar componente',
  'common.fields': 'Campos',
  'common.delete': 'Excluir',
  'common.add': 'Adicionar',
  'common.information': 'Informação',
  'common.openApp': 'Abrir aplicativo',
  'common.openAppInNewInstance': 'Abrir aplicativo em nova instância',
  'common.description': 'Descrição',
  'common.version': 'Versão',
  'common.versions': 'Versões',
  'common.screenshots': 'Capturas de tela',
  'common.showInstallationLogs': 'Mostrar logs de instalação',
  'common.hideInstallationLogs': 'Ocultar logs de instalação',
  'common.noResults': 'Sem resultados',
  'common.conditionFormatType': 'Tipo de condição',
  'common.loadingAppVersion': 'Carregando versão do aplicativo',
  'common.loadingTextEditor': 'Carregando editor de texto..',
  'common.creatingAppVersion': 'Criando versão do aplicativo',
  'common.notAllowedCharacters':
    'O texto contém um ou mais caracteres não permitidos. Por favor, remova os seguintes caracteres: / \\ : * ? ',
  'common.status': 'Estado',
  'common.activate': 'Ativar',
  'common.archive': 'Arquivar',
  'common.unarchive': 'Desarquivar',
  'common.invalidCharactersMessage': 'Não são permitidos os seguintes caracteres: {characters}',
  'common.import': 'Importar',
  'common.export': 'Exportar',
  'common.validating': 'Validando',
  'common.scenarios': 'Cenários',
  'common.selectANode': 'Selecione um nó',
  'common.selectedNode': 'Nó selecionado',
  'common.deleteAll': 'Excluir tudo',
  'common.creator': 'Criador',
  'common.scenario': 'Cenário',
  'common.selectedNode.incorrect': 'O nó selecionado está incorreto. Selecione outro nó.',
  'common.max': 'Máximo',
  'common.min': 'Mínimo',
  'common.internalTests': 'Testes internos',
  'common.used': 'Usado',
  'common.generalSettings': 'Configurações Gerais',
  'common.clipboard': 'Prancheta',
  'common.clipboard.clear': 'Limpar prancheta',
  'common.apiKeysManager': 'Administrador de chaves API',
  'common.user': 'Usuário',
  'common.items': 'Itens',
  'common.assistant': 'Assistente',
  'common.assistants': 'Assistentes',
  'common.sources': 'Fontes',
  'common.team': 'Equipe',
  'common.appConsolidation': 'Consolidação',
  'common.changes': 'Mudanças',
  'common.destination': 'Destino',
  'common.new': 'Novo',
  'common.old': 'Velho',
  'common.definition': 'Definição',
  'common.nodes': 'Nós',
  'common.appManagement': 'Administração do aplicativo',
  'common.modules': 'Módulos',
  'common.maximize': 'Maximizar',
  'common.minimize': 'Minimizar',
  'common.areYouSureYouWantToProceed': 'Tem certeza de que deseja continuar?',
  'common.load': 'Carregar',
  'common.colors': 'Cores',
  'common.component': 'Componente',
  'common.source': 'Origem',
  'common.string': 'Texto',
  'common.integer': 'Inteiro',
  'common.float': 'Decimal',
  'common.boolean': 'Booleano',
  'common.date': 'Data',
  'common.datetime': 'Data e hora',
  'common.extraSettings': 'Configurações extras',
  'common.apiKeys': 'Chaves de API',
  'common.applicationEnvironment': 'Ambiente do aplicativo',
  'common.moduleRestrictions': 'Restrições de módulos',
  'common.workflowProcesses': 'Processos de fluxo de trabalho',
  'common.lostMessage': 'serão perdidos.',
  'common.attemptingReconnectServer': 'Tentando reconectar com o servidor, por favor aguarde...',
  'common.connectionReestablished': 'Conexão restabelecida',
  'common.order': 'Ordem',
  'common.nodeInterface': 'Interface de nó',
  'common.pleaseWait': 'Por favor espere...',
  'common.context': 'Contexto',
  'common.name': 'Nome',
  'common.assistantBot': 'Assistente',
  'common.assistantBots': 'Assistentes',
  'common.open': 'Abrir',
  'common.somethingWentWrong': 'Algo deu errado',
  'common.details': 'Detalhes',
  'common.reloadPage': 'Recarregar página',
  'common.titleAndId': 'Título + id',
  'common.expand': 'Expandir',
  'common.seeMore': 'Ver mais',
  'common.application': 'Aplicativo',
  'common.companyPreference': 'Preferências da empresa',
  'common.externalLinks': 'Links externos',
  'common.instance': 'Instância',
  'common.instanceId': 'ID da instância',
  'common.logging': 'Logs',
  'common.modelManager': 'Administrador de modelos',
  'common.userCompany': 'Usuário da empresa',
  'common.forceRun': 'Forçar execução',
  'common.of': 'de',
  'common.scrollBottom': 'Rolar para baixo',
  'common.scrollTop': 'Rolar para cima',
  'common.tableCopied': 'Tabela copiada',
  'common.copyId': 'Copiar id',
  'common.refresh': 'Atualizar',
  'common.invalidCharactersCompanyValidation':
    'Caracteres inválidos. Somente a-z minúsculo, A-Z maiúsculas, números de 0 a 9, hífens e sublinhados são permitidos',
  'common.invalidCharactersFilesAndFoldersValidation':
    'Caracteres inválidos. Somente a-z minúsculo, A-Z maiúsculas, números de 0 a 9, hífens, sublinhados e símbolos "+", "%", "&" e "*" são permitidos',
  'common.invalidCharactersAppsVersionsScenariosValidation':
    'Caracteres inválidos. Somente a-z minúsculo, A-Z maiúsculas, números de 0 a 9 e hífens, sublinhados, parênteses e símbolos "+", "%", "&" e "*" são permitidos',
  'common.undo': 'Desfazer',
  'common.redo': 'Refazer',
  'common.darkMode': 'Modo escuro',
  'common.lightMode': 'Modo claro',
  'common.copyTableToClipboard': 'Copiar tabela para a área de transferência',
  'common.websocketsStatus': 'Estado do Websockets',
  'common.connected': 'Conectado',
  'common.disconnected': 'Desconectado',
  'common.persistenceType': 'Tipo de persistência',
  'common.inDefinition': 'Em definição',
  'common.inMemory': 'Na memória',
  'common.onDisk': 'Em disco',
  'common.persistencePath': 'Caminho de persistência',
  'common.componentCodeError': 'Houve um erro no código do componente',
  'common.resultError': 'Não foi possível exibir o resultado deste componente',
  'common.componentDefinitionError': 'Houve um erro na definição do componente',
  'common.nodeResultError': 'Não foi possível exibir o resultado deste nó',
  'common.noPermissionToNavigate': 'Você não tem permissão para ir para {path}',
  'common.addContext': 'Adicionar contexto',
  'common.addAsContext': 'Adicionar como contexto',
  'common.addComponent': 'Adicionar componente',
  'common.addComponentToAgentContext': 'Adicionar componente ao contexto do agente',
  'common.addNodeContextMessage': 'Para adicionar contexto, selecione e execute um nó',
  'common.addComponentToContextMessage': 'Clique em um componente para adicioná-lo como contexto',
  'common.selectComponentToContextMessage': 'Selecionar um componente como contexto',
  'common.sort': 'Ordenar',
  'common.ascending': 'Ascendente',
  'common.descending': 'Descendente',
  'common.preference': 'Preferência',
  'common.insert': 'Inserir',
  'common.searchBy': 'Buscar por',
  'common.searchFields': 'Buscar campos',
  'common.clear': 'Limpar',
  'common.charts': 'Gráficos',
  'common.indicators': 'Indicadores',
  'common.indexes': 'Índices',

  copying_app_to_user_workspace: 'Copiando aplicativo no espaço de trabalho do usuário',
  creating_environment: 'Criando ambiente',
  starting_environment: 'Inicializando o ambiente',
  loading_workspace: 'Carregamento do espaço de trabalho',
  engine_created: 'Motor de cálculo criado',
  starting_pyplan_calc_engine: 'Inicializando o motor de cálculo',
  opening_app: 'Abrindo aplicativo',
  cancel_opening_app: 'Cancelar abertura',
  canceling_app_opening: 'Cancelando...',
  error_opening_app: 'Ocorreu um erro ao abrir o aplicativo',
  installing_requirements_file_libraries: 'Instalando bibliotecas do arquivo requirements.txt',
  no_libraries_to_install: 'Sem bibliotecas para instalar',
  processing_startup_nodes: 'Processando nós iniciais',
  reading_app_properties: 'Lendo propriedades do aplicativo',
  reading_app_modules: 'Lendo módulos do aplicativo',
  loading_interfaces: 'Carregando interfaces',
  creating_nodes: 'Criando nós',
  applying_migrations: 'Aplicando migrações',
  done: 'Pronto',
  may_take: 'Esta tarefa pode demorar até 5 minutos. Por favor, aguarde...',
  'common.checkingPythonLibrariesUsedInModel':
    'Verificação das bibliotecas python utilizadas no modelo',
  'common.librariesAlreadyInstalled': 'Bibliotecas já instaladas',
  'common.resultsNotFound': 'Sem resultados, faça uma pesquisa',
  need_logout: 'Logout necessário',
  need_logout_detail:
    'O administrador pediu que a instância fosse encerrada. Favor salvar e encerrar a instância o mais rápido possível',
  session_killed_detail: 'Logout necessário',
  session_killed: 'O administrador encerrou sua instância',
  instance_purged: 'Sua instância expirou devido a inatividade',
  instance_purged_detail: 'Fechar instância',
  session_purged: 'Sua sessão expirou devido a inatividade',
  session_purged_detail: 'Iniciar sessão de novo',
  engine_down:
    'O motor de cálculo foi fechado de maneira inesperada. Por favor, encerre a instância e abra uma nova',
  engine_down_detail: 'Encerrar instância',
  error_installing_libs_from_requirements:
    'Erro instalando bibliotecas do arquivo requirements.txt',
  error_creating_new_version: 'Erro criando nova versão',
  error_version_name_already_exists: 'O nome da versão escolhido já existe',
  app_recovered_from_backup: 'Aplicativo recuperado da cópia de segurança',
  indexing_documents: 'Indexando documentos',
  recovered_existing_instance: 'O aplicativo foi recuperado a partir de uma instância existente.',
  app_closed_in_another_tab: 'O aplicativo foi fechado em outra aba.',
  app_closed_by_agent: 'O agente fechou o aplicativo.',
  'app.agentLive.anAgent': 'Um agente',
  'app.agentLive.working': '{name} está trabalhando neste aplicativo',
  'app.agentLive.follow': 'Seguir o agente',
  'app.agentLive.status': 'Trabalhando neste aplicativo via MCP',
  'app.agentLive.tooltip':
    '{name} está trabalhando neste aplicativo via MCP. Você vê as alterações aqui à medida que ele as faz. Clique para escolher se a tela o acompanha.',
  'app.agentLive.followHelp':
    'Leva você aos nós e interfaces que ele edita. Não faz isso enquanto você tiver alterações não confirmadas.',
  'app.agentLive.nodeCreated': 'O agente criou um nó',
  'app.agentLive.nodeUpdated': 'O agente modificou um nó',
  'app.agentLive.nodesMoved': 'O agente moveu nós de um módulo',
  'app.agentLive.interfaceChangedWhileEditing':
    'O agente alterou esta interface enquanto você a edita',
  'app.agentLive.viewCaptured': 'O agente capturou sua tela para revisar o trabalho',
  'app.agentLive.interfaceChangedWhileEditingDetail':
    'Não foi atualizada para manter suas alterações. Ao salvá-las, você substitui as do agente.',
  'app.agentLive.nodesDeleted': 'O agente excluiu nós de um módulo',
  'app.agentLive.interfaceCreated': 'O agente criou uma interface',
  'app.agentLive.interfaceUpdated': 'O agente modificou uma interface',
  session_closed_in_another_tab: 'A sessão foi fechada em outra aba.',
  indexing_app_elements: 'Indexando elementos do aplicativo',
  uploading_app_documentation: 'Carregando documentação do aplicativo',

  //home
  'app.components.HomePage.header': 'Início',
  //notifier
  'common.notifier.dismissSnackbar': 'Fechar',
  'common.notifier.readMore': 'Ver mais',

  //Initial configuration
  'app.pages.initialConfig.initialSetUp': 'Configuração inicial',
  'app.pages.initialConfig.internalTesting': 'Teste interno',
  'app.pages.initialConfig.finish': 'Finalizar',
  'app.pages.initialConfig.initialConfig': 'Por favor, digite o nome da empresa',
  'app.pages.initialConfig.userAdminInfo':
    'Digite as informações de usuário do administrador da empresa',
  'app.pages.initialConfig.copyKey':
    'Copie o código de ativação e envie-o para o administrador do sistema para gerar o código de licença',
  'app.pages.initialConfig.finishMessage': 'Processo concluído com sucesso',
  'app.pages.initialConfig.licenseSuccess': 'Licença gerada com sucesso',

  // Internal tests
  'app.pages.internalTests.runTests': 'Executar testes',
  'app.pages.internalTests.deleteApp': 'Excluir aplicativo',
  'app.pages.internalTests.createPublicFolder': 'Criar pasta pública',
  'app.pages.internalTests.removePublicFolder': 'Remover pasta pública',
  'app.pages.internalTests.systemResources': 'Recursos do sistema',

  //cards
  'app.components.cards.instanceCard.openAgo': 'Aberta há {number} mins',
  'app.components.cards.instanceCard.currentInstance': 'Instância atual',
  'app.components.cards.instanceCard.activeAgo': 'Ativa há {number} mins',
  'app.components.cards.instanceCard.deleteInstance': 'Excluir instância',
  'app.components.cards.instanceCard.selectInstance': 'Selecionar instância',
  'app.components.cards.instanceCard.changeInstance':
    'Mudar para esta instância:{br}- Nome: {title}{br}- Versão: {version}{br}- Caminho: {modelPath}',
  'app.components.cards.instanceCard.currentInstanceTooltip':
    '- Nome: {title}{br}- Versão: {version}{br}- Caminho: {modelPath}',

  //login
  'app.pages.login.init': 'Início',
  'app.pages.login.usernameLabel': 'Usuário',
  'app.pages.login.passwordLabel': 'Senha',
  'app.pages.login.forgotPassword': 'Esqueceu sua senha?',
  'app.pages.login.sendInstructions': 'Enviar Instruções',
  'app.pages.login.login': 'Iniciar Sessão',
  'app.pages.login.connectWithSocialMedia': 'Conecte-se com redes sociais',
  'app.pages.login.connectWithApp': 'Conectar com {app}',
  'app.pages.login.or': 'ou',
  'app.pages.login.orContinueWith': 'Ou continue com:',
  'app.pages.login.SSOTo': 'SSO a {company}',
  'app.pages.login.createAnAccount': 'Criar uma conta',
  'app.pages.login.copyright': 'Copyright © Pyplan {year}.',
  'app.pages.login.selectCompany': 'Selecione uma empresa',
  'app.pages.login.licenseInfo': 'Informação da licença',
  'app.pages.login.invalidLicense': 'Licença inválida',
  'app.pages.login.carousel.previous': 'Anterior', //Duplicated on PT and ES, but unique on EN
  'app.pages.login.carousel.next': 'Próxima',
  'app.pages.login.carousel.viewMore': 'Ver mais',
  'app.pages.login.carousel.userPasswordExpired':
    'Sua senha de usuário expirou! Por favor, escolha uma nova para manter sua conta segura.',
  'app.pages.login.carousel.userPasswordRepeated':
    'A nova senha deve ser diferente da senha atual.',
  'app.pages.login.rememberMe': 'Lembre-me',
  'app.pages.login.resetPasswordMessage':
    'Se existir uma conta para este usuário, você receberá um e-mail com instruções para redefinir sua senha.',
  'app.pages.login.resetPassword': 'Redefinir senha',
  'app.pages.login.passwordChangedSuccessfully': 'Senha alterada com sucesso',
  'app.pages.login.invalidToken': 'O token é inválido',
  'app.pages.login.multiFactorAuthentication': 'Autenticação de múltiplos fatores',
  'app.pages.login.scanQrCode':
    'Aprimore a segurança da sua conta baixando um aplicativo de Autenticação em Dois Fatores (2FA), como o Google Authenticator ou o Microsoft Authenticator, em seu dispositivo móvel. Escaneie o código QR abaixo usando o aplicativo para gerar códigos de verificação únicos sempre que fizer login.',
  'app.pages.login.enterCode': 'Insira o código gerado pelo seu aplicativo de autenticação',
  'app.pages.login.enterCodePlaceholder': 'Insira o código',
  'app.pages.login.enterCodeError': 'O código é inválido',
  'app.pages.login.enterCodeSuccess': 'Autenticação de múltiplos fatores habilitada com sucesso',
  'app.pages.login.verify': 'Verificar',
  'app.pages.login.cantUseAuthAppNow': 'Não consigo usar meu aplicativo autenticador no momento.',
  'app.pages.login.sendCodeToEmail':
    'Enviamos o código de verificação para a sua caixa de correio eletrônico {userSecretMail}. Por favor, insira o código para continuar.',
  'app.pages.login.loadingInstanceData': 'Carregando dados da instância',
  'app.pages.login.deleteSSOTo': 'Excluir link "SSO a {company}"',
  'app.pages.login.invalidCredentials':
    'Não foi possível fazer login com as credenciais fornecidas.',
  'app.pages.login.accountDisabled':
    'A conta de usuário está desativada. Por favor, entre em contato com seu administrador.',
  'app.pages.login.invalidInput': "Deve incluir 'nome de usuário' e 'senha'.",
  'app.pages.login.directAccessCompanyDenied': 'Sua conta não tem acesso à empresa {company}.',
  'app.pages.login.privacyMessage': 'Ao entrar, você concorda com os',
  'app.pages.login.termsOfService': 'Termos de serviço',
  'app.pages.login.privacyPolicy': 'Política de privacidade',

  //topbar
  'app.pages.app.topbar.notifications': 'Notificações',
  'app.pages.app.topbar.showMore': 'Ver mais',
  'app.pages.app.topbar.showNotifications': 'Ver notificações',
  'app.pages.app.topbar.showErrors': 'Mostrar erros',
  'app.pages.app.topbar.defaultInterface': 'Interface padrão',
  'app.pages.app.topbar.summary': 'Resumo',
  'app.pages.app.topbar.manageLibs': 'Bibliotecas',
  'app.pages.app.topbar.reloadApp': 'Recarregar aplicativo',
  'app.pages.app.topbar.createNew.app': 'Aplicativo',
  'app.pages.app.topbar.layout.diagram': 'Resultado',
  'app.pages.app.topbar.layout.preview': 'Código+Preview',
  'app.pages.app.topbar.layout.result': 'Código+Resultado',
  'app.pages.app.topbar.saveAs': 'Salvar como',
  'app.pages.app.topbar.saveAsNewVersion': 'Salvar como nova versão',
  'app.pages.app.topbar.saveApplicationInMyWorkspace':
    'Salvar aplicativo no meu espaço de trabalho',
  'app.pages.app.topbar.saveApplicationInTeam': 'Salvar aplicativo na minha equipe',
  'app.pages.app.topbar.claimWriteMode': 'Reivindicar modo de escrita',
  'app.pages.app.topbar.writeModeClaimed': 'Agora você pode salvar suas alterações',
  'app.pages.app.topbar.appName': 'Nome do Aplicativo',
  'app.pages.app.topbar.appNameValidationError':
    'O nome do aplicativo não pode conter algum dos seguintes caracteres: ',
  'app.pages.app.topbar.selectAppVersionsToCopy': 'Selecionar versões do aplicativo para copiar',
  'app.pages.app.topbar.copiesAllAppVersionMessage':
    'Todas as versões serão copiadas se nenhuma foi selecionada',
  'app.pages.app.topbar.logout': 'Sair',
  'app.pages.app.topbar.libsManager.uninstalled': 'A biblioteca foi desinstalada com sucesso',
  'app.pages.app.topbar.libsManager.version': 'Versão',
  'app.pages.app.topbar.libsManager.refresh': 'Atualizar',
  'app.pages.app.topbar.libsManager.location': 'Localização',
  'app.pages.app.topbar.libsManager.actions': 'Ações',
  'app.pages.app.topbar.libsManager.installedLibraries': 'Bibliotecas instaladas',
  'app.pages.app.topbar.libsManager.install': 'Instalar',
  'app.pages.app.topbar.libsManager.appRequirements': 'Requisitos do aplicativo',
  'app.pages.app.topbar.libsManager.saveFileInstallLibraries':
    'Salvar arquivo e instalar bibliotecas',
  'app.pages.app.topbar.libsManager.saveInstallLibraries': 'Salvar e instalar',
  'app.pages.app.topbar.libsManager.requirementsFile': 'Arquivo requirements.txt',
  'app.pages.app.topbar.libsManager.pipInstallError': 'Espaços em branco não são permitidos',
  'app.pages.app.topbar.libsManager.systemLib': 'biblioteca do sistema',
  'app.pages.app.topbar.libsManager.userLib': 'biblioteca do usuário',
  'app.pages.app.topbar.libsManager.filter': 'Filtrar',
  'app.pages.app.topbar.libsManager.libraries': 'Bibliotecas',
  'app.pages.app.topbar.showConsole': 'Ver console',
  'app.pages.app.topbar.showPinnedNodes': 'Ver nós fixados',
  'app.pages.app.topbar.hidePinnedNodes': 'Ocultar nós fixados',
  'app.pages.app.topbar.closeConsole': 'Fechar console',
  'app.pages.app.topbar.appProperties': 'Propriedades',
  'app.pages.app.topbar.appPropertiesUpdatedSuccessfully':
    'Propriedades do aplicativo atualizadas com sucesso',
  'app.pages.app.topbar.deparmentsError':
    'Existe uma interface sem departamentos.Selecione um departamento.',
  'app.pages.app.topbar.deparmentRepeated': 'O departamento {name} já tem uma interface definida',
  'app.pages.app.topbar.allDeps': 'Todos',
  'app.pages.app.topbar.selecteDefaultInterface': 'Selecione a interface padrão para o aplicativo',
  'app.pages.app.topbar.libsManager.cantInstallHead':
    'O aplicativo utiliza um ambiente público. Pyplan precisa gerar um ambiente único para que possa adicionar/remover bibliotecas (esta tarefa pode levar alguns minutos).',
  'app.pages.app.topbar.libsManager.cantInstallTasksHead':
    'Para isso, serão realizadas as seguintes tarefas:',
  'app.pages.app.topbar.libsManager.cantInstallTask1': 'o aplicativo atual será salvado',
  'app.pages.app.topbar.libsManager.cantInstallTask2': 'será criado um novo ambiente exclusivo',
  'app.pages.app.topbar.libsManager.cantInstallTask3':
    'o aplicativo será reaberto com o ambiente único',
  'app.pages.app.topbar.libsManager.cantInstallConfirmationMessage':
    'Tem certeza de que deseja realizar estas tarefas?',
  'app.pages.app.topbar.libsManager.cantInstallButtonText': 'Sim, realizar estas tarefas',
  'app.pages.app.topbar.changeAppVersion': 'Alterar versão do aplicativo',
  'app.pages.app.topbar.changeVersion': 'Alterar versão',
  'app.pages.app.topbar.takeScreenshot': 'Tirar captura de tela',
  'app.pages.app.topbar.goToAppFolder': 'Ir para a pasta do aplicativo',
  'app.pages.app.topbar.screenshotResult': 'Resultado da captura de tela',
  'app.pages.app.topbar.downloadScreenshot': 'Baixar imagem',
  'app.pages.app.topbar.saveImageAsAppThumbnail': 'Salvar imagem como miniatura do aplicativo',
  'app.pages.app.topbar.appIdError':
    'O ID do aplicativo só pode conter números, letras, hífens e deve ter mais de 7 caracteres',
  'app.pages.app.topbar.mustRestartAppWarning':
    'Para que as alterações entrem em vigor, você deve reiniciar o aplicativo.',
  'app.pages.app.topbar.allDataRelatedTo': 'Todos os dados relacionados a:',
  'app.pages.app.topbar.additionalInformation': 'Informações adicionais',
  'app.pages.app.topbar.nodesEvaluatedMessage': 'Nós avaliados quando o aplicativo é aberto',
  'app.pages.app.topbar.noNodesEvaluated':
    'Não há nós que sejam avaliados quando o aplicativo é aberto.',
  'app.pages.app.topbar.defaultSettings': 'Opções padrão',
  'app.pages.app.topbar.componentHeaderBackgroundColor':
    'Cor de fundo do cabeçalho do componente - tabelas, gráficos, indicadores, formulários',
  'app.pages.app.topbar.componentHeaderTextColor':
    'Cor do texto do cabeçalho do componente - tabelas, gráficos, indicadores, formulários',
  'app.pages.app.topbar.commonHeaderBackgroundColor':
    'Cor de fundo do cabeçalho do componente - índices, seletores',
  'app.pages.app.topbar.commonHeaderColor':
    'Cor do texto do cabeçalho do componente - índices, seletores',
  'app.pages.app.topbar.libsManager.creatingEnvironmentSuccess': 'Ambiente criado',
  'app.pages.app.topbar.showColumnFilterIcon': 'Mostrar ícone de filtro de coluna',
  'app.pages.app.topbar.showIndex': 'Mostrar índice',
  'app.pages.app.topbar.defaultStylesComponentHeaderColorsSection':
    'Cores do cabeçalho do componente',
  'app.pages.app.topbar.defaultStylesTableOptionsSection': 'Opções de tabelas',
  'app.pages.app.topbar.defaultStylesChartOptionsSection': 'Opções de gráficos',
  'app.pages.app.topbar.defaultStylesFormatsSection': 'Formatos padrão',
  'app.pages.app.topbar.dateFormatLabel': 'Formato de datas',
  'app.pages.app.topbar.dateTimeFormatLabel': 'Formato de data e hora',
  'app.pages.app.topbar.indexFormatLabel': 'Formato de índices',
  'app.pages.app.topbar.selectorFormatLabel': 'Formato de seletores',
  'app.pages.app.topbar.defaultStylesFormPropertiesSection': 'Opções de formulários',
  'app.pages.app.topbar.buildAutomaticDateHierarchies':
    'Construir hierarquias de datas automáticas',
  'app.pages.app.topbar.scenarioFillMissingWithZero': 'Preencher valores ausentes com zero',
  'app.pages.app.topbar.scenarioZeroDivisionReturnsZero': 'Divisão por zero retorna zero',
  'app.pages.app.topbar.fontFamily': 'Família de fonte',
  'app.pages.app.topbar.tableNonEditableCellBackgroundColor': 'Cor de fundo da célula não editável',
  'app.pages.app.topbar.tableNonEditableCellColor': 'Cor do texto da célula não editável',
  'app.pages.app.topbar.tableEditableCellBackgroundColor': 'Cor de fundo da célula editável',
  'app.pages.app.topbar.tableEditableCellColor': 'Cor do texto da célula editável',
  'app.pages.app.topbar.tableLabelsBackgroundColor': 'Cor de fundo dos rótulos',
  'app.pages.app.topbar.tableLabelsColor': 'Cor do texto dos rótulos',
  'app.pages.app.topbar.tableColorsLightTheme': 'Tema claro',
  'app.pages.app.topbar.tableColorsDarkTheme': 'Tema escuro',
  'app.pages.app.topbar.chartColorPalettes': 'Paletas de cores',

  //Info menu dialog:
  'app.pages.app.closeApp': 'Fechar aplicativo',
  'app.pages.app.closedSuccessfully': 'Aplicativo fechado com sucesso',
  'app.pages.app.reloadSuccessfully': 'Aplicativo recarregado com sucesso',
  'app.pages.app.saveSuccessfully': 'Aplicativo salvado com sucesso',
  'app.pages.app.appNewPath': 'O aplicativo foi salvado em: ',
  'app.pages.app.saveApp': 'Salvar aplicativo',
  'app.pages.app.newModelName': 'Nome do novo modelo',
  'app.pages.app.newModelNamePlaceholder': 'Insira o nome do novo modelo',
  'app.pages.app.unconfirmedNodes': 'Nós não confirmados',
  'app.pages.app.saveDefinitionsAndApp': 'Confirmar as definições e salvar o aplicativo',
  'app.pages.app.discardDefinitionsAndSaveApp': 'Descartar as definições e salvar o aplicativo',
  'app.pages.app.unconfirmedNodesAlert':
    'Existem {number} nós com definições não confirmadas. O que você gostaria de fazer?',
  'app.pages.app.lostDataAlert': 'Os dados do aplicativo não salvos serão perdidos. Tem certeza?',
  'app.pages.app.unsavedChanges': 'Existem alterações não salvas. O que você gostaria de fazer?',
  'app.pages.app.saveChangesAndOpenApp': 'Salvar alterações e abrir aplicativo',
  'app.pages.app.discardChangesAndOpenApp': 'Descartar alterações e abrir aplicativo',
  'app.pages.app.saveChangesAndCreateApp': 'Salvar alterações e criar aplicativo',
  'app.pages.app.discardChangesAndCreateApp': 'Descartar alterações e criar aplicativo',
  'app.pages.app.saveChangesAndLogout': 'Salvar alterações e sair',
  'app.pages.app.saveChangesAndReload': 'Salvar alterações e recarregar aplicativo',
  'app.pages.app.saveChangesAndCloseApp': 'Salvar alterações e fechar aplicativo',

  //sidebarMenu:
  'app.pages.app.sidebarMenu.fileManager': 'Administrador de arquivos',
  'app.pages.app.sidebarMenu.code': 'Código',
  'app.pages.app.sidebarMenu.interfaces': 'Interfaces',
  'app.pages.app.sidebarMenu.tools': 'Ferramentas',
  'app.pages.app.sidebarMenu.aiManagement': 'Gestão de IA',
  'app.pages.app.sidebarMenu.scheduledTasks': 'Tarefas programadas',
  'app.pages.app.sidebarMenu.myAccount': 'Minha conta',
  'app.pages.app.sidebarMenu.settings': 'Ajustes',
  'app.pages.app.sidebarMenu.securityOptions': 'Opções de segurança',
  'app.pages.app.sidebarMenu.users': 'Usuários',
  'app.pages.app.sidebarMenu.departments': 'Departamentos',
  'app.pages.app.sidebarMenu.teams': 'Equipes',
  'app.pages.app.sidebarMenu.instance': 'Gerenciador de instâncias',
  'app.pages.app.sidebarMenu.permissionByRole': 'Permissão por cargo',
  'app.pages.app.sidebarMenu.applications': 'Aplicativos',
  'app.pages.app.sidebarMenu.processManager': 'Processos',
  'app.pages.app.sidebarMenu.home': 'Início',
  'app.pages.app.sidebarMenu.numberLocale': 'Formato numérico',
  'app.pages.app.sidebarMenu.language': 'Idioma',
  'app.pages.app.sidebarMenu.applicationAnalysis': 'Análise',
  'app.pages.app.sidebarMenu.connections': 'Conexões',
  'app.pages.app.sidebarMenu.applicationTests': 'Testes de aplicativo',
  'app.pages.app.sidebarMenu.support': 'Suporte',
  'app.pages.app.sidebarMenu.supportNewTicket': 'Criar ticket',
  'app.pages.app.sidebarMenu.supportMyTickets': 'Meus tickets',
  'app.pages.support.errors.tabBlocked':
    'O navegador bloqueou a aba do Pyplan Support. Permita pop-ups deste site e tente novamente.',
  'app.pages.support.errors.timeout':
    'O Pyplan demorou demais para abrir o Pyplan Support. Tente novamente.',
  'app.pages.support.errors.network':
    'Não foi possível conectar ao Pyplan para abrir o Pyplan Support. Verifique sua conexão e tente novamente.',
  'app.pages.support.errors.invalidResponse':
    'Não foi possível abrir o Pyplan Support porque o Pyplan enviou uma resposta inesperada. Tente novamente.',
  'app.pages.support.errors.notEnabled': 'O Pyplan Support não está habilitado para sua empresa.',
  'app.pages.support.errors.emailRequired':
    'Seu usuário precisa de um e-mail válido para abrir o Pyplan Support. Peça ao seu administrador para adicioná-lo.',
  'app.pages.support.errors.sessionExpired':
    'Sua sessão não pode mais abrir o Pyplan Support. Entre novamente e tente outra vez.',
  'app.pages.support.errors.unavailable':
    'Não foi possível abrir o Pyplan Support (erro {status}). Tente novamente mais tarde.',

  //home
  'app.pages.app.home.myPyplan': 'Meu Pyplan',
  'app.pages.app.home.openApps': 'Aplicativos abertos',
  'app.pages.app.home.workspaces': 'Espaços de trabalho',
  'app.pages.app.home.folders': 'Pastas',
  'app.pages.app.home.instanceKilledSuccessfully': 'Instância excluída com sucesso',
  'app.pages.app.home.instanceChangedSuccessfully': 'Instância mudada com sucesso',
  //home.pyplanResources
  'app.pages.app.home.pyplanResources': 'Recursos Pyplan',
  'app.pages.app.home.pyplanResources.videos': 'Vídeos',
  'app.pages.app.home.pyplanResources.videosCaption': 'Veja o Pyplan em ação',
  'app.pages.app.home.pyplanResources.documentation': 'Documentação',
  'app.pages.app.home.pyplanResources.documentationCaption': 'Passos básicos',
  'app.pages.app.home.pyplanResources.examples': 'Exemplos',
  'app.pages.app.home.pyplanResources.examplesCaption': 'de aplicativos',
  //home.shortcutsPanel
  'app.pages.app.home.shortcutsPanel.tutorials': 'Tutoriais',
  'app.pages.app.home.shortcutsPanel.examples': 'Exemplos',
  'app.pages.app.home.shortcutsPanel.demos': 'Demonstrações',
  'app.pages.app.home.shortcutsPanel.models': 'Modelos',
  'app.pages.app.home.shortcutsPanel.noModelFound':
    'Nenhum modelo foi aberto recentemente. Procure seus arquivos ou crie um novo.',
  'app.pages.app.home.shortcutsPanel.noExamplesFound': 'Sem exemplos',
  'app.pages.app.home.shortcutsPanel.my_apps': 'Meus aplicativos',
  'app.pages.app.home.shortcutsPanel.public_apps': 'Aplicativos públicos',
  'app.pages.app.home.shortcutsPanel.recently_opened': 'Recentemente aberto',
  'app.pages.app.home.shortcutsPanel.noPermissionsToViewApps':
    'Você não tem permissões para visualizar aplicativos. Entre em contato com um administrador.',

  //editProfile
  'app.pages.editProfile.editProfile': 'Perfil',
  'app.pages.editProfile.changePasswordAlert':
    'Se você alterar sua senha, sua instância será encerrada e você precisará fazer login novamente',
  'app.pages.editProfile.currentPassword': 'Senha atual',
  'app.pages.editProfile.currentPasswordIncorrect': 'Senha atual incorreta',
  //my account
  'app.pages.myAccount.title': 'Minha conta',
  'app.pages.myAccount.preferences': 'Preferências',
  'app.pages.myAccount.accessTokens': 'Tokens de acesso',
  'app.pages.accessTokens.title': 'Tokens de acesso pessoais',
  'app.pages.accessTokens.description':
    'Os tokens de acesso pessoais permitem que clientes headless (Claude Code, scripts, outros clientes MCP) e integrações de API se autentiquem em seu nome com um token bearer estático, substituindo o login interativo. Trate-os como senhas.',
  'app.pages.accessTokens.create': 'Criar token',
  'app.pages.accessTokens.name': 'Nome',
  'app.pages.accessTokens.defaultCompany': 'Empresa padrão',
  'app.pages.accessTokens.defaultCompanyHelp':
    'A sessão começa nesta empresa; o assistente pode trocá-la depois.',
  'app.pages.accessTokens.expiration': 'Expiração',
  'app.pages.accessTokens.expiresInDays': '{days} dias',
  'app.pages.accessTokens.createdAt': 'Criado',
  'app.pages.accessTokens.expiresAt': 'Expira',
  'app.pages.accessTokens.lastUsed': 'Último uso',
  'app.pages.accessTokens.status': 'Estado',
  'app.pages.accessTokens.active': 'Ativo',
  'app.pages.accessTokens.expired': 'Expirado',
  'app.pages.accessTokens.revoked': 'Revogado',
  'app.pages.accessTokens.revoke': 'Revogar',
  'app.pages.accessTokens.revokeConfirm':
    'Revogar este token? Os clientes que o utilizam deixarão de funcionar.',
  'app.pages.accessTokens.copyWarning': 'Copie este token agora — ele não será exibido novamente.',
  'app.pages.accessTokens.copy': 'Copiar',
  'app.pages.accessTokens.copied': 'Copiado',
  'app.pages.accessTokens.empty': 'Você ainda não tem tokens de acesso.',
  'app.pages.accessTokens.descriptionForAgent':
    'Os tokens de acesso permitem que este agente se autentique a partir de clientes headless (Claude Code, scripts, outros clientes MCP) com um bearer token estático. O agente não pode fazer login, então seus tokens são gerenciados aqui. Trate-os como senhas.',
  'app.pages.accessTokens.emptyForAgent': 'Este agente ainda não tem tokens de acesso.',
  'app.pages.accessTokens.nameRequired': 'O nome é obrigatório',
  'app.pages.accessTokens.createError': 'Não foi possível criar o token. Tente novamente.',
  //scim tokens (company manager)
  'app.pages.scimTokens.title': 'Tokens SCIM',
  'app.pages.scimTokens.create': 'Criar token',
  'app.pages.scimTokens.name': 'Nome',
  'app.pages.scimTokens.company': 'Empresa',
  'app.pages.scimTokens.prefix': 'Prefixo',
  'app.pages.scimTokens.createdAt': 'Criado',
  'app.pages.scimTokens.expiresAt': 'Expira',
  'app.pages.scimTokens.lastUsedAt': 'Último uso',
  'app.pages.scimTokens.status': 'Estado',
  'app.pages.scimTokens.active': 'Ativo',
  'app.pages.scimTokens.expired': 'Expirado',
  'app.pages.scimTokens.revoked': 'Revogado',
  'app.pages.scimTokens.revoke': 'Revogar',
  'app.pages.scimTokens.revokeConfirm': 'Revogar este token? O Entra ID deixará de poder usá-lo.',
  'app.pages.scimTokens.copy': 'Copiar',
  'app.pages.scimTokens.copied': 'Copiado',
  'app.pages.scimTokens.copyWarning': 'Copie este token agora — ele não será exibido novamente.',
  'app.pages.scimTokens.empty': 'Esta empresa ainda não tem tokens SCIM.',
  'app.pages.scimTokens.nameRequired': 'O nome é obrigatório',
  'app.pages.scimTokens.noExpiration': 'Sem expiração',
  'app.pages.scimTokens.createError': 'Não foi possível criar o token. Tente novamente.',
  'app.pages.scimTokens.tabSecretToken': 'Secret Token',
  'app.pages.scimTokens.tabOAuth2': 'OAuth 2.0',
  'app.pages.scimTokens.oauth2Create': 'Criar client',
  'app.pages.scimTokens.oauth2Help':
    'O Token Endpoint a ser inserido no Entra é /api/oauth2/token deste servidor.',
  'app.pages.scimTokens.oauth2ClientId': 'Client ID',
  'app.pages.scimTokens.oauth2ClientSecret': 'Client Secret',
  'app.pages.scimTokens.oauth2CopyWarning':
    'Copie o Client Secret agora — ele não será exibido novamente.',
  'app.pages.scimTokens.oauth2Empty': 'Esta empresa ainda não tem clients OAuth2.',
  'app.pages.myAccount.personalData': 'Dados pessoais',
  'app.pages.myAccount.formatAndLanguage': 'Formato e idioma',
  'app.pages.myAccount.theme': 'Tema',

  //managers
  'app.pages.app.managers.firstPage': 'Primeira',
  'app.pages.app.managers.prevPage': 'Anterior',
  'app.pages.app.managers.nextPage': 'Próxima',
  'app.pages.app.managers.lastPage': 'Última',
  'app.pages.app.managers.cancel': 'Cancelar',
  'app.pages.app.managers.update': 'Atualizar',
  'app.pages.app.managers.create': 'Criar',
  'app.pages.app.managers.search': 'Procurar',
  'app.pages.app.managers.searchHelperText': 'Escreva pelo menos 3 caracteres',
  'app.pages.app.managers.companyManager': 'Administrador da empresa',
  'app.pages.app.managers.folder': 'Pasta',
  'app.pages.app.managers.departmentManager': 'Administrador de departamentos',
  'app.pages.app.managers.rowsPerPage': 'Linhas por página',
  'app.pages.app.managers.company': 'Empresa',
  'app.pages.app.managers.company.companies': 'Empresas',
  'common.name.isRequired': 'O nome é necessário',
  'app.pages.app.managers.company.notFound': 'Empresa não encontrada',
  'app.pages.app.managers.company.placeholder': 'Escolha uma empresa',
  'app.pages.app.managers.company.isRequired': 'A empresa é necessária',
  'app.pages.app.managers.roleManager': 'Administrador de cargos',
  'app.pages.managers.invalidJSON': 'Não é um JSON válido',
  'app.pages.managers.actions': 'Ações',
  'app.pages.managers.departments': 'Departamentos',
  'app.components.departmentSelector.searchPlaceholder': 'Digite para pesquisar departamentos...',
  'app.pages.managers.mainDepartment': 'Departamento principal',
  'app.pages.managers.add': 'Adicionar',
  'app.pages.managers.role': 'Cargo',
  'app.pages.managers.roles': 'Cargos',
  'app.pages.app.managers.back': 'Voltar',
  'app.pages.app.managers.unkwownStep': 'Passo desconhecido',
  'app.pages.app.managers.saveButton': 'Salvar',
  'app.pages.app.managers.nextButton': 'Avançar',
  'app.pages.app.managers.companies': 'Empresas',
  'app.pages.managers.instances': 'Instâncias',
  'app.pages.managers.password': 'Senha',
  'app.pages.managers.newPassword': 'Nova senha',
  'app.pages.managers.confirmPassword': 'Confirmar senha',
  'app.pages.managers.passwordIsRequired': 'Senha é necessária',
  'app.pages.managers.ConfirmPasswordIsRequired': 'Confirmar Senha é necessária',
  'app.pages.managers.passwordMinLength':
    'A senha é pequena - A senha deve ter pelo menos {number} caracteres',
  'app.pages.managers.passwordInvalidRequisites':
    'A senha deve ter pelo menos uma maiúscula, uma minúscula, um número e um símbolo',
  'app.pages.managers.passwordsNotMatch': 'Senhas não coincidem',
  'app.pages.managers.send': 'Enviar',
  'app.pages.app.managers.delete': 'Excluir',
  'app.pages.app.managers.createAppFromThis': 'Criar aplicativo a partir deste',
  'app.pages.app.managers.applicationSuccessfullyCreated': 'Aplicativo criado com sucesso em',
  'app.pages.app.managers.newFolder': 'Nova pasta',
  'app.pages.app.managers.newFile': 'Novo arquivo',
  'app.pages.app.managers.rename': 'Renomear',
  'app.pages.app.managers.set_permission': 'Definir permissões',
  'app.pages.app.managers.duplicate': 'Duplicar',
  'app.pages.app.managers.openAsReadOnly': 'Abrir como somente leitura',
  'app.pages.app.managers.copyAppToWorkspace': 'Copiar aplicativo para o espaço de trabalho',
  'app.pages.app.managers.copyAppToTeam': 'Copiar aplicativo para equipe',
  'app.pages.app.managers.copyAppToPublic': 'Copiar aplicativo para Public',
  'app.pages.app.managers.downloadApp': 'Baixar aplicativo',
  'app.pages.app.managers.appDownloaded': 'Aplicativo baixado',
  'app.pages.app.managers.copyInterfaceId': 'Copiar id da interface',
  'app.pages.app.managers.idCopied': 'Id copiado',
  'app.pages.app.managers.folderExists': 'A pasta já existe',
  'app.pages.FileManagerPage.downloaded': 'Baixado!',

  // Connections Manager
  'app.pages.app.managers.connectionsManager.connection': 'Conexão',
  'app.pages.app.managers.connectionsManager.connections': 'Conexões',
  'app.pages.app.managers.connectionsManager.addNewConnection': 'Adicionar nova conexão',
  'app.pages.connectionsManager.addConnection': 'Adicionar conexão',
  'app.pages.app.managers.connectionsManager.stablishingConnection': 'Estabelecendo conexão',
  'app.pages.app.managers.connectionsManager.createConnection': 'Criar conexão',
  'app.pages.app.managers.connectionsManager.testConnection': 'Testar conexão',
  'app.pages.managers.connectionsManager.successfullyTestedConnection':
    'Conexão testada com sucesso',
  'app.pages.app.managers.editConnection': 'Editar conexão',
  'app.pages.app.managers.removeConnection': 'Remover conexão',
  'app.pages.app.managers.areYouSureYouWantToRemoveConnection':
    'Tem certeza de que deseja excluir esta conexão?',
  'app.pages.connectionsManager.erpSystems': 'Sistemas ERP',
  'app.pages.connectionsManager.crmSystems': 'Sistemas CRM',
  'app.pages.connectionsManager.relationalDatabases': 'Bancos de dados relacionais',
  'app.pages.connectionsManager.nosqlDatabases': 'Bancos de dados NoSQL',
  'app.pages.connectionsManager.flatFiles': 'Arquivos planos',
  'app.pages.connectionsManager.cloudPlatforms': 'Plataformas em nuvem',
  'app.pages.connectionsManager.dataWarehouses': 'Armazéns de dados',
  'app.pages.connectionsManager.apisAndServices': 'APIs e serviços',
  'app.pages.connectionsManager.supplyChainServices': 'Serviços de cadeia de suprimentos',
  'app.pages.managers.connectionsManager.connectionsNotFound': 'Conexões não encontradas',
  'app.pages.managers.connectionsManager.successfullyCreatedConnection':
    'Conexão criada com sucesso',
  'app.pages.managers.connectionsManager.successfullyUpdatedConnection':
    'Conexão atualizada com sucesso',
  'app.pages.managers.connectionsManager.successfullyRemovedConnection':
    'Conexão removida com sucesso',
  'app.pages.managers.connectionsManager.executed': 'Executado',

  // Translation Manager
  'app.pages.app.managers.translationsManager': 'Traduções',
  'app.pages.app.managers.translationsManager.initialText': 'Texto inicial',
  'app.pages.app.managers.translationsManager.parent': 'Pai',
  'app.pages.app.managers.translationsManager.node': 'Nó',
  'app.pages.app.managers.translationsManager.node.plural': 'Nós',
  'app.pages.app.managers.translationsManager.interface': 'Interface',
  'app.pages.app.managers.translationsManager.interface.plural': 'Interfaces',
  'app.pages.app.managers.translationsManager.component': 'Componente da interface',
  'app.pages.app.managers.translationsManager.component.plural': 'Componentes da interface',
  'app.pages.app.managers.translationsManager.menuItemText': 'Texto do item de menu',
  'app.pages.app.managers.translationsManager.menuItemText.plural': 'Textos do item de menu',
  'app.pages.app.managers.translationsManager.menuItemSubtitle': 'Subtítulo do item de menu',
  'app.pages.app.managers.translationsManager.menuItemSubtitle.plural':
    'Subtítulos do item de menu',
  'app.pages.app.managers.translationsManager.menuActionText': 'Texto da ação do menu',
  'app.pages.app.managers.translationsManager.menuActionText.plural': 'Textos da ação do menu',
  'app.pages.app.managers.translationsManager.menuActionSubtitle': 'Subtítulo da ação do menu',
  'app.pages.app.managers.translationsManager.menuActionSubtitle.plural':
    'Subtítulos da ação do menu',
  'app.pages.app.managers.translationsManager.translationsNotFound': 'Traduções não encontradas',
  'app.pages.app.managers.translationsManager.filterType': 'Filtrar por tipo',
  'app.pages.app.managers.translationsManager.interfaceDocumentationSuccessfullyUpdated':
    'Documentação da interface atualizada com sucesso',
  'app.pages.app.managers.translationsManager.automaticallyCompleteTranslations':
    'Completar automaticamente traduções',
  'app.pages.app.managers.translationsManager.confirmAutomaticTranslations':
    'Confirmar traduções automáticas',
  'app.pages.app.managers.translationsManager.translationsCompleted': 'Traduções completadas',
  'app.pages.app.managers.translationsManager.confirmAutomaticTranslationsContent':
    'Os seguintes itens serão traduzidos automaticamente: ',
  'app.pages.app.managers.translationsManager.translateCurrentRow': 'Traduzir linha atual',
  'app.pages.app.managers.translationsManager.translatingCurrentRow': 'Traduzindo linha atual',
  'app.pages.app.managers.translationsManager.translatingItems': 'Traduzindo {numbers} itens',
  'app.pages.app.managers.translationsManager.translationsSettings': 'Configurações de tradução',
  'app.pages.app.managers.translationsManager.automaticTranslationsError':
    'Ocorreu um erro ao tentar traduzir automaticamente os itens. Por favor, tente novamente mais tarde.',

  // Notifications Manager
  'app.pages.app.notificationsManager.notificationsManager': 'Administrador de notificações',
  'app.pages.app.notificationsManager.addNotification': 'Adicionar notificação',
  'app.pages.app.notificationsManager.editNotification': 'Editar notificação',
  'app.pages.app.notificationsManager.successChangedNotificationStatus':
    'Estado da notificação alterado com sucesso',
  'app.pages.app.notificationsManager.removeNotification': 'Remover notificação',
  'app.pages.app.notificationsManager.removeNotificationConfirmation':
    'Tem certeza de que deseja excluir esta notificação?',
  'app.pages.app.notificationsManager.successRemovedNotification':
    'Notificação removida com sucesso',
  'app.pages.app.notificationsManager.successAddedNotification':
    'Notificação adicionada com sucesso',
  'app.pages.app.notificationsManager.effectiveDate': 'Data efetiva',
  'app.pages.app.notificationsManager.noNotifications': 'Sem notificações',
  'app.pages.app.notificationsManager.notificationTitle': 'Título da notificação',
  'app.pages.app.notificationsManager.notificationDescription': 'Descrição da notificação',
  'app.pages.app.notificationsManager.notification': 'Notificação',

  //companyManager
  'app.pages.app.companyManager.newCompany': 'Criar empresa',
  'app.pages.app.companyManager.editCompany': 'Atualizar empresa',
  'app.pages.app.companyManager.companyPreferences': 'Preferências',
  'app.pages.app.companyManager.scimTokens': 'Tokens SCIM',
  'app.pages.app.companyManager.successChangedStatus': 'Status da empresa alterado com sucesso',
  //companyManager.companyTable
  'app.pages.app.companyManager.companyTable.companyStatusColumn': 'Estado',
  'app.pages.app.companyManager.companyTable.companyTableAriaLabel': 'Tabela de empresas',
  'app.pages.app.companyManager.companyTable.companiesNotFound': 'Empresas não encontradas',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataTitle':
    'Excluir a empresa {companyName}',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataWarning':
    'Isso excluirá a empresa permanentemente e removerá as atribuições de todos os seus usuários. Seus departamentos, teams, roles, tarefas agendadas, configurações de IA, secrets, api keys, histórico de e-mails e processos de workflow serão excluídos permanentemente, e as pastas Public, Teams e Media, junto com todos os workspaces dos usuários, serão apagadas. Esta ação não pode ser desfeita.',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataInputLabel':
    'Digite "{keyword}" para confirmar',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataConfirmButton': 'Excluir empresa',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataDisabledCurrentCompany':
    'Você não pode excluir a empresa em que está conectado atualmente',
  'app.pages.app.companyManager.companyTable.successDeletedCompanyData':
    'Empresa excluída com sucesso',
  'app.pages.app.companyManager.hasSaml': 'Tem configuração SAML',
  'app.pages.app.companyManager.noSamlConfiguration':
    'A empresa {company} não tem o SAML configurado',
  'app.pages.login.samlCompanyAccessDenied':
    'Seu usuário não pertence à empresa {company}. Entre com uma empresa válida ou entre em contato com o administrador.',

  //companyManager.addOrEdit
  'app.pages.companyManager.addOrEdit.companyNameField': 'Nome da empresa',
  'app.pages.companyManager.addOrEdit.companyCodeField': 'Nome da pasta da empresa',
  'app.pages.companyManager.addOrEdit.companyActivationCodeField': 'Código de ativação',
  'app.pages.companyManager.addOrEdit.copiedCompanyActivationCode':
    'Código de ativação - Copiado ✓',
  'app.pages.companyManager.addOrEdit.companyLicenseField': 'Licença',
  'app.pages.companyManager.addOrEdit.companyLogos': 'Logos',
  'app.pages.companyManager.addOrEdit.companyLogo': 'Logo da empresa',
  'app.pages.companyManager.addOrEdit.companyLogoHelp':
    'Exibido dentro do aplicativo e na tela de login.',
  'app.pages.companyManager.addOrEdit.companyEmailLogo': 'Logo para e-mails',
  'app.pages.companyManager.addOrEdit.companyEmailLogoHelp':
    'Exibido nos e-mails enviados pela plataforma. É renderizada com 36 px de altura sobre fundo branco, então uma imagem clara e larga funciona melhor.',
  'app.pages.companyManager.addOrEdit.emailLogoDropzoneFirstRow':
    'Arraste e solte o logo para e-mails ou',
  'app.pages.companyManager.addOrEdit.dropzoneFirstRow': 'Arraste e solte o logotipo da empresa ou',
  'app.pages.companyManager.addOrEdit.dropzoneLinkRow': 'navegue em seus arquivos',
  'app.pages.companyManager.addOrEdit.companyFieldRequiredError': 'Campo obrigatório',
  'app.pages.companyManager.addOrEdit.companyFieldMaxLengthError':
    'Não pode exceder 255 caracteres',
  'app.pages.companyManager.addOrEdit.companyFolderAlreadyExists':
    'A pasta da empresa já existe, escolha um código diferente',
  'app.pages.companyManager.addOrEdit.copyToClipboard': 'Copiar para área de transferência',
  'app.pages.companyManager.addOrEdit.copiedData': 'Dados copiados para área de transferência',
  'app.pages.companyManager.addOrEdit.invalidFileExtension':
    'Arquivo inválido. A imagem é necessária',
  'app.pages.app.companyManager.successAddedCompany': 'Nova empresa criada com sucesso',
  'app.pages.app.companyManager.successEditedCompany': 'Empresa editada com sucesso',
  'app.pages.app.companyManager.removeLicense': 'Remover licença',
  'app.pages.companyManager.addOrEdit.licenseExpirationDateField': 'Data de expiração da licença',
  'app.pages.companyManager.addOrEdit.licensesAssignedField': 'Licenças atribuídas',
  'app.pages.companyManager.addOrEdit.licensesAvailableField': 'Licenças disponíveis',
  'app.pages.companyManager.addOrEdit.licensesOccupiedField': 'Licenças ocupadas',
  'app.pages.companyManager.addOrEdit.licenseUsageTitle': 'Assentos por cargo',
  'app.pages.companyManager.addOrEdit.licenseUsageExceeded': 'Excedido',
  'app.pages.companyManager.addOrEdit.licenseUsageNoRole': 'Sem cargo com este nome',
  'app.pages.companyManager.addOrEdit.licenseWarningsTitle':
    'Esta licença tem avisos. Ela pode ser salva mesmo assim.',
  'app.pages.license.savedWithWarnings': 'A licença foi salva com avisos',
  'app.pages.companyManager.addOrEdit.licenseExpirationRecipientsField':
    'Notificar o vencimento da licença para',
  'app.pages.companyManager.addOrEdit.invalidLicenseExpirationRecipients':
    'Um ou mais destinatários do aviso de vencimento não são mais usuários ativos da empresa. A lista foi atualizada: revise-a e salve novamente.',
  'app.pages.companyManager.addOrEdit.licenseExpirationRecipientsHelp':
    'Se nenhum for escolhido, o aviso é enviado aos usuários com os papéis Super Administrator, Administrator e App Administrator.',

  //Department Manager
  'app.pages.DepartmentPage.addDepartment': 'Criar departamento',
  'app.pages.DepartmentPage.editDepartment': 'Editar departamento',
  'app.pages.DepartmentPage.engineDefinitions': 'Definições do motor',
  'app.pages.DepartmentPage.loginAction': 'Ações ao fazer login',
  'app.pages.DepartmentPage.deniedItems': 'Acessos negados',
  'app.pages.DepartmentPage.allowedItems': 'Acessos permitidos',
  'app.pages.DepartmentPage.name.maxLengthError': 'O tamanho máximo do nome é {number} caracteres',
  'app.pages.DepartmentPage.department.notFound': 'Departamento não encontrado',
  'app.pages.DepartmentPage.department.created': 'Departamento criado',
  'app.pages.DepartmentPage.department.updated': 'Departamento atualizado',
  'app.pages.DepartmentPage.departmentManagerTable': 'Tabela de administrador de departamentos',
  'app.pages.DepartmentPage.addLoginAction': 'Adicionar ação de login',
  'app.pages.DepartmentPage.downloadReport': 'Baixar relatório de departamentos',
  'app.pages.DepartmentPage.reportDownloaded': 'Relatório de departamentos baixado',
  'app.pages.DepartmentPage.department': 'Departamento',

  //Role Manager
  'app.pages.RolePage.addRole': 'Criar cargo',
  'app.pages.RolePage.editRole': 'Editar cargo',
  'app.pages.RolePage.role.notFound': 'Cargo não encontrado',
  'app.pages.RolePage.role.permission.template': 'Modelo de permissões',
  'app.pages.RolePage.role.permission.administrator': 'Administrador',
  'app.pages.RolePage.role.permission.appAdministrator': 'Administrador de app',
  'app.pages.RolePage.role.permission.creatorWithPublicAccess': 'Criador com Acesso ao Public',
  'app.pages.RolePage.role.permission.creator': 'Criador',
  'app.pages.RolePage.role.permission.explorer': 'Navegador',
  'app.pages.RolePage.role.permission.viewer': 'Visualizador',
  'app.pages.RolePage.role.permission.loginOnlyUser': 'Usuário Apenas para Login',
  'app.pages.RolePage.role.permission.override': 'Permissões substituídas',
  'app.pages.RolePage.role.created': 'Cargo criado',
  'app.pages.RolePage.role.updated': 'Cargo atualizado',
  'app.pages.RolePage.name.maxLengthError': 'O tamanho máximo do nome é {number} caracteres',
  'app.pages.RolePage.name.exist': 'O nome de cargo existe',
  'app.pages.RolePage.roleManagerTable': 'Tabela de administrador de cargo',

  //notFoundPage
  'app.components.notFoundPage.message': 'a página que você está procurando não existe',
  'app.components.notFoundPage.orGoTo': 'ou ir para',
  'app.components.notFoundPage.returnToThe': 'Retornar para a',
  'app.components.notFoundPage.previousPage': 'página anterior',
  'app.components.notFoundPage.homePage': 'página inicial',

  //Company Preferences
  'app.pages.app.companyManager.companyPreferences.notFound': 'Preferências não encontradas',
  'app.pages.app.companyManager.companyPreferences.title': 'Preferências da empresa ',
  'app.pages.app.companyManager.companyPreferences.copyDefaultValue': 'Copiar valor padrão',
  'app.pages.app.companyManager.companyPreferences.defaultValueCopied': 'Valor padrão copiado',
  'app.pages.app.companyManager.companyPreferences.preferenceUpdated': 'Preferência atualizada',
  'app.pages.app.companyManager.companyPreferences.preferenceCreated': 'Preferência criada',
  'app.pages.app.companyManager.companyPreferences.preferenceDelete': 'Preferência retirada',
  'app.pages.app.companyManager.companyPreferences.saveCustomValue': 'Salvar valor personalizado',
  'app.pages.app.companyManager.companyPreferences.removeCustomValue':
    'Retirar valor personalizado',
  'app.pages.app.companyManager.companyPreferences.openJsonEditor': 'Abrir editor JSON',
  'app.pages.app.companyManager.companyPreferences.jsonEditorTitle': 'Editar valor JSON',
  'app.pages.app.companyManager.companyPreferences.editDefaultValue': 'Editar valor padrão',
  'app.pages.app.companyManager.companyPreferences.invalidValue':
    'Não é um valor válido. Valores disponíveis: {values}',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingUploadTooltip':
    'Enviar {fileName}',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingUploaded': 'Arquivo enviado',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingUploadError':
    'Erro ao enviar o arquivo',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingWrongFileName':
    "Era esperado um arquivo chamado '{expectedName}'",
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingManageFiles':
    'Gerenciar arquivos enviados',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingStatusUploaded': 'Enviado',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingStatusError': 'Falha no envio',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingStatusPending':
    'Ainda não enviado',

  //Permissions by role
  'app.pages.app.permissionsByRole': 'Permissões por cargo',
  'app.pages.app.permissionsByRole.permissionActivated': 'Permissão ativada',
  'app.pages.app.permissionsByRole.permissionDeactivated': 'Permissão desativada',
  'app.pages.app.permissionsByRole.allPermissionsActivated':
    'Todas as permissões de {name} foram ativadas',
  'app.pages.app.permissionsByRole.permission': 'Permissão',
  'app.pages.app.permissionsByRole.permissionsUpdated': 'Permissões atualizadas',

  //team manager
  'app.pages.app.teamManager.team': 'Administrador de equipes',
  'app.pages.app.teamManager.addTeam': 'Criar equipe',
  'app.pages.app.teamManager.editTeam': 'Editar equipe',
  'app.pages.app.teamManager.accessLevel': 'Nível de acessos',
  'app.pages.app.teamManager.teamDeleted': 'Equipe {name} excluída',
  'app.pages.app.teamManager.deleteTeam': 'Excluir equipe',
  'app.pages.app.teamManager.areYouSureToDeleteTeam':
    'Tem certeza de que deseja excluir a equipe {name}?',
  'app.pages.app.teamManager.departmentsAsociated':
    'Está associado com os seguintes departamentos:',
  'app.pages.app.teamManager.readOnly': 'Somente leitura',
  'app.pages.app.teamManager.readAndWrite': 'Leitura e escrita',
  'app.pages.app.teamManager.updateTeam': 'Atualizar equipe',
  'app.pages.app.teamManager.createTeam': 'Criar equipe',
  'app.pages.app.teamManager.teamDepartments': 'Não há departamentos',
  'app.pages.app.teamManager.downloadReport': 'Baixar relatório de equipes',
  'app.pages.app.teamManager.reportDownloaded': 'Relatório de equipes baixado',
  'app.pages.app.teamManager.teamUpdated': 'Equipe atualizada',
  'app.pages.app.teamManager.teamCreated': 'Equipe criada',
  'app.pages.teamManager.name.maxLengthError': 'O tamanho máximo do nome é {number} caracteres',
  'app.pages.teamManager.teamsNotFound': 'Equipes não encontradas',
  //User Manager
  'app.pages.UserPage.userManager': 'Administrador de usuários',
  'app.pages.UserPage.addUser': 'Criar usuário',
  'app.pages.UserPage.editUser': 'Editar usuário',
  'app.pages.UserPage.email': 'Email',
  'app.pages.UserPage.login': 'Nome de usuário',
  'app.pages.UserPage.usersNotFound': 'Usuário não encontrado',
  'app.pages.UserPage.changePassword': 'Mudar a senha',
  'app.pages.UserPage.manageCompanies': 'Gerenciar empresas',
  'app.pages.UserPage.passwordChanged': 'Senha alterada',
  'app.pages.UserPage.downloadReport': 'Baixar Relatório de usuários',
  'app.pages.UserPage.reportsDownloaded': 'Relatório de usuários baixado',
  'app.pages.UserPage.firstName': 'Nome',
  'app.pages.UserPage.firstNameIsRequired': 'Nome é necessário',
  'app.pages.UserPage.firstNameMaxLength': 'O tamanho máximo do nome é {number} caracteres',
  'app.pages.UserPage.firstNamePlaceholder': 'Insira seu nome',
  'app.pages.UserPage.lastNamePlaceholder': 'Insira seu sobrenome',
  'app.pages.UserPage.lastNameIsRequired': 'Sobrenome é necessário',
  'app.pages.UserPage.lastNameMaxLength': 'O tamanho máximo do sobrenome é {number} caracteres',
  'app.pages.UserPage.emailPlaceholder': 'Insira seu email',
  'app.pages.UserPage.emailIsInvalid': 'Email errado',
  'app.pages.UserPage.emailContainingÑ': 'E-mail não pode conter "Ñ"',
  'app.pages.UserPage.emailIsRequired': 'Email é necessário',
  'app.pages.UserPage.emailAlreadyExist': 'Email já existe',
  'app.pages.UserPage.lastName': 'Sobrenome',
  'app.pages.UserPage.userNameIsRequired': 'Nome de usuário é necessário',
  'app.pages.UserPage.userNamePlaceholder': 'Insira seu nome de usuário',
  'app.pages.UserPage.passwordPlaceholder': 'Insira sua senha',
  'app.pages.UserPage.usernameAlreadyExist': 'Nome de usuário já existe',
  'app.pages.UserPage.usernameInvalid':
    'Nome de usuário pode ter "@", "+", "-", "_" ou "." caracteres. Espaços em branco não permitidos',
  'app.pages.UserPage.steps.userInformation': 'Informações de usuário',
  'app.pages.UserPage.steps.roleAndCompanySelection': 'Seleção de cargo e empresas',
  'app.pages.UserPage.steps.roleAndCompanySelection.departmentPlaceholder':
    'Escolha um departamento',
  'app.pages.UserPage.steps.roleAndCompanySelection.rolePlaceholder': 'Escolha um cargo',
  'app.pages.UserPage.steps.roleAndCompanySelection.addCompany': 'Adicionar empresa',
  'app.pages.UserPage.steps.roleAndCompanySelection.removeCompany': 'Remover empresa',
  'app.pages.UserPage.steps.roleAndCompanySelection.noCompaniesAdded':
    'Empresas não encontradas, escolha uma',
  'app.pages.UserPage.steps.roleAndCompanySelection.roleWarning':
    'Este cargo se aplica a todas as empresas, exceto àquelas que têm um cargo específico atribuído',
  'app.pages.UserPage.steps.roleAndCompanySelection.noPermissionToRemove':
    'Você não tem permissão para remover atribuições de empresas. Apenas Super Administradores podem modificar atribuições usuário-empresa.',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainWarningTitle':
    'Aviso de Validação de Domínio de Email',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainWarningMessage':
    'Não existem usuários com o domínio de email "@{domain}" na empresa "{companyName}". Isso pode indicar uma atribuição incorreta de empresa.',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainConfirmPlaceholder':
    'Digite o email do usuário para confirmar',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainConfirmLabel':
    'Confirme digitando o endereço de email completo',
  'app.pages.UserPage.toggleActiveUser.errorNoRoles':
    '{user} não tem um cargo para a empresa {company}',
  'app.pages.UserPage.toggleActiveUser.activated': 'Usuário ativado',
  'app.pages.UserPage.toggleActiveUser.desactivated': 'Usuário desativado',
  'app.pages.UserPage.userUnlocked': 'Usuário desbloqueado',
  'app.pages.UserPage.userCreated': 'Usuário criado',
  'app.pages.UserPage.userUpdated': 'Usuário atualizado',
  'app.pages.UserPage.errorCompanyWithNoRoles': 'Há uma empresa sem cargos',
  'app.pages.UserPage.errorCompanyWithNoDepartments': 'Há uma empresa sem departamentos',
  'app.pages.UserPage.deleteUser': 'Excluir usuário',
  'app.pages.UserPage.areYouSureToDeleteUser':
    'Tem certeza de que deseja excluir o usuário {name}?',
  'app.pages.UserPage.userDeleted': 'Usuário excluído',
  'app.pages.UserPage.changeStatus': 'Alterar estado',
  'app.pages.UserPage.unlockUser': 'Desbloquear usuário',
  'app.pages.UserPage.ChangePasswordLogin': 'Modificar senha ao iniciar sessão',
  'app.pages.UserPage.enableMfa': 'Habilitar autenticação de vários fatores',
  'app.pages.UserPage.setNewQrCode': 'Configurar um novo código QR',
  'app.pages.UserPage.validateSetNewQRCode':
    'Será configurado um novo código QR para o usuário {user}. Deseja continuar?',
  'app.pages.UserPage.qrCodeSuccesfullySeted': 'Novo código QR configurado',
  'app.pages.UserPage.lastLogin': 'Último acesso',
  'app.pages.UserPage.creationDate': 'Data de criação',
  'app.pages.UserPage.clearFilters': 'Limpar filtros',
  'app.pages.UserPage.activeUsersOnly': 'Somente usuários ativos',
  'app.pages.UserPage.addMultipleUsers': 'Adicionar múltiplos usuários',
  'app.pages.UserPage.dragDropCsvMultipleUsers':
    'Arraste e solte um arquivo CSV com informações de usuários',
  'app.pages.UserPage.roleAndDepartmentAppliedToAll':
    'O cargo e departamento selecionados serão aplicados a todos os usuários',
  'app.pages.UserPage.bulkCreationSummary': 'Resumo da criação em massa',
  'app.pages.UserPage.bulkUsersTotal': 'Total de usuários',
  'app.pages.UserPage.bulkUsersCreated': 'Criados',
  'app.pages.UserPage.bulkUsersAssignedExisting': 'Usuários existentes atribuídos à empresa',
  'app.pages.UserPage.bulkUsersAlreadyInCompany': 'Usuários que já pertenciam à empresa',
  'app.pages.UserPage.bulkUsersErrorsTitle': 'Erros',
  'app.pages.UserPage.bulkUsersStatusUnavailable':
    'Não foi possível obter o progresso da criação em massa. Verifique a lista de usuários para ver o resultado.',
  'app.pages.UserPage.downloadSampleCsv': 'Baixar CSV de exemplo',

  //Code Diagram Nodes
  'app.pages.Code.Diagram.Nodes.variable': 'Variável',
  'app.pages.Code.Diagram.Nodes.datareading': 'Leitura de dados',
  'app.pages.Code.Diagram.Nodes.button': 'Botão',
  'app.pages.Code.Diagram.Nodes.index': 'Índice',
  'app.pages.Code.Diagram.Nodes.module': 'Módulo',
  'app.pages.Code.Diagram.Nodes.inputscalar': 'Escalar',
  'app.pages.Code.Diagram.Nodes.inputselector': 'Seletor',
  'app.pages.Code.Diagram.Nodes.inputdateselector': 'Seletor de datas',
  'app.pages.Code.Diagram.Nodes.inputchoice': 'Opção',
  'app.pages.Code.Diagram.Nodes.inputdataframe': 'Tabela de dados',
  'app.pages.Code.Diagram.Nodes.inputdataarray': 'Matriz de dados',
  'app.pages.Code.Diagram.Nodes.inputcube': 'Cubo',
  'app.pages.Code.Diagram.Nodes.text': 'Texto',
  'app.pages.Code.Diagram.Nodes.generic': 'Genérico',
  'app.pages.Code.Diagram.Nodes.form': 'Formulário',
  'app.pages.Code.Diagram.Nodes.inputInitialName': 'Nome do nó',
  'app.pages.Code.Diagram.Nodes.inputData': 'Entrada de dados',
  'app.pages.Code.Diagram.Nodes.chooseInputType': 'Escolha o tipo de entrada de dados',
  'app.pages.Code.Diagram.Nodes.report': 'Relatório',
  'app.pages.Code.Diagram.Nodes.outputnode': 'Saída',
  'app.pages.Code.Diagram.Nodes.reportwizard': 'Wizard de relatório',
  'app.pages.Code.Diagram.Nodes.beingUsedInInterfaces': 'O nó está sendo utilizado em interfaces',
  'app.pages.Code.Diagram.Nodes.nodeHasNoInterfaces': 'O nó não tem interfaces',
  'app.pages.Code.Diagram.Nodes.beingUsedInModulesAndInterfaces':
    'Tem saídas fora do seu módulo e está sendo utilizado em interfaces',
  'app.pages.Code.Diagram.Nodes.someNodesAreBeingUsedInInterfaces':
    'Alguns nós estão sendo utilizados em interfaces',
  'app.pages.Code.Diagram.Nodes.nextStep': 'Próximo passo',
  'app.pages.Code.Diagram.Nodes.outsideModule': 'Este nó está localizado fora do módulo atual',

  //Code Diagram Menu
  'app.pages.Code.Diagram.Menu.hideMenu': 'Ocultar menu',
  'app.pages.Code.Diagram.Menu.wizards': 'Assistentes',
  'app.pages.Code.Diagram.Menu.importModule': 'Importação do módulo',
  'app.pages.Code.Diagram.Menu.importModule.steps.selectModule': 'Seleção de módulo',
  'app.pages.Code.Diagram.Menu.importModule.steps.importType': 'Tipo de importação',
  'app.pages.Code.Diagram.Menu.importModule.steps.importType.switch': 'Mudança',
  'app.pages.Code.Diagram.Menu.importModule.steps.importType.merge': 'Mesclar',
  'app.pages.Code.Diagram.Menu.importModule.sucessful': 'Módulo importado com sucesso',
  'app.pages.Code.Diagram.Menu.importModule.hasOutputsOutsideItsModule':
    'Tem saídas fora do seu módulo',
  //Code Diagram Delete dialog
  'app.pages.Code.Diagram.DeleteDialog.deleteNodes': 'Excluir nós?',
  'app.pages.Code.Diagram.DeleteDialog.confirmationtext':
    'Tem certeza de que deseja excluir {number} nós selecionados?',
  //Node Properties Dialog
  'app.pages.Code.Diagram.Nodes.properties.title': 'Título do nó',
  'app.pages.Code.Diagram.Nodes.properties.id': 'Identificador do nó',
  'app.pages.Code.Diagram.Nodes.properties.nodeClass': 'Tipo de nó',
  'app.pages.Code.Diagram.Nodes.properties.units': 'Unidades',
  'app.pages.Code.Diagram.Nodes.properties.evaluateOnStart': 'Avaliar no início',
  'app.pages.Code.Diagram.Nodes.properties.releaseMemory': 'Liberar memória',
  'app.pages.Code.Diagram.Nodes.properties.prefixIdentifier': 'Prefixo do módulo',
  'app.pages.Code.Diagram.Nodes.properties.setIdFromTitle': 'Usar título como identificador',
  'app.pages.Code.Diagram.Nodes.properties.normalizeIdentifier':
    'Normalizar identificador (minúsculas, remover caracteres inválidos, resolver conflitos)',
  'app.pages.Code.Diagram.Nodes.properties.idHelperText':
    'O identificador deve começar com uma letra e pode conter letras minúsculas, números e underlines',
  'app.pages.Code.Diagram.Nodes.properties.idRequired':
    'O identificador de nó não pode estar vazio',
  'app.pages.Code.Diagram.Nodes.properties.prefixIdHelperText':
    'O prefixo do módulo deve começar com uma letra e pode conter letras minúsculas, números e underlines',
  'app.pages.Code.Diagram.Nodes.properties.hierarchyMap': 'Mapa de hierarquia',
  'app.pages.Code.Diagram.Nodes.inputs': 'Entradas',
  'app.pages.Code.Diagram.Nodes.outputs': 'Saídas',
  'app.pages.Code.Diagram.Nodes.general': 'Geral',
  'app.pages.Code.Diagram.Nodes.metadata': 'Metadados',
  'app.pages.Code.Diagram.Nodes.translations': 'Traduções',
  'app.pages.Code.Diagram.Nodes.addNewTranslation': 'Adicionar nova tradução',
  'app.pages.Code.Diagram.Nodes.noLanguageConfiguredMessage':
    'O aplicativo deve ter um idioma padrão configurado para adicionar traduções',
  'app.pages.Code.Diagram.Nodes.creationDate': 'Data de criação',
  'app.pages.Code.Diagram.Nodes.lastModification': 'Última modificação',
  'app.pages.Code.Diagram.Nodes.lastModificationUser': 'Usuário',
  'app.pages.Code.Diagram.Nodes.lastUserThatModified': 'Último usuário que modificou',
  'app.pages.Code.Diagram.Nodes.docs': 'Documentação',
  'app.pages.Code.Diagram.Nodes.noInputs': 'Não há entradas',
  'app.pages.Code.Diagram.Nodes.noOutputs': 'Não há saídas',
  'app.pages.Code.Diagram.Nodes.noDocs': 'Não há documentação para esta seção',
  'app.pages.Code.Diagram.Nodes.editDocs': 'Editar docs',
  'app.pages.Code.Diagram.Nodes.docsEdited': 'Documentação editada',
  'app.pages.Code.Diagram.Nodes.selectNodeToShowDocs': 'Escolha um nó para mostrar a documentação',
  'app.pages.Code.itemHeader.saveDefaultView': 'Salvar visualização padrão',
  //Context Menu
  'app.pages.Code.Diagram.ContextMenu.resize': 'Redimensionar nós como {string}',
  'app.pages.Code.Diagram.ContextMenu.alignment': 'Alinhar nós para o {string}',
  'app.pages.Code.Diagram.ContextMenu.showInputs': 'Mostrar entradas',
  'app.pages.Code.Diagram.ContextMenu.showOutputs': 'Mostrar saídas',
  'app.pages.Code.Diagram.ContextMenu.moveNodeToBackground': 'Mover nó para segundo plano',
  'app.pages.Code.Diagram.ContextMenu.nodeMovedToBackground': 'Nó movido para segundo plano',
  'app.pages.Code.Diagram.ContextMenu.moveNodeToFront': 'Mover nó para frente',
  'app.pages.Code.Diagram.ContextMenu.nodeMovedToFront': 'Nó movido para frente',
  'app.pages.Code.Diagram.ContextMenu.sizes.width': 'Mesma largura',
  'app.pages.Code.Diagram.ContextMenu.sizes.height': 'Mesma altura',
  'app.pages.Code.Diagram.ContextMenu.sizes.size': 'Mesmo tamanho',
  'app.pages.Code.Diagram.ContextMenu.alignment.top': 'Bordas superiores',
  'app.pages.Code.Diagram.ContextMenu.alignment.centerH': 'Centralizar horizontalmente',
  'app.pages.Code.Diagram.ContextMenu.alignment.centerV': 'Centralizar verticalmente',
  'app.pages.Code.Diagram.ContextMenu.alignment.bottom': 'Bordas inferiores',
  'app.pages.Code.Diagram.ContextMenu.alignment.right': 'Bordas direitas',
  'app.pages.Code.Diagram.ContextMenu.alignment.left': 'Bordas esquerdas',
  'app.pages.Code.Diagram.ContextMenu.exportModule': 'Exportar módulo',
  'app.pages.Code.Diagram.ContextMenu.moduleExported': 'Módulo exportado',
  'app.pages.Code.Diagram.ContextMenu.setRestriction': 'Definir restrição',
  'app.pages.Code.Diagram.ContextMenu.pinNode': 'Fixar nó',
  'app.pages.Code.Diagram.ContextMenu.unpinNode': 'Desafixar nó',
  'app.pages.Code.pinnedNodes.allGroups': 'Todos',
  'app.pages.Code.pinnedNodes.createGroup': 'Novo grupo',
  'app.pages.Code.pinnedNodes.createGroupTooltip': 'Criar um novo grupo de nós fixados',
  'app.pages.Code.pinnedNodes.newGroup': 'Novo grupo',
  'app.pages.Code.pinnedNodes.groupColorTooltip': 'Escolha a cor do grupo',
  'app.pages.Code.pinnedNodes.groupName': 'Nome do grupo',
  'app.pages.Code.pinnedNodes.groupNameInUse': 'Já existe um grupo com esse nome',
  'app.pages.Code.pinnedNodes.renameGroup': 'Renomear grupo',
  'app.pages.Code.pinnedNodes.deleteGroup': 'Excluir grupo',
  'app.pages.Code.pinnedNodes.deleteGroupConfirmation':
    'O grupo "{name}" será excluído. Seus nós continuam fixados, sem grupo.',
  'app.pages.Code.pinnedNodes.emptyGroup':
    'Fixe nós com este grupo selecionado para adicioná-los aqui',
  'app.pages.Code.Diagram.ContextMenu.apiEndpoint': 'Obter API URL',
  'app.pages.Code.Diagram.apiEndpoint.endpointFor': 'API URL para: ',
  'app.pages.Code.Diagram.apiEndpoint.shareInstance': 'Compartilhar instância',
  'app.pages.Code.Diagram.apiEndpoint.apiURLcopied': 'API URL copiado ',
  'app.pages.Code.Diagram.apiEndpoint.message':
    'e envie os parâmetros da função como um objeto JSON no corpo da solicitação.',
  'app.pages.Code.Diagram.ContextMenu.openWizard': 'Abrir o assistente',
  'app.pages.Code.Diagram.ContextMenu.compareNodes': 'Comparar nós',
  'app.pages.Code.Diagram.ContextMenu.handlingDataWidget': 'Manipulação de dados',
  'app.pages.Code.Diagram.Wizards.dropDuplicates': 'Remover duplicados',
  'app.pages.Code.Diagram.ContextMenu.dataSystemNodeNoData': 'Nó de sistema de dados sem dados',

  //Code Diagram Wizards
  'app.pages.Code.Diagram.Wizards.openWizard': 'Abrir o assistente',
  'app.pages.Code.Diagram.Wizards.selectColumns': 'Selecionar colunas',
  'app.pages.Code.Diagram.Wizards.editInExcel': 'Editar no Excel',
  'app.pages.Code.Diagram.Wizards.selectRows': 'Selecionar linhas',
  'app.pages.Code.Diagram.Wizards.name': 'Nome da coluna',
  'app.pages.Code.Diagram.Wizards.isIndex': 'É índice',
  'app.pages.Code.Diagram.Wizards.dtype': 'Tipo de dados',
  'app.pages.Code.Diagram.Wizards.editTableDefinition': 'Editar definição da Tabela',
  'app.pages.Code.Diagram.Wizards.removeColumn': 'Excluir coluna',
  'app.pages.Code.Diagram.Wizards.addNewColumn': 'Inserir nova coluna',
  'app.pages.Code.Diagram.Wizards.column': 'Coluna',
  'app.pages.Code.Diagram.Wizards.editCubeDefinition': 'Editar definição do Cubo',
  'app.pages.Code.Diagram.Wizards.deleteCubeData': 'Excluir dados do Cubo',
  'app.pages.Code.Diagram.Wizards.deleteCubeDataMessage':
    'Tem certeza de que deseja excluir os dados do Cubo do banco de dados?',
  'app.pages.Code.Diagram.Wizards.deleteCubeDataConfirm':
    'Os dados do Cubo foram excluídos com sucesso do banco de dados',
  'app.pages.Code.Diagram.Wizards.availableIndexes': 'Índices disponíveis',
  'app.pages.Code.Diagram.Wizards.selectedIndexes': 'Índices selecionados',
  'app.pages.Code.Diagram.Wizards.filter': 'Filtrar',
  'app.pages.Code.Diagram.Wizards.defaultValue': 'Valor padrão',
  'app.pages.Code.Diagram.Wizards.defaultValueType': 'Tipo de valor padrão',
  'app.pages.Code.Diagram.Wizards.scalar': 'Escalar',
  'app.pages.Code.Diagram.Wizards.model_node': 'Nó do modelo',
  'app.pages.Code.Diagram.Wizards.app_node': 'Nó do app',
  'app.pages.Code.Diagram.Wizards.node_id': 'O identificador do nó já existe, selecione outro',
  'app.pages.Code.Diagram.Wizards.calculatedField': 'Campo calculado',
  'app.pages.Code.Diagram.Wizards.setIndex': 'Definir índice',
  'app.pages.Code.Diagram.Wizards.groupAgregate': 'Agrupar/agregar',
  'app.pages.Code.Diagram.Wizards.createindex': 'Criar Índice',
  'app.pages.Code.Diagram.Wizards.createcube': 'Criar Cubo',
  'app.pages.Code.Diagram.Wizards.form': 'Formulário',
  'app.pages.Code.Diagram.Wizards.report': 'Relatório',
  'app.pages.Code.Diagram.Wizards.editFormDefinition': 'Editar definição do Formulário',
  'app.pages.Code.Diagram.Wizards.deleteFormData': 'Excluir dados do Formulário',
  'app.pages.Code.Diagram.Wizards.deleteFormDataMessage':
    'Tem certeza de que deseja excluir os dados do Formulário do banco de dados?',
  'app.pages.Code.Diagram.Wizards.deleteFormDataConfirm':
    'Os dados do Formulário foram excluídos com sucesso do banco de dados',
  'app.pages.Code.Diagram.Wizards.formFieldError': 'Id ou título do campo não pode ser "id"',
  'app.pages.Code.Diagram.Wizards.formFieldNoWhiteSpacesError':
    'O campo ID não pode conter espaços em branco.',
  'app.pages.Code.Diagram.Wizards.fieldId': 'ID do campo',
  'app.pages.Code.Diagram.Wizards.fieldTitle': 'Título do campo',
  'app.pages.Code.Diagram.Wizards.columnType': 'Tipo de coluna',
  'app.pages.Code.Diagram.Wizards.hidden': 'Escondido',
  'app.pages.Code.Diagram.Wizards.readOnly': 'Somente leitura',
  'app.pages.Code.Diagram.Wizards.formula': 'Fórmula',
  'app.pages.Code.Diagram.Wizards.values': 'Valores',
  'app.pages.Code.Diagram.Wizards.filterRowsByDomain': 'Filtrar linhas por domínio',
  'app.pages.Code.Diagram.Wizards.strict': 'Estrito',
  'app.pages.Code.Diagram.Wizards.relatedMap': 'Mapa relacionado',
  'app.pages.Code.Diagram.Wizards.relatedMapColumnValues': 'Coluna com valores',
  'app.pages.Code.Diagram.Wizards.relatedColumns': 'Colunas relacionadas',
  'app.pages.Code.Diagram.Wizards.fromNode': 'A partir do nó',
  'app.pages.Code.Diagram.Wizards.fromNodeDetails':
    'O resultado do nó deve ser uma função que recebe um DataFrame de Pandas como parâmetro e retorna um DataFrame de Pandas',
  'app.pages.Code.Diagram.Wizards.advancedOptions': 'Opções avançadas',
  'app.pages.Code.Diagram.Wizards.appNode': 'Nó no app',
  'app.pages.Code.Diagram.Wizards.typeNewValues':
    'Digite novos valores. Pressione Enter para confirmar',
  'app.pages.Code.Diagram.Wizards.columnType.input': 'Input',
  'app.pages.Code.Diagram.Wizards.columnType.checkbox': 'Checkbox',
  'app.pages.Code.Diagram.Wizards.columnType.selector': 'Seletor',
  'app.pages.Code.Diagram.Wizards.columnType.related_selector': 'Seletor relacionado',
  'app.pages.Code.Diagram.Wizards.columnType.calc': 'Cálculo',
  'app.pages.Code.Diagram.Wizards.columnType.dataframe_column': 'Coluna de DataFrame',
  'app.pages.Code.Diagram.Wizards.columnType.system': 'Sistema',
  'app.pages.Code.Diagram.Wizards.tableName': 'Nome da tabela',
  'app.pages.Code.Diagram.Wizards.formSettings': 'Opções do formulário',
  'app.pages.Code.Diagram.Wizards.editFormSettings': 'Editar opções do formulário',
  'app.pages.Code.Diagram.Wizards.addNewField': 'Inserir novo campo',
  'app.pages.Code.Diagram.Wizards.addNewItem': 'Inserir novo elemento',
  'app.pages.Code.Diagram.Wizards.databaseEngine': 'Motor de banco de dados',
  'app.pages.Code.Diagram.Wizards.databaseConnection': 'Conexão com banco de dados',
  'app.pages.Code.Diagram.Wizards.databasePath': 'Caminho do banco de dados',
  'app.pages.Code.Diagram.Wizards.host': 'Host',
  'app.pages.Code.Diagram.Wizards.database': 'Banco de dados',
  'app.pages.Code.Diagram.Wizards.databaseCustomURL': 'URL personalizada',
  'app.pages.Code.Diagram.Wizards.initialEmptyRows': 'Linhas vazias iniciais',
  'app.pages.Code.Diagram.Wizards.allowAddRows': 'Permitir inserir linhas',
  'app.pages.Code.Diagram.Wizards.allowRemoveRows': 'Permitir excluir linhas',
  'app.pages.Code.Diagram.Wizards.allowAddNewColumns': 'Permitir inserir novas colunas',
  'app.pages.Code.Diagram.Wizards.allowRowReordering': 'Permitir reordenar linhas',
  'app.pages.Code.Diagram.Wizards.validateSelectorsOnInitialRender':
    'Validar valores dos seletores ao carregar o formulário',
  'app.pages.Code.Diagram.Wizards.trackHistory': 'Registrar histórico de dados',
  'app.pages.Code.Diagram.Wizards.fixedColumns': 'Colunas fixas',
  'app.pages.Code.Diagram.Wizards.formRecreateTableMessage':
    'Todos os dados do formulário serão apagados e serão recriados do zero',
  'app.pages.Code.Diagram.Wizards.formSubmitConfirmation':
    'A definição do formulário será substituída.',
  'app.pages.Code.Diagram.Wizards.fromDataFrame': 'A partir de DataFrame',
  'app.pages.Code.Diagram.Wizards.sourceDataFrameNode': 'Nó com DataFrame original',
  'app.pages.Code.Diagram.Wizards.sourceDataFrameIdColumn': 'Coluna ID do DataFrame original',
  'app.pages.Code.Diagram.Wizards.removeOldRows': 'Excluir linhas antigas',
  'app.pages.Code.Diagram.Wizards.newFieldName': 'Nome do novo campo',
  'app.pages.Code.Diagram.Wizards.newItemName': 'Nome do novo item',
  'app.pages.Code.Diagram.Wizards.expression': 'Expressão',
  'app.pages.Code.Diagram.Wizards.fieldList': 'Campos disponíveis',
  'app.pages.Code.Diagram.Wizards.agregate': 'Funções de agregação',
  'app.pages.Code.Diagram.Wizards.groupBy': 'Agrupar por',
  'app.pages.Code.Diagram.Wizards.filterDataFrame': 'Filtrar DataFrame',
  'app.pages.Code.Diagram.Wizards.condition': 'Condição',
  'app.pages.Code.Diagram.Wizards.addNewFilter': 'Adicionar novo filtro',
  'app.pages.Code.Diagram.Wizards.valueIsRequired': 'Valor é obrigatório',
  'app.pages.Code.Diagram.Wizards.mustHaveAtLeastValues': 'Deve ter pelo menos {number} valor/es',
  'app.pages.Code.Diagram.Wizards.filterDataArray': 'Filtrar DataArray',
  'app.pages.Code.Diagram.Wizards.dimension': 'Dimensão',
  'app.pages.Code.Diagram.Wizards.editIndex': 'Editar índice',
  'app.pages.Code.Diagram.Wizards.itemList': 'Lista de itens',
  'app.pages.Code.Diagram.Wizards.count': 'Contagem',
  'app.pages.Code.Diagram.Wizards.insertAbove': 'Inserir linha acima',
  'app.pages.Code.Diagram.Wizards.insertBelow': 'Inserir linha abaixo',
  'app.pages.Code.Diagram.Wizards.removeRow': 'Remover linha',
  'app.pages.Code.Diagram.Wizards.index': 'Índice',
  'app.pages.Code.Diagram.Wizards.renameIndex': 'Renomear índice',
  'app.pages.Code.Diagram.Wizards.files': 'Arquivos',
  'app.pages.Code.Diagram.Wizards.databases': 'Bancos de dados',
  'app.pages.Code.Diagram.Wizards.online': 'Online',
  'app.pages.Code.Diagram.Wizards.dataReadingNode': 'Nó de leitura de dados',
  'app.pages.Code.Diagram.Wizards.readCsvFile': 'Ler arquivo CSV',
  'app.pages.Code.Diagram.Wizards.readExcelFile': 'Ler arquivo Excel',
  'app.pages.Code.Diagram.Wizards.dataPreview': 'Pré-visualização de dados',
  'app.pages.Code.Diagram.Wizards.schema': 'Esquema',
  'app.pages.Code.Diagram.Wizards.csvDataSource': 'Fonte de dados CSV',
  'app.pages.Code.Diagram.Wizards.excelDataSource': 'Fonte de dados Excel',
  'app.pages.Code.Diagram.Wizards.backStep': 'Voltar',
  'app.pages.Code.Diagram.Wizards.finishingDataRead':
    'Finalizando a criação do nó, por favor aguarde...',
  'app.pages.Code.Diagram.Wizards.nextStep': 'Próximo',
  'app.pages.Code.Diagram.Wizards.chooseDataSource': 'Escolha uma fonte de dados',
  'app.pages.Code.Diagram.Wizards.selectFile': 'Selecionar arquivo do servidor',
  'app.pages.Code.Diagram.Wizards.selectFolder': 'Selecionar pasta',
  'app.pages.Code.Diagram.Wizards.selectFileFromUrl': 'Selecionar arquivo de URL',
  'app.pages.Code.Diagram.Wizards.encoding': 'Codificação',
  'app.pages.Code.Diagram.Wizards.separator': 'Separador',
  'app.pages.Code.Diagram.Wizards.dataSetSample': 'Exemplo de conjunto de dados',
  'app.pages.Code.Diagram.Wizards.sheetName': 'Nome da planilha',
  'app.pages.Code.Diagram.Wizards.definedRanges': 'Intervalos definidos',
  'app.pages.Code.Diagram.Wizards.customRange': 'Intervalo personalizado',
  'app.pages.Code.Diagram.Wizards.setNewHeaderFirstRow':
    'Definir novo cabeçalho com a primeira linha',
  'app.pages.Code.Diagram.Wizards.exampleCustomRange': 'Exemplo: A1:B10',
  'app.pages.Code.Diagram.Wizards.sortDataFrame': 'Ordenar DataFrame',
  'app.pages.Code.Diagram.Wizards.criteria': 'Critério',
  'app.pages.Code.Diagram.Wizards.addNewOrderCondition': 'Adicionar nova condição de classificação',
  'app.pages.Code.Diagram.Wizards.indexOptions': 'Opções de índice',
  'app.pages.Code.Diagram.Wizards.transform': 'Transformar',
  'app.pages.Code.Diagram.Wizards.toDataFrame': 'Para DataFrame',
  'app.pages.Code.Diagram.Wizards.changeIndex': 'Alterar índice',
  'app.pages.Code.Diagram.Wizards.oldIndex': 'Índice anterior',
  'app.pages.Code.Diagram.Wizards.newIndex': 'Novo índice',
  'app.pages.Code.Diagram.Wizards.compareMode': 'Modo de comparação',
  'app.pages.Code.Diagram.Wizards.searchIndex': 'Pesquisar índice',
  'app.pages.Code.Diagram.Wizards.byPosition': 'Por posição',
  'app.pages.Code.Diagram.Wizards.byValue': 'Por valor',
  'app.pages.Code.Diagram.Wizards.list': 'Lista',
  'app.pages.Code.Diagram.Wizards.rangeType': 'Tipo de intervalo',
  'app.pages.Code.Diagram.Wizards.frequency': 'Frequência',
  'app.pages.Code.Diagram.Wizards.cumulative': 'Cumulativo',
  'app.pages.Code.Diagram.Wizards.periods': 'Períodos',
  'app.pages.Code.Diagram.Wizards.stringPrefix': 'Prefixo de string',
  'app.pages.Code.Diagram.Wizards.to': 'Para',
  'app.pages.Code.Diagram.Wizards.steps': 'Passos',
  'app.pages.Code.Diagram.Wizards.enterNumericalValue': 'Digite um valor numérico',
  'app.pages.Code.Diagram.Wizards.invalidDate':
    'Data inválida, favor inserir uma data com formato: AAAA-MM-DD',
  'app.pages.Code.Diagram.Wizards.startDateIsRequired': 'A data de início é obrigatória',
  'app.pages.Code.Diagram.Wizards.endDateIsRequired': 'A data de término é obrigatória',
  'app.pages.Code.Diagram.Wizards.yearly': 'Anual',
  'app.pages.Code.Diagram.Wizards.monthly': 'Mensal',
  'app.pages.Code.Diagram.Wizards.weekly': 'Semanal',
  'app.pages.Code.Diagram.Wizards.daily': 'Diário',
  'app.pages.Code.Diagram.Wizards.saveLabels': 'Salvar rótulos',
  'app.pages.Code.Diagram.Wizards.nestedHeaders': 'Cabeçalhos aninhados',
  'app.pages.Code.Diagram.Wizards.nestedHeadersTypeNewValues':
    'Digite novos cabeçalhos aninhados. Pressione Enter para confirmar',
  'app.pages.Code.Diagram.Wizards.deleteAndRecreateTable': 'Excluir e recriar tabela',
  'app.pages.Code.Diagram.Wizards.itemName': 'Nome de elemento',
  'app.pages.Code.Diagram.Wizards.editReportDefinition': 'Editar definição do Relatório',
  'app.pages.Code.Diagram.Wizards.itemsFromIndex': 'Elementos do índice',
  'app.pages.Code.Diagram.Wizards.indexNode': 'Nó índice',
  'app.pages.Code.Diagram.Wizards.addItemsFromIndex': 'Inserir elementos do índice',
  'app.pages.Code.Diagram.Wizards.asNegative': 'Como negativo',
  'app.pages.Code.Diagram.Wizards.itemIsNotInItemsList':
    'O elemento "{item}" não existe na lista de elementos do nó "{nodeId}"',
  'app.pages.Code.Diagram.Wizards.reportSubmitConfirmation':
    'A definição do relatório será substituída.',
  'app.pages.Code.Diagram.Wizards.outputType': 'Tipo de saída',
  'app.pages.Code.Diagram.Wizards.removeNonExistingCombinations':
    'Remover combinações inexistentes',
  'app.pages.Code.Diagram.Wizards.allowDimensionChanges': 'Permitir alteração de dimensões',
  'app.pages.Code.Diagram.Wizards.confirmWizardChanges': 'Confirmar alterações do assistente',
  'app.pages.Code.Diagram.Wizards.overWriteDefinition': 'Sobrescrever definição',
  'app.pages.Code.Diagram.Wizards.createNewNodeWithCurrentChanges':
    'Criar novo nó com alterações atuais',
  'app.pages.Code.Diagram.Wizards.renameColumn': 'Renomear coluna',
  'app.pages.Code.Diagram.Wizards.deleteColumn': 'Excluir coluna',
  'app.pages.Code.Diagram.Wizards.duplicateColumn': 'Duplicar coluna',
  'app.pages.Code.Diagram.Wizards.changeDataType': 'Alterar tipo de dados',
  'app.pages.Code.Diagram.Wizards.sortColumn': 'Ordenar coluna',
  'app.pages.Code.Diagram.Wizards.removeDuplicates': 'Remover duplicados',
  'app.pages.Code.Diagram.Wizards.newColumnName': 'Novo nome da coluna',
  'app.pages.Code.Diagram.Wizards.deleteColumnMessage':
    'A coluna {column} será removida do dataframe. Deseja continuar?',
  'app.pages.Code.Diagram.Wizards.newDuplicateColumnName': 'Novo nome da coluna duplicada',
  'app.pages.Code.Diagram.Wizards.changeColumnType': 'Alterar tipo de coluna',
  'app.pages.Code.Diagram.Wizards.columnSanitization': 'Limpeza de coluna',
  'app.pages.Code.Diagram.Wizards.addNewSanitizeAction': 'Adicionar nova ação de limpeza',
  'app.pages.Code.Diagram.Wizards.sanitizationColumnOptions': 'Opções para limpar a coluna',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveDuplicatesWords':
    'Remover palavras duplicadas da coluna',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.ReplaceMultiSpace':
    'Substituir múltiplos espaços por um único espaço',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemovePunctuation':
    'Remover a pontuação do texto',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveNumbers': 'Remover números do texto',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.KeepOnlyAlphaNumeric':
    'Manter apenas caracteres alfanuméricos',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.NormalizeAccents':
    'Normalizar acentos do texto',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveSpaces': 'Remover espaços do texto',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.AddSpaceBetweenWords':
    'Adicionar espaço entre palavras',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveRepeatedChars':
    'Remover caracteres repetidos',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.UpperWordCase': 'Palavra em maiúscula',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.LowerWordCase': 'Palavra em minúscula',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.TitleWordCase': 'Palavra em título',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveHiddenChars':
    'Remover caracteres ocultos',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.ReplaceHypensWithSpace':
    'Substituir hífens por espaços',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.ReplaceText': 'Substituir texto',
  'app.pages.Code.Diagram.Wizards.textToReplace': 'Texto a ser substituído',
  'app.pages.Code.Diagram.Wizards.replaceWith': 'Substituir por',
  'app.pages.Code.Diagram.Wizards.stopWords': 'Palavras de parada',
  'app.pages.Code.Wizards.Upper': 'Maiúsculas',
  'app.pages.Code.Wizards.Lower': 'Minúsculas',
  'app.pages.Code.Wizards.Title': 'Título',
  'app.pages.Code.Wizards.Capitalize': 'Capitalizar',
  'app.pages.Code.Wizards.Swapcase': 'Trocar maiúsculas e minúsculas',
  'app.pages.Code.Diagram.Wizards.applyChangesInNewColumn': 'Aplicar alterações em nova coluna',
  'app.pages.Code.Diagram.Wizards.fillEmptyValues': 'Preencher valores vazios',
  'app.pages.Code.Diagram.Wizards.fillValue': 'Preencher valor',
  'app.pages.Code.Diagram.Wizards.fillMethod': 'Método de preenchimento',
  'app.pages.Code.Diagram.Wizards.searchConditionValue': 'Valor de condição de pesquisa',
  'app.pages.Code.Diagram.Wizards.selectorType': 'Tipo de seletor',
  'app.pages.Code.Diagram.Wizards.selectorType.standard': 'Padrão',
  'app.pages.Code.Diagram.Wizards.selectorType.date': 'Data',

  //Interfaces
  'app.pages.Interfaces.Table.add1RowAbove': 'Inserir 1 linha acima',
  'app.pages.Interfaces.Table.add5RowsAbove': 'Inserir 5 linhas acima',
  'app.pages.Interfaces.Table.add1RowBelow': 'Inserir 1 linha embaixo',
  'app.pages.Interfaces.Table.add5RowsBelow': 'Inserir 5 linhas embaixo',
  'app.pages.Interfaces.Table.addRow': 'Inserir linha',
  'app.pages.Interfaces.Table.removeRow': 'Excluir linha/s',
  'app.pages.Interfaces.Table.copy': 'Copiar',
  'app.pages.Interfaces.Table.copyTable': 'Copiar tabela',
  'app.pages.Interfaces.Table.copyWithHeaders': 'Copiar com cabeçalho',
  'app.pages.Interfaces.Table.copyOnlyHeaders': 'Copiar apenas o cabeçalho',
  'app.pages.Interfaces.Table.copyAllGroupHeaders': 'Copiar com todos os cabeçalhos de grupo',
  'app.pages.Interfaces.Form.addRowsAbove': 'Adicionar linhas acima',
  'app.pages.Interfaces.Form.addRowsBelow': 'Adicionar linhas abaixo',
  'app.pages.Interfaces.Form.multiselectSelected': 'Selecionados',
  'app.pages.Interfaces.Form.multiselectNotSelected': 'Não selecionados',
  'app.pages.Interfaces.Form.multiselectLoadingMore': 'Carregando mais...',
  'app.pages.Interfaces.Form.multiselectSearch': 'Pesquisar...',
  'app.pages.Interfaces.Form.refreshData': 'Atualizar dados',
  'app.pages.Interfaces.Form.refreshDataAlert':
    'Atualizar os dados fará com que sejam lidos novamente do banco de dados. As alterações que ainda não foram confirmadas serão perdidas.',
  'app.pages.Interfaces.Form.confirmChangesAndRefresh': 'Confirmar alterações e atualizar',
  'app.pages.Interfaces.Form.discardChangesAndRefresh': 'Descartar alterações e atualizar',
  'app.pages.Interfaces.History.title': 'Histórico de dados',
  'app.pages.Interfaces.History.source': 'Origem',
  'app.pages.Interfaces.History.oldValue': 'Valor anterior',
  'app.pages.Interfaces.History.newValue': 'Valor novo',
  'app.pages.Interfaces.History.viewRowHistory': 'Ver histórico da linha',
  'app.pages.Interfaces.History.changedCells': '{count, plural, one {# célula} other {# células}}',
  'app.pages.Interfaces.History.inRows': 'em {count, plural, one {# linha} other {# linhas}}',
  'app.pages.Interfaces.History.insertedRows':
    '{count, plural, one {# linha adicionada} other {# linhas adicionadas}}',
  'app.pages.Interfaces.History.deletedRows':
    '{count, plural, one {# linha removida} other {# linhas removidas}}',
  'app.pages.Interfaces.History.editSession': '{count, plural, one {# edição} other {# edições}}',
  'app.pages.Interfaces.History.batches': 'Lotes',
  'app.pages.Interfaces.History.users': 'Usuários',
  'app.pages.Interfaces.History.lastChange': 'Última alteração',
  'app.pages.Interfaces.History.empty': 'Não há alterações registradas',
  'app.pages.Interfaces.History.operation.update': 'Valor alterado',
  'app.pages.Interfaces.History.operation': 'Operação',
  'app.pages.Interfaces.History.fullName': 'Nome completo',
  'app.pages.Interfaces.History.batch': 'Lote',
  'app.pages.Interfaces.History.download': 'Baixar histórico',
  'app.pages.Interfaces.History.operation.insert': 'Linha adicionada',
  'app.pages.Interfaces.History.operation.delete': 'Linha removida',
  'app.pages.Interfaces.History.source.interface': 'Interface',
  'app.pages.Interfaces.History.source.diagram': 'Diagrama',
  'app.pages.Interfaces.History.source.html_interface': 'Interface HTML',
  'app.pages.Interfaces.History.source.agent': 'Agente',
  'app.pages.Interfaces.History.source.office_addin': 'Suplemento do Excel',
  'app.pages.Interfaces.History.source.code': 'Código',
  'app.pages.Interfaces.Table.drilldownBy': 'Expandir por:',
  'app.pages.Interfaces.Table.drilldownBack': 'Voltar a:',
  'app.pages.Interfaces.Table.drilldownsApplied': 'Drilldowns aplicados:',
  'app.pages.Interfaces.Table.removeDrilldowns': 'Remover drilldowns',
  'app.pages.Interfaces.Table.drilldownBackOneLevel': 'Voltar um nível',
  'app.pages.Interfaces.SelectWithAutocomplete.noOptions': 'Sem opções',
  'app.pages.Interfaces.SelectWithAutocomplete.loading': 'Carregando...',
  'app.pages.Interfaces.IndexFilterDialog.availableElements': 'Elementos disponíveis',
  'app.pages.Interfaces.IndexFilterDialog.selectedElements': 'Elementos selecionados',
  'app.pages.Interfaces.IndexFilterDialog.filterElements': 'Filtrar elementos',
  'app.pages.Interfaces.IndexFilterDialog.contains': 'Contém',
  'app.pages.Interfaces.IndexFilterDialog.notcontains': 'Não contém',
  'app.pages.Interfaces.IndexFilterDialog.equal': 'Igual a',
  'app.pages.Interfaces.IndexFilterDialog.equal_to_node_values': 'Igual aos valores dos nós',
  'app.pages.Interfaces.IndexFilterDialog.regular_expression': 'Expressão regular',
  'app.pages.Interfaces.IndexFilterDialog.notequal': 'Não igual a',
  'app.pages.Interfaces.IndexFilterDialog.greater_than': 'Maior que',
  'app.pages.Interfaces.IndexFilterDialog.greater_than_equal_to': 'Maior ou igual a',
  'app.pages.Interfaces.IndexFilterDialog.less_than': 'Menor que',
  'app.pages.Interfaces.IndexFilterDialog.less_than_equal_to': 'Menor ou igual a',
  'app.pages.Interfaces.IndexFilterDialog.begin_with': 'Começa com',
  'app.pages.Interfaces.IndexFilterDialog.not_begin_with': 'Não começa com',
  'app.pages.Interfaces.IndexFilterDialog.end_with': 'Termina com',
  'app.pages.Interfaces.IndexFilterDialog.not_end_with': 'Não termina com',
  'app.pages.Interfaces.IndexFilterDialog.naDisplayValue': '(vazios)',
  'app.pages.Interfaces.IndexFilterDialog.earliest': 'Primeiro',
  'app.pages.Interfaces.IndexFilterDialog.latest': 'Último',
  'app.pages.Interfaces.IndexFilterDialog.between': 'Entre',
  'app.pages.Interfaces.IndexFilterDialog.notbetween': 'Não entre',
  'app.pages.Interfaces.IndexFilterDialog.matches_pattern': 'Corresponde ao padrão',
  'app.pages.Interfaces.IndexFilterDialog.not_matches_pattern': 'Não corresponde ao padrão',
  'app.pages.Interfaces.IndexFilterDialog.rowsCount': 'Contagem',
  'app.pages.Interfaces.ConditionFilterDialog.filterApplied': 'Filtro por condição aplicado',
  'app.pages.Interfaces.ConditionFilterDialog.clearFilter': 'Limpar filtro',
  'app.pages.Interfaces.ConditionFilterDialog.showWhen': 'Mostrar itens que atendam a',
  'app.pages.Interfaces.ConditionFilterDialog.combinator': 'Como combinar as condições',
  'app.pages.Interfaces.ConditionFilterDialog.all': 'todas as condições (E)',
  'app.pages.Interfaces.ConditionFilterDialog.any': 'alguma condição (OU)',
  'app.pages.Interfaces.ConditionFilterDialog.and': 'E',
  'app.pages.Interfaces.ConditionFilterDialog.or': 'OU',
  'app.pages.Interfaces.ConditionFilterDialog.addCondition': 'Adicionar condição',
  'app.pages.Interfaces.ConditionFilterDialog.removeCondition': 'Remover condição',
  'app.pages.Interfaces.ConditionFilterDialog.patternHelp':
    'Curingas do padrão: * qualquer quantidade de caracteres, ? um único caractere, ~ antes de * ? ~ para buscá-los literalmente.\nEx.: *óleo*girassol*. Não diferencia maiúsculas de minúsculas.',
  'app.pages.Interfaces.ItemHeader.filterByValues': 'Filtrar por valores',
  'app.pages.Interfaces.ItemHeader.filterByCondition': 'Filtrar por condição',
  'app.pages.Interfaces.ItemHeader.filterByNodeValues': 'Filtrar por valores de nó',
  'app.pages.Interfaces.NodeFilterDialog.filterApplied': 'Filtro por valores de nó aplicado',
  'app.pages.Interfaces.NodeFilterDialog.node': 'Nó',
  'app.pages.Interfaces.NodeFilterDialog.help':
    'Os elementos que coincidem com os valores do nó (uma lista, um índice ou um único valor) são filtrados sempre que a visualização é carregada. Os valores do nó que não existem na dimensão são ignorados.',
  'app.pages.Interfaces.SelectFormColumnsDialog.nodeHelp':
    'São exibidas as colunas cujo nome ou título está no resultado do nó (uma lista, um índice ou um único valor) sempre que a visualização é carregada. Os valores do nó que não são colunas são ignorados.',
  'app.pages.Interfaces.SelectFormColumnsDialog.conditionHelp':
    'As condições são avaliadas sobre os títulos das colunas sempre que a visualização é carregada.',
  'app.pages.Interfaces.Components.core.Node': 'Nó',
  'app.pages.Interfaces.Components.core.Index': 'Índice',
  'app.pages.Interfaces.Components.core.Selector': 'Seletor',
  'app.pages.Interfaces.Components.core.Chart': 'Gráfico',
  'app.pages.Interfaces.Components.core.PlotlyChart': 'Gráfico plotly',
  'app.pages.Interfaces.Components.core.InputValue': 'Entrada de valor',
  'app.pages.Interfaces.Components.core.Table': 'Tabela',
  'app.pages.Interfaces.Components.core.InputDataArray': 'Entrada de dataarray',
  'app.pages.Interfaces.Components.core.InputDataFrame': 'Entrada de dataframe',
  'app.pages.Interfaces.Components.core.Html': 'Texto formatado',
  'app.pages.Interfaces.Components.core.Menu': 'Menu',
  'app.pages.Interfaces.Components.core.Empty': 'Vazio',
  'app.pages.Interfaces.Components.core.Generic': 'Genérico',
  'app.pages.Interfaces.Components.core.Indicator': 'Indicador',
  'app.pages.Interfaces.Components.core.Choice': 'Escolha',
  'app.pages.Interfaces.Components.core.Button': 'Botão',
  'app.pages.Interfaces.Components.core.Button.disable': 'Desativar botão',
  'app.pages.Interfaces.Components.core.Button.runButtonDefaultMessage':
    'Tem certeza de que deseja executar este botão?',
  'app.pages.Interfaces.Components.core.Form': 'Formulário',
  'app.pages.Interfaces.Components.core.MyTasks': 'Tarefas',
  'app.pages.Interfaces.Components.core.ScheduledTasks': 'Tarefas agendadas',
  'app.pages.Interfaces.Components.core.InputData': 'Entrada de dados',
  'app.pages.Interfaces.Components.core.MatplotlibChart': 'Gráfico matplotlib',
  'app.pages.Interfaces.Components.core.Assistant': 'Assistente',
  'app.pages.Interfaces.Components.core.Notifications': 'Notificações',
  'app.pages.Interfaces.Components.core.DynamicHtml': 'Menu HTML',
  'app.pages.Interfaces.Components.core.Filter': 'Filtro',
  'app.pages.Interfaces.Components.core.Filters': 'Filtros',
  'app.pages.Interfaces.Components.core.UploadManager': 'Administrador de arquivos',
  'app.pages.Interfaces.Components.core.HtmlVisualization': 'Visualização HTML',
  'app.pages.Interfaces.Components.core.ApplyFilters': 'Aplicar filtros',
  'app.pages.Interfaces.Components.core.multiple': 'Múltiplo',
  'app.pages.Interfaces.Components.core.multiSelect': 'Multi-seleção',
  'app.pages.Interfaces.Components.core.numberOfValuesToDisplayInCell':
    'Quantidade de valores a exibir na célula',
  'app.pages.Interfaces.View.InterfaceName': 'Interface {name}',
  'app.pages.Interfaces.View.share': 'Compartilhar',
  'app.pages.Interfaces.View.Empty':
    'A interface está vazia no momento. Entre no modo de edição para adicionar componentes.',
  'app.pages.Interfaces.View.openMenu': 'Abrir menu',
  'app.pages.Interfaces.Edit': 'Editar interface',
  'app.pages.Interfaces.Edit.Menu.componentConfig': 'Configuração do componente',
  'app.pages.Interfaces.Edit.Menu.newComponent': 'Novo componente',
  'app.pages.Interfaces.Edit.Menu.title': 'Título',
  'app.pages.Interfaces.Edit.Menu.chartEvents': 'Eventos',
  'app.pages.Interfaces.Edit.Menu.data': 'Dados',
  'app.pages.Interfaces.Edit.Menu.indexSync': 'Índices sincronizados',
  'app.pages.Interfaces.Edit.Menu.indexSync.all': 'Sincronizar todos os índices',
  'app.pages.Interfaces.Edit.Menu.indexSync.syncedCount': '{synced} de {total} sincronizados',
  'app.pages.Interfaces.Edit.Menu.styleEditor': 'Estilos',
  'app.pages.Interfaces.Edit.Menu.icon': 'Ícone',
  'app.pages.Interfaces.Edit.Menu.advancedPivot': 'Pivot avançado',
  'app.pages.Interfaces.Edit.Menu.layoutProperties': 'Esquema',
  'app.pages.Interfaces.Edit.Menu.valueFormat': 'Formato de valores',
  'app.pages.Interfaces.Edit.Menu.valueFormatSecondaryAxis': 'Formato de valores - Eixo secundário',
  'app.pages.Interfaces.Edit.Menu.conditionalFormat': 'Formato condicional',
  'app.pages.Interfaces.Edit.Menu.cellProperties': 'Propriedades de células',
  'app.pages.Interfaces.Edit.Menu.progressBar': 'Barra de progresso',
  'app.pages.Interfaces.Edit.Menu.heatmap': 'Mapa de calor',
  'app.pages.Interfaces.Edit.Menu.componentStyle': 'Componente',
  'app.pages.Interfaces.Edit.Menu.general': 'Geral',
  'app.pages.Interfaces.Edit.Menu.scenarios': 'Cenários',
  'app.pages.Interfaces.Edit.Menu.columnsToShow': 'Colunas para mostrar',
  'app.pages.Interfaces.Edit.Menu.scheduledTasksOptions': 'Opções',
  'app.pages.Interfaces.Edit.Menu.notificationsOptions': 'Opções',
  'app.pages.Interfaces.Edit.Menu.confirmationDialog': 'Caixa de diálogo de confirmação',
  'app.pages.Interfaces.Edit.Menu.showConfirmationDialog': 'Mostrar caixa de diálogo',
  'app.pages.Interfaces.Edit.Menu.confirmationDialogMessage': 'Mensagem',
  'app.pages.Interfaces.Edit.Menu.editConfirmationDialogMessage': 'Editar mensagem',
  'app.pages.Interfaces.Edit.Menu.confirmationDialogMessageEditorTitle':
    'Mensagem da caixa de confirmação',
  'app.pages.Interfaces.Edit.Menu.confirmationDialogMessageEmpty': 'A mensagem padrão será exibida',
  'app.pages.Interfaces.Edit.Menu.formProperties': 'Propriedades de formulário',
  'app.pages.Interfaces.Edit.Menu.validations': 'Validações',
  'app.pages.Interfaces.Edit.Menu.inputCubeProperties': 'Propriedades de cubo',
  'app.pages.Interfaces.Edit.selectNode': 'Selecione um nó para criar um componente de tipo',
  'app.pages.Interfaces.Edit.nodeType': 'Tipo de nó',
  'app.pages.Interfaces.Edit.selectedNodeId': 'ID do nó selecionado',
  'app.pages.Interfaces.Edit.refresh': 'Atualizar interface',
  'app.pages.Interfaces.Edit.refreshAndReset': 'Atualizar interface e restaurar sua visualização',
  'app.pages.Interfaces.Edit.copy': 'Copiar interface',
  'app.pages.Interfaces.Edit.detachSidebar': 'Separar barra lateral',
  'app.pages.Interfaces.Edit.fixSidebar': 'Fixar barra lateral',
  'app.pages.Interfaces.Edit.hidePanel': 'Esconder painel',
  'app.pages.Interfaces.Edit.showPanel': 'Mostrar painel',
  'app.pages.Interfaces.Edit.removeComponent': 'Excluir componente',
  'app.pages.Interfaces.Edit.remove': 'Excluir',
  'app.pages.Interfaces.Edit.removeConfirmationText':
    'Tem certeza de que deseja excluir este componente?',
  'app.pages.Interfaces.Edit.discardUnsavedChanges': 'Descartar alterações não salvas?',
  'app.pages.Interfaces.Edit.discardUnsavedChangesText':
    'Tem certeza de que deseja descartar as alterações não salvas?',
  'app.pages.Interfaces.Edit.showInterfaceCode': 'Mostrar código da interface',
  'app.pages.Interfaces.Edit.gridSettings': 'Editar configuração do grid',
  'app.pages.Interfaces.Edit.interfaceCodeEditor': 'Editor de código da interface',
  'app.pages.Interfaces.Edit.closeComponentCodeEditor': 'Fechar editor de código do componente',
  'app.pages.Interfaces.Edit.customComponentCode': 'Código personalizado do componente',
  'app.pages.Interfaces.Edit.HTMLEditor': 'Editor de HTML',
  'app.pages.Interfaces.Edit.menuEditor': 'Editor do menu',
  'app.pages.Interfaces.Edit.title.enabled': 'Mostrar',
  'app.pages.Interfaces.Edit.title.editTitle': 'Editar título',
  'app.pages.Interfaces.Edit.title.customTitle': 'Título personalizado',
  'app.pages.Interfaces.Edit.table.size.rowsPerPage': 'Linhas por página',
  'app.pages.Interfaces.Edit.table.size.columnsPerPage': 'Colunas por página',
  'app.pages.Interfaces.Edit.table.data.showRowTotals': 'Mostrar totais de linhas',
  'app.pages.Interfaces.Edit.table.data.rowTotalsPosition': 'Posição de totais de linhas',
  'app.pages.Interfaces.Edit.table.data.rowTotalsAggregation': 'Agregação de totais de linhas',
  'app.pages.Interfaces.Edit.table.data.showColumnTotals': 'Mostrar totais de colunas',
  'app.pages.Interfaces.Edit.table.data.removeColumnTotals': 'Remover totais por colunas',
  'app.pages.Interfaces.Edit.table.data.removeRowTotals': 'Remover totais por linhas',
  'app.pages.Interfaces.Edit.table.data.columnTotalsPosition': 'Posição de totais de colunas',
  'app.pages.Interfaces.Edit.table.data.columnTotalsAggregation': 'Agregação de totais de colunas',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByMember': 'Agregação por membro',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByMemberHelp':
    'Defina o método de agregação por membro de cada dimensão. Aplica-se ao total inferior quando a dimensão está em colunas e ao total à direita quando está em linhas. O critério é mantido ao mover ou ocultar a dimensão.',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByField': 'Agregação por campo',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByFieldHelp':
    'Defina o método de agregação do total inferior por campo. Campos sem exceção usam o método geral.',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationFieldsGroup': 'Campos',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationGeneral': 'Geral',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationNoMembers':
    'A dimensão não tem membros para exibir.',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationNoDimensions':
    'A tabela não tem dimensões para configurar.',
  'app.pages.Interfaces.Edit.table.data.compareScenarios': 'Comparar cenários',
  'app.pages.Interfaces.Edit.table.data.disableCompareScenarios': 'Desabilitar comparar cenários',
  'app.pages.Interfaces.Edit.table.data.compareAllInterfaceScenarios':
    'Comparar cenários em todos os componentes',
  'app.pages.Interfaces.Edit.table.data.scenariosPlacement': 'Posicionamento de cenários',
  'app.pages.Interfaces.Edit.table.data.scenariosInRows': 'Em linhas',
  'app.pages.Interfaces.Edit.table.data.scenariosInColumns': 'Em colunas',
  'app.pages.Interfaces.Edit.table.data.showValues': 'Mostrar valores',
  'app.pages.Interfaces.Edit.table.data.showDifference': 'Mostrar diferença',
  'app.pages.Interfaces.Edit.table.data.showPercentageDifference': 'Mostrar diferença percentual',
  'app.pages.Interfaces.Edit.table.data.fillMissingWithZero':
    'Preencher valores faltantes com zero',
  'app.pages.Interfaces.Edit.table.data.fillMissingWithZeroTooltip':
    'Substitui por 0 os valores ausentes no cenário selecionado e no cenário base antes de calcular as diferenças.',
  'app.pages.Interfaces.Edit.table.data.zeroDivisionReturnsZero': 'Divisão por zero retorna zero',
  'app.pages.Interfaces.Edit.table.data.zeroDivisionReturnsZeroTooltip':
    'Apenas para diferença percentual: retorna 0 quando o valor do cenário base é 0 em vez de dividir por zero.',
  'app.pages.Interfaces.Edit.table.data.differenceEndText': 'Texto final de diferença',
  'app.pages.Interfaces.Edit.table.data.percentageDifferenceEndText':
    'Texto final de diferença percentual',
  'app.pages.Interfaces.Edit.table.data.columnsProperties': 'Propriedades de colunas',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData': 'Esconder dados vazios',
  'app.pages.Interfaces.Edit.chart.data.hideEmptyLegend': 'Esconder legendas vazias',
  'app.pages.Interfaces.Edit.chart.data.syncYAxesRange': 'Sincronizar escalas dos eixos Y',
  'app.pages.Interfaces.Edit.table.data.totalsPositions.end': 'Fim',
  'app.pages.Interfaces.Edit.table.data.totalsPositions.beginning': 'Começo',
  'app.pages.Interfaces.Edit.table.data.showColumnFilterIcon': 'Mostrar ícone de filtro de coluna',
  'app.pages.Interfaces.Edit.table.data.enableQuickPivot': 'Ativar o pivô rápido',
  'app.pages.Interfaces.Edit.table.data.hideFooter': 'Ocultar rodapé',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData.column': 'Coluna',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData.row': 'Linha',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData.both': 'Ambas',
  'app.pages.Interfaces.Edit.table.data.processingEngine': 'Motor de processamento',
  'app.pages.Interfaces.Edit.table.data.processingEngine.pandas': 'Pandas',
  'app.pages.Interfaces.Edit.table.data.processingEngine.polars': 'Polars',
  'app.pages.Interfaces.Edit.table.data.pagination': 'Paginação',
  'app.pages.Interfaces.Edit.table.data.fixedColumns': 'Colunas fixadas',
  'app.pages.Interfaces.Edit.table.data.subtotalLabel': 'Rótulo do subtotal',
  'app.pages.Interfaces.Edit.table.data.subtotalLabelHelperText':
    "Use '{dimension}' como variável para o valor. Deixe em branco para usar o rótulo padrão: '{dimension} - Subtotal'",
  'app.pages.Interfaces.Edit.table.data.showIndex': 'Mostrar coluna "index"',
  'app.pages.Interfaces.Edit.events.selectedEvent': 'Evento de seleção',
  'app.pages.Interfaces.Edit.events.hoverEvent': 'Evento hover',
  'app.pages.Interfaces.Edit.events.drilldownEvent': 'Evento drilldown',
  'app.pages.Interfaces.Edit.pivot': 'Pivot',
  'app.pages.Interfaces.Edit.filter': 'Filtro',
  'app.pages.Interfaces.Edit.dataHandling': 'Manipulação de dados',
  'app.pages.Interfaces.Edit.appliedFiltersOn': 'Filtros aplicados em',
  'app.pages.Interfaces.Edit.appliedConditionFiltersOn': 'Filtros por condição aplicados em',
  'app.pages.Interfaces.Edit.appliedNodeFiltersOn': 'Filtros por valores de nó aplicados em',
  'app.pages.Interfaces.Edit.isolateStyles': 'Isolar estilos',
  'app.pages.Interfaces.Edit.style.fontSize': 'Tamanho da fonte',
  'app.pages.Interfaces.Edit.style.fixedColumnWidth': 'Largura de coluna fixa',
  'app.pages.Interfaces.Edit.style.fontStyle': 'Estilo da fonte',
  'app.pages.Interfaces.Edit.style.fontStyle.bold': 'Negrito',
  'app.pages.Interfaces.Edit.style.fontStyle.italic': 'Itálico',
  'app.pages.Interfaces.Edit.style.fontStyle.underline': 'Sublinhado',
  'app.pages.Interfaces.Edit.style.fontColor': 'Cor da fonte',
  'app.pages.Interfaces.Edit.style.backgroundColor': 'Cor de fundo',
  'app.pages.Interfaces.Edit.style.headerBackgroundColor': 'Cor de fundo do cabeçalho',
  'app.pages.Interfaces.Edit.style.headerColor': 'Cor do cabeçalho',
  'app.pages.Interfaces.Edit.style.textAlign': 'Alinhamento do texto',
  'app.pages.Interfaces.Edit.style.textAlign.left': 'Esquerda',
  'app.pages.Interfaces.Edit.style.textAlign.center': 'Centralizado',
  'app.pages.Interfaces.Edit.style.textAlign.right': 'Direita',
  'app.pages.Interfaces.Edit.style.textAlign.justify': 'Justificado',
  'app.pages.Interfaces.Edit.style.verticalAlign': 'Alinhamento vertical',
  'app.pages.Interfaces.Edit.style.verticalAlign.top': 'Topo',
  'app.pages.Interfaces.Edit.style.verticalAlign.middle': 'Meio',
  'app.pages.Interfaces.Edit.style.verticalAlign.bottom': 'Fundo',
  'app.pages.Interfaces.Edit.style.hideHeader': 'Ocultar header',
  'app.pages.Interfaces.Edit.style.hideBorder': 'Ocultar borda',
  'app.pages.Interfaces.Edit.style.hideMaximizeButton': 'Ocultar botão de maximizar',
  'app.pages.Interfaces.Edit.style.hidePivotIcon': 'Ocultar ícone de pivot',
  'app.pages.Interfaces.Edit.style.showViewAsTableChartIcon':
    'Mostrar ícone de “Ver como tabela/gráfico”',
  'app.pages.Interfaces.Edit.style.showComponentSettingsIcon':
    'Mostrar ícone de configurações do componente',
  'app.pages.Interfaces.Edit.style.note': '(aplica no modo de visualização)',
  'app.pages.Interfaces.Edit.style.setDefaultColor': 'Definir cor padrão',
  'app.pages.Interfaces.Edit.style.applyAndClose': 'Aplicar e fechar',
  'app.pages.Interfaces.Edit.style.seriesColors': 'Cor das séries',
  'app.pages.Interfaces.Edit.style.colorPalette.increasing': 'Aumento',
  'app.pages.Interfaces.Edit.style.colorPalette.decreasing': 'Diminuição',
  'app.pages.Interfaces.Edit.style.hideCharacters': 'Ocultar caracteres',
  'app.pages.Interfaces.Edit.layout.style.axesTitles': 'Títulos de eixos',
  'app.pages.Interfaces.Edit.layout.style.showYAxisTitle': 'Mostrar título de eixo Y',
  'app.pages.Interfaces.Edit.layout.style.showXAxisTitle': 'Mostrar título de eixo X',
  'app.pages.Interfaces.Edit.layout.color_palette': 'Paleta de cores',
  'app.pages.Interfaces.Edit.layout.color_palette.color_continuous_scale': 'Escala contínua',
  'app.pages.Interfaces.Edit.layout.color_palette.color_discrete_sequence': 'Sequência discreta',
  'app.pages.Interfaces.Edit.layout.legend': 'Legenda',
  'app.pages.Interfaces.Edit.layout.legend.showlegend': 'Mostrar legenda',
  'app.pages.Interfaces.Edit.layout.legend.toggleOthersWithSingleClick':
    'Alternar outros com um único clique',
  'app.pages.Interfaces.Edit.layout.legend.coloraxis_showscale': 'Mostrar escala',
  'app.pages.Interfaces.Edit.layout.legend.orientation': 'Orientação',
  'app.pages.Interfaces.Edit.layout.legend.xanchor': 'Ponto de ancoragem X',
  'app.pages.Interfaces.Edit.layout.legend.x': 'X',
  'app.pages.Interfaces.Edit.layout.legend.yanchor': 'Ponto de ancoragem Y',
  'app.pages.Interfaces.Edit.layout.legend.y': 'Y',
  'app.pages.Interfaces.Edit.layout.margins': 'Margens',
  'app.pages.Interfaces.Edit.layout.selectValues.auto': 'Auto',
  'app.pages.Interfaces.Edit.layout.selectValues.left': 'Esquerda',
  'app.pages.Interfaces.Edit.layout.selectValues.center': 'Centro',
  'app.pages.Interfaces.Edit.layout.selectValues.right': 'Direita',
  'app.pages.Interfaces.Edit.layout.selectValues.top': 'Superior',
  'app.pages.Interfaces.Edit.layout.selectValues.middle': 'Meio',
  'app.pages.Interfaces.Edit.layout.selectValues.bottom': 'Inferior',
  'app.pages.Interfaces.Edit.layout.chartMode': 'Variante de gráfico',
  'app.pages.Interfaces.Edit.layout.chartMode.modePreset': 'Variante predefinida',
  'app.pages.Interfaces.Edit.layout.chartMode.stack': 'Empilhado',
  'app.pages.Interfaces.Edit.layout.chartMode.relative': 'Relativo',
  'app.pages.Interfaces.Edit.layout.chartMode.group': 'Agrupado',
  'app.pages.Interfaces.Edit.layout.chartMode.overlay': 'Sobreposição',
  'app.pages.Interfaces.Edit.layout.chartMode.barmode': 'Variante de barra',
  'app.pages.Interfaces.Edit.layout.chartMode.boxmode': 'Variante de caixa',
  'app.pages.Interfaces.Edit.layout.chartMode.funnelmode': 'Variante de funil',
  'app.pages.Interfaces.Edit.layout.chartMode.violinmode': 'Variante de violino',
  'app.pages.Interfaces.Edit.layout.chartMode.waterfallmode': 'Variante de cachoeira',
  'app.pages.Interfaces.Edit.layout.chartMode.percent': 'Porcentagem',
  'app.pages.Interfaces.Edit.layout.chartNorm': 'Normalização de gráfico',
  'app.pages.Interfaces.Edit.layout.chartNorm.barnorm': 'Normalização de barra',
  'app.pages.Interfaces.Edit.layout.chartNorm.groupnorm': 'Normalização de grupo',
  'app.pages.Interfaces.Edit.layout.chartNorm.fraction': 'Fração',
  'app.pages.Interfaces.Edit.layout.chartNorm.percent': 'Porcentagem',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels': 'Rótulos',
  'app.pages.Interfaces.Edit.layout.chartNorm.labelsSecondaryAxis': 'Rótulos - Eixo secundário',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.showLabels': 'Mostrar rótulos',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.labelField': 'Campo',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.minSize': 'Tamanho mínimo',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.mode': 'Modo',
  'app.pages.Interfaces.Edit.layout.customSeriesColors': 'Cores de séries personalizadas',
  'app.pages.Interfaces.Edit.layout.customName': 'Nome personalizado',
  'app.pages.Interfaces.Edit.layout.addValue': 'Inserir valor',
  'app.pages.Interfaces.Edit.layout.addColor': 'Inserir cor',
  'app.pages.Interfaces.Edit.layout.generateValuesFromColumn': 'Gerar valores a partir da coluna',
  'app.pages.Interfaces.Edit.layout.y_axis_range': 'Intervalo do eixo Y',
  'app.pages.Interfaces.Edit.layout.y_axis_range_secondary_axis':
    'Intervalo do eixo Y - Eixo secundário',
  'app.pages.Interfaces.Edit.layout.yAxisTitle': 'Título do eixo Y',
  'app.pages.Interfaces.Edit.layout.xAxisTitle': 'Título do eixo X',
  'app.pages.Interfaces.Edit.valueFormat.formatPreset': 'Formato predefinido',
  'app.pages.Interfaces.Edit.valueFormat.number': 'Número',
  'app.pages.Interfaces.Edit.valueFormat.decimal': 'Decimal',
  'app.pages.Interfaces.Edit.valueFormat.integer': 'Inteiro',
  'app.pages.Interfaces.Edit.valueFormat.percent': 'Porcentagem',
  'app.pages.Interfaces.Edit.valueFormat.currency': 'Moeda',
  'app.pages.Interfaces.Edit.valueFormat.currencyRounded': 'Moeda (arredondada)',
  'app.pages.Interfaces.Edit.valueFormat.accounting': 'Contabilidade',
  'app.pages.Interfaces.Edit.valueFormat.accountingRounded': 'Contabilidade (arredondado)',
  'app.pages.Interfaces.Edit.valueFormat.finance': 'Financeiro',
  'app.pages.Interfaces.Edit.valueFormat.financeRounded': 'Financeiro (arredondado)',
  'app.pages.Interfaces.Edit.valueFormat.showNegativeInParentheses':
    'Mostrar negativos entre parênteses',
  'app.pages.Interfaces.Edit.valueFormat.date': 'Data',
  'app.pages.Interfaces.Edit.valueFormat.datetime': 'Data hora',
  'app.pages.Interfaces.Edit.valueFormat.general': 'Geral',
  'app.pages.Interfaces.Edit.valueFormat.thousandsSeparator': 'Separador de milhares',
  'app.pages.Interfaces.Edit.valueFormat.decimalPlaces': 'Decimais',
  'app.pages.Interfaces.Edit.valueFormat.prefix': 'Prefixo',
  'app.pages.Interfaces.Edit.valueFormat.suffix': 'Sufixo',
  'app.pages.Interfaces.Edit.valueFormat.dateFormat': 'Formato de data',
  'app.pages.Interfaces.Edit.valueFormat.datetimeFormat': 'Formato de data hora',
  'app.pages.Interfaces.Edit.valueFormat.seePatternReference': 'Ver referência de padrão',
  'app.pages.Interfaces.Run.runningButton': 'Executando Botão',
  'app.pages.Interfaces.Edit.editTitle.showUnits': 'Mostrar unidades',
  'app.pages.Interfaces.Edit.progressBar.applyProgressBar': 'Aplicar barra de progresso',
  'app.pages.Interfaces.Edit.progressBar.max_value': 'Valor máximo',
  'app.pages.Interfaces.Edit.progressBar.min_hue': 'Matiz mínima',
  'app.pages.Interfaces.Edit.progressBar.max_hue': 'Matiz máxima',
  'app.pages.Interfaces.Edit.progressBar.saturation': 'Saturação',
  'app.pages.Interfaces.Edit.progressBar.lightness': 'Clareza',
  'app.pages.Interfaces.Edit.progressBar.show_value': 'Mostrar valor',
  'app.pages.Interfaces.Edit.heatmap.applyHeatmap': 'Aplicar mapa de calor',
  'app.pages.Interfaces.Edit.heatmap.by': 'Por',
  'app.pages.Interfaces.Edit.heatmap.hex_base_background_color': 'Cor de fundo base',
  'app.pages.Interfaces.Edit.heatmap.hex_text_color': 'Cor de texto',
  'app.pages.Interfaces.Edit.heatmap.exclude_nans': 'Excluir NaNs',
  'app.pages.Interfaces.Edit.heatmap.exclude_right_total': 'Excluir totais de linhas',
  'app.pages.Interfaces.Edit.heatmap.exclude_bottom_total': 'Excluir totais de colunas',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor': 'Cor de mapa de calor',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_green_alt': 'vermelho-verde-alt',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_red_alt': 'verde-vermelho-alt',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_green': 'vermelho-verde',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_red': 'verde-vermelho',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_white': 'vermelho-branco',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.white_red': 'branco-vermelho',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.white_green': 'branco-verde',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_white': 'verde-branco',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_blue': 'verde-azul',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.blue_green': 'azul-verde',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_blue': 'vermelho-azul',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.blue_red': 'azul-vermelho',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.custom': 'Personalizado',
  'app.pages.Interfaces.Edit.conditionalFormat.addCondition': 'Adicionar condição',
  'app.pages.Interfaces.Edit.conditionalFormat.deleteAll': 'Excluir todas',
  'app.pages.Interfaces.Edit.conditionalFormat.Conditions': 'Condições',
  'app.pages.Interfaces.Edit.conditionalFormat.showIconOnly': 'Mostrar só o ícone',
  'app.pages.Interfaces.Edit.conditionalFormat.expressionInfo1':
    'Preencha com uma expressão onde cada nome de coluna esteja entre # no início e no fim. Todos os nomes de colunas usados devem estar presentes na tabela final.',
  'app.pages.Interfaces.Edit.conditionalFormat.expressionInfo2':
    'A expressão deve sempre retornar uma série booleana.',
  'app.pages.Interfaces.Edit.conditionalFormat.expressionInfo3': 'Por exemplo:',
  'app.pages.Interfaces.Edit.style.addNewStyle': 'Adicionar estilo novo',
  'app.pages.Interfaces.Edit.style.deleteStyle': 'Excluir estilo',
  'app.pages.Interfaces.Edit.style.editStyle': 'Editar estilo',
  'app.pages.Interfaces.Edit.style.dimensionName': 'Nome de dimensão',
  'app.pages.Interfaces.Edit.style.filterType': 'Tipo de filtro',
  'app.pages.Code.Diagram.Wizards.styleConditions': 'Condições do estilo',
  'app.pages.Code.Diagram.Wizards.filterIndexes': 'Filtrar índices',
  'app.pages.Interfaces.Edit.colorPicker.themeColors': 'Cores do tema',
  'app.pages.Interfaces.Edit.colorPicker.standardColors': 'Cores padrão',
  'app.pages.Interfaces.Edit.colorPicker.recentColors': 'Cores recentes',
  'app.pages.Interfaces.Edit.colorPicker.selectedColor': 'Cor selecionada',
  'app.pages.Interfaces.Edit.leaveInterfaceTitle': 'Interface com alterações não confirmadas',
  'app.pages.Interfaces.Edit.leaveInterfaceContent':
    'Deseja confirmar as alterações ou descartá-las?',
  'app.pages.Interfaces.Edit.inputNodeProperties.hideIdColumn': 'Ocultar coluna com ID',
  'app.pages.Interfaces.Edit.inputNodeProperties.confirmOnChange':
    'Confirmar ao fazer uma alteração',
  'app.pages.Interfaces.Edit.inputNodeProperties.invalidateOutputsOnChange':
    'Invalidar saídas ao fazer uma alteração',
  'app.pages.Interfaces.Edit.inputNodeProperties.invalidateOutputsOnConfirm':
    'Invalidar saídas ao confirmar',
  'app.pages.Interfaces.Edit.inputNodeProperties.updateCalcColumnsOnChange':
    'Atualizar colunas calculadas ao fazer uma alteração',
  'app.pages.Interfaces.Edit.inputNodeProperties.updateCalcColumnsOnConfirm':
    'Atualizar colunas calculadas ao confirmar',
  'app.pages.Interfaces.Edit.inputNodeProperties.showSelectColumnsIcon':
    'Mostrar ícone de Selecionar colunas',
  'app.pages.Interfaces.Edit.inputNodeProperties.showEditExcelIcon':
    'Mostrar ícone de Editar no Excel',
  'app.pages.Interfaces.Edit.inputNodeProperties.showRefreshIcon':
    'Mostrar ícone de Atualizar dados',
  'app.pages.Interfaces.Edit.inputNodeProperties.showHistoryIcon':
    'Mostrar ícone de Histórico de dados',
  'app.pages.Interfaces.Edit.inputNodeProperties.newRowsPosition': 'Posição de novas linhas',
  'app.pages.Interfaces.Edit.filterIndexValues': 'Filtrar valores de índice',
  'app.pages.Interfaces.Edit.filterIndexValues.fromToError':
    'O valor "De" deve ser menor ou igual ao valor "Até".',
  'app.pages.Interfaces.Edit.style.applyConditionTo': 'Aplicar condição a',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customView': 'Visualização personalizada',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customViewWithName':
    'Visualização personalizada: {name}',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.editingCustomView':
    'Você está editando a visualização personalizada "{name}"',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.originalView': 'Visualização original',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.myView': 'Minha visualização',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.opensByDefault': 'Abre por padrão',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.openByDefault':
    'Abrir esta visualização por padrão',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.saveChangesInView':
    'Salvar alterações em "{name}"',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.saveAsNewView':
    'Salvar como nova visualização…',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.newView': 'Nova visualização personalizada',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.editView': 'Editar visualização personalizada',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.deleteViewConfirm':
    'Excluir a visualização personalizada "{name}"?',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.deleteCustomView':
    'Excluir visualização personalizada',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customViewSaved':
    'A visualização personalizada da interface foi salva com sucesso',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customViewDeleted':
    'A visualização personalizada da interface foi excluída com sucesso',
  'app.pages.Interfaces.components.options.showPivotArea': 'Mostrar área de pivô',
  'app.pages.Interfaces.components.options.hidePivotArea': 'Ocultar área de pivô',
  'app.pages.app.properties.componentOptions': 'Opções do componente',

  //Instance manager
  'app.pages.app.instanceManager.noInstances': 'Não há instâncias',
  'app.pages.app.instanceManager.open': 'Aberto',
  'app.pages.app.instanceManager.currentApplication': 'Aplicativo atual',
  'app.pages.app.instanceManager.active': 'Ativo',
  'app.pages.app.instanceManager.timeoutIn': 'Tempo de espera restante',
  'app.pages.app.instanceManager.minutes': ' min',
  'app.pages.app.instanceManager.cpu': 'CPU',
  'app.pages.app.instanceManager.memory': 'Memória',
  'app.pages.app.instanceManager.peak': 'Pico',
  'app.pages.app.instanceManager.apiResources': 'Recursos do aplicativo',
  'app.pages.app.instanceManager.systemMemory': 'Total',
  'app.pages.app.instanceManager.inUse': 'Em uso',
  'app.pages.app.instanceManager.disk': 'Disco',
  'app.pages.app.instanceManager.time': 'Tempo',
  'app.pages.app.instanceManager.selectedInstance': 'Instância selecionada',
  'app.pages.app.instanceManager.pid': 'PID',
  'app.pages.app.instanceManager.memoryPeak': 'Pico de memória',
  'app.pages.app.instanceManager.lastProcessedNode': 'Último nó processado',
  'app.pages.app.instanceManager.requireLogoutTitle': 'Requerer logout',
  'app.pages.app.instanceManager.requireLogoutMessage':
    'Tem certeza de que deseja enviar uma solicitação para fechar a instância?',
  'app.pages.app.instanceManager.killInstanceTitle': 'Fechar instância',
  'app.pages.app.instanceManager.killInstanceMessage':
    'Toda informação desta instância será apagada. Tem certeza?',
  'app.pages.app.instanceManager.requestSent': 'Solicitação enviada',
  'app.pages.app.instanceManager.instanceClosed': 'Instância fechada',
  'app.pages.app.instanceManager.noSelectedInstance': 'Não há instância selecionada',
  'app.pages.app.instanceManager.yourInstanceIsAboutToExpire':
    'Sua instância está prestes a expirar',
  'app.pages.app.instanceManager.pressConfirmToExtendYourInstance':
    'Pressione confirmar para estender sua instância',
  'app.pages.app.instanceManager.yourInstanceHasBeenExtended': 'Sua instância foi estendida',
  'app.pages.app.instanceManager.cpuArchitecture': 'Arquitetura',
  'app.pages.app.instanceManager.userOrigin': 'Origem',
  'app.pages.app.instanceManager.internalUser': 'Interno',
  'app.pages.app.instanceManager.externalUser': 'Externo',
  'app.pages.app.instanceManager.agentUser': 'Agente',
  'app.pages.app.instanceManager.poolOrigin': 'Pool',
  'app.pages.app.instanceManager.poolForUser': 'Pool {user}',
  'app.pages.app.instanceManager.noFilteredInstances': 'Nenhuma instância corresponde aos filtros',

  //Log manager
  'app.pages.managers.logs': 'Logs',
  'app.pages.managers.logManager.startDate': 'Data de início',
  'app.pages.managers.logManager.endDate': 'Data final',
  'app.pages.managers.logManager.instanceKey': 'Instância',
  'app.pages.managers.logManager.podName': 'Pod',
  'app.pages.managers.logManager.user': 'Usuário',
  'app.pages.managers.logManager.user.notFound': 'Usuário não encontrado',
  'app.pages.managers.logManager.user.selectUser': 'Selecione ou procure um usuário',
  'app.pages.managers.logManager.action': 'Ação',
  'app.pages.managers.logManager.action.notFound': 'Ação não encontrada',
  'app.pages.managers.logManager.action.selectAction': 'Selecione ou procure uma ação',
  'app.pages.managers.logManager.model': 'Modelo',
  'app.pages.managers.logManager.reportDownloaded': 'Relatório baixado',
  'app.pages.managers.logManager.clearFilters': 'Limpar filtros',
  'app.pages.managers.logManager.filter': 'Filtro',
  'app.pages.managers.logManager.table.date': 'Data',
  'app.pages.managers.logManager.table.query': 'Consulta',
  'app.pages.managers.logManager.table.body': 'Corpo',
  'app.pages.managers.logManager.table.podName': 'Pod',
  'app.pages.managers.logManager.table.memory': 'Memória (MB)',
  'app.pages.managers.logManager.appOrQuery': 'App ou consulta',
  'app.pages.managers.logManager.lastHour': 'Última hora',
  'app.pages.managers.logManager.last24Hours': 'Últimas 24 horas',
  'app.pages.managers.logManager.last7Days': 'Últimos 7 dias',
  'app.pages.managers.logManager.rangeError':
    'Este intervalo é de {range} dias. Escolha até {days} dias.',
  'app.pages.managers.logManager.rangeOrderError': '"Até" deve ser posterior a "De".',
  'app.pages.managers.logManager.empty.title': 'Nenhuma requisição corresponde a estes filtros',
  'app.pages.managers.logManager.empty.hint':
    'Nada foi registrado para esta combinação entre {range}. Tente ampliar o intervalo de datas ou remover algum filtro.',
  'app.pages.managers.logManager.rangeFrom': 'De',
  'app.pages.managers.logManager.rangeTo': 'Até',
  'app.pages.managers.logManager.rangeHelper': 'Até {days} dias',
  'app.pages.managers.logManager.downloadCsv': 'Baixar CSV',
  'app.pages.managers.logManager.filtering': 'Filtrando…',
  'app.pages.managers.logManager.detail.title': 'Detalhes da requisição',
  'app.pages.managers.logManager.detail.properties': 'Propriedades',
  'app.pages.managers.logManager.detail.company': 'Empresa',
  'app.pages.managers.logManager.detail.appVersion': 'Versão do app',
  'app.pages.managers.logManager.detail.noQuery': 'Nenhum parâmetro foi enviado.',
  'app.pages.managers.logManager.detail.noBody': 'Nenhum corpo foi enviado.',
  'app.pages.managers.logManager.detail.clientAndServer': 'Cliente e servidor',
  'app.pages.managers.logManager.detail.ip': 'Endereço IP',
  'app.pages.managers.logManager.detail.browser': 'Navegador',
  'app.pages.managers.logManager.detail.os': 'Sistema operacional',
  'app.pages.managers.logManager.detail.device': 'Dispositivo',
  'app.pages.managers.logManager.detail.sessionDuration': 'Duração da sessão',
  'app.pages.managers.logManager.detail.onlyThisUser': 'Ver apenas as requisições deste usuário',
  'app.pages.managers.instanceLogs': 'Logs de instâncias',
  'app.pages.managers.instanceLogs.userOrInstance': 'Usuário ou id da instância',
  'app.pages.managers.instanceLogs.pleaseSelectLog':
    'Selecione um log da tabela para ver os detalhes',
  'app.pages.managers.instanceLogs.emptyLog': 'Log vazio',
  'app.pages.managers.instanceLogs.copyLog': 'Copiar log',
  'app.pages.managers.instanceLogs.logCopied': 'Log copiado',
  'app.pages.managers.instanceLogs.searchInLogs': 'Buscar em logs',
  'app.pages.managers.instanceLogs.searchInLogs.notFound':
    'Nenhuma correspondência encontrada para: {text}',

  // App documentation
  'app.pages.managers.appDocumentation': 'Documentação',
  'app.pages.managers.appDocumentation.includeInterfaces': 'Incluir interfaces',
  'app.pages.managers.appDocumentation.uploadingDocumentation': 'Carregando documentação',
  'app.pages.managers.appDocumentation.uploadSuccess': 'Documentação carregada com sucesso',
  'app.pages.managers.appDocumentation.includeNodes': 'Incluir nós',
  'app.pages.managers.appDocumentation.generateAutomatically': 'Gerar automaticamente',
  'app.pages.managers.appDocumentation.generating': 'Gerando documentação do aplicativo...',
  'app.pages.managers.appDocumentation.options.title': 'Gerar documentação',
  'app.pages.managers.appDocumentation.options.description':
    'Por padrão, cada interface do aplicativo é documentada. Opcionalmente, restrinja esta execução a um subconjunto de interfaces e/ou adicione instruções extras para o agente documentador.',
  'app.pages.managers.appDocumentation.options.interfaces': 'Interfaces a documentar (opcional)',
  'app.pages.managers.appDocumentation.options.extraInstructions': 'Instruções extras (opcional)',
  'app.pages.managers.appDocumentation.options.extraInstructionsPlaceholder':
    'Ex: foque no módulo de vendas, use um tom formal, pule a seção de resumo...',

  // Documenter agents
  'app.pages.documentation.documentAutomatically': 'Gerar documentação automaticamente',
  'app.pages.documentation.generateDocumentation': 'Gerar documentação',
  'app.pages.documentation.generatingDocumentation': 'Gerando documentação...',
  'common.documentationGenerated': 'Documentação gerada com sucesso',
  'common.documentation.languageRequired':
    'O aplicativo deve ter um idioma padrão configurado para gerar a documentação automaticamente',
  'app.pages.Code.Diagram.ContextMenu.documentNode': 'Documentar nó',
  'app.pages.Code.Diagram.ContextMenu.documentModule': 'Documentar módulo',
  'app.pages.Code.Diagram.ContextMenu.documentSelectedNodes': 'Documentar {count} nós selecionados',
  'app.pages.Code.Diagram.ContextMenu.documentSelectedModules':
    'Documentar {count} módulos selecionados',
  'app.pages.Code.Diagram.documentingSelectedNodes': 'Documentando nós',
  'app.pages.Code.Diagram.documentingSelectedModules': 'Documentando módulos',
  'app.pages.Code.Diagram.ContextMenu.documentOptions': 'Documentar diagrama',
  'app.pages.interfaceManager.htmlInterfaceType': 'HTML',
  'app.pages.interfaceManager.documentAllInterfaces': 'Documentar todas as interfaces',
  'app.pages.interfaceManager.documentingInterfaces': 'Documentando interfaces',
  'app.pages.interfaceManager.documentSelectedInterfaces':
    'Documentar {count} interfaces selecionadas',
  'app.pages.interfaceManager.documentInterface': 'Documentar interface',
  'app.pages.interfaceManager.documentFolderContent': 'Documentar interfaces da pasta',
  'app.pages.interfaceManager.documentSelectedFoldersContent':
    'Documentar conteúdo de {count} pastas selecionadas',
  'app.pages.interfaceManager.documentFolder.scope.direct':
    'Apenas interfaces diretamente na(s) pasta(s) selecionada(s)',
  'app.pages.interfaceManager.documentFolder.scope.recursive':
    'Interfaces na(s) pasta(s) selecionada(s) e em todas as subpastas (recursivo)',
  'app.pages.moduleDocumentation.dialogTitle': 'Documentar módulo',
  'app.pages.moduleDocumentation.dialogTitle.multi': 'Documentar {count} módulos',
  'app.pages.moduleDocumentation.generating':
    'A documentação automática do módulo está sendo gerada. Isso pode levar alguns segundos.',
  'app.pages.moduleDocumentation.generating.multi':
    'A documentação automática de {count} módulos está sendo gerada. Isso pode levar alguns segundos.',
  'app.pages.moduleDocumentation.scope.moduleOnly': 'Apenas o módulo (a partir dos seus nós)',
  'app.pages.moduleDocumentation.scope.moduleAndNodes': 'Módulo e nós internos diretos',
  'app.pages.moduleDocumentation.scope.moduleAndNodesRecursive':
    'Módulo, nós internos e módulos (recursivo)',
  'app.pages.documentation.options.mode.label': 'Como tratar a documentação existente?',
  'app.pages.documentation.options.mode.overwrite': 'Sobrescrever a documentação existente',
  'app.pages.documentation.options.mode.missingOnly': 'Documentar apenas os itens sem documentação',
  'app.pages.documentation.options.scope.label': 'Escopo',
  'app.pages.documentation.error.generic': 'Falha ao gerar a documentação.',
  'app.pages.documentCurrentView.scope.nodesOnly':
    'Apenas os nós diretos desta visualização do diagrama',
  'app.pages.documentCurrentView.scope.includeModules':
    'Nós diretos e os módulos desta visualização do diagrama',
  'app.pages.documentCurrentView.scope.recursive':
    'Nós diretos, módulos e seu conteúdo (recursivo)',

  //Interface toolbar
  'app.pages.interfaces.toolbar.cancel': 'Cancelar',
  'app.pages.interfaces.toolbar.mode': 'Modo',
  'app.pages.interfaces.toolbar.hideMinMaxLabels': 'Ocultar rótulos mínimo e máximo',
  'app.pages.interfaces.toolbar.mode.single': 'Seleção simples',
  'app.pages.interfaces.toolbar.mode.multi': 'Seleção múltipla',
  'app.pages.interfaces.toolbar.format': 'Formato',
  'app.pages.interfaces.toolbar.menu.alignment': 'Alinhamento',
  'app.pages.interfaces.toolbar.format.small': 'Pequeno',
  'app.pages.interfaces.toolbar.format.hidden': 'Oculto',
  'app.pages.interfaces.toolbar.format.range': 'Range',
  'app.pages.interfaces.toolbar.format.select': 'Seleção',
  'app.pages.interfaces.toolbar.format.radio': 'Rádio',
  'app.pages.interfaces.toolbar.format.slider': 'Controle deslizante',
  'app.pages.interfaces.toolbar.format.options_list': 'Lista de opções',
  'app.pages.interfaces.toolbar.format.selectable_chips': 'Fichas selecionáveis',
  'app.pages.interfaces.toolbar.orientation': 'Orientação',
  'app.pages.interfaces.toolbar.orientation.horizontal': 'Horizontal',
  'app.pages.interfaces.toolbar.orientation.vertical': 'Vertical',
  'app.pages.interfaces.toolbar.chartType': 'Tipo de gráfico',
  'app.pages.interfaces.toolbar.chartSubtype': 'Subtipo de gráfico',
  'app.pages.interfaces.toolbar.chartType.bar': 'Barra',
  'app.pages.interfaces.toolbar.chartType.column': 'Coluna',
  'app.pages.interfaces.toolbar.chartType.normal': 'Normal',
  'app.pages.interfaces.toolbar.chartType.stacked': 'Empilhado',
  'app.pages.interfaces.toolbar.chartType.percentStacked': 'Porcentagem empilhado',
  'app.pages.interfaces.toolbar.chartType.line': 'Linha',
  'app.pages.interfaces.toolbar.chartType.linesOnly': 'Só linhas',
  'app.pages.interfaces.toolbar.chartType.linesAndPoints': 'Linhas e pontos',
  'app.pages.interfaces.toolbar.chartType.pointsOnly': 'Só pontos',
  'app.pages.interfaces.toolbar.chartType.pie': 'Pizza',
  'app.pages.interfaces.toolbar.chartType.donut': 'Rosquinha',
  'app.pages.interfaces.toolbar.chartType.sunburst': 'Projeção solar',
  'app.pages.interfaces.toolbar.chartType.area': 'Área',
  'app.pages.interfaces.toolbar.chartType.percent': 'Porcentagem',
  'app.pages.interfaces.toolbar.chartType.scatter': 'Dispersão',
  'app.pages.interfaces.toolbar.chartType.combined': 'Combinado',
  'app.pages.interfaces.toolbar.chartType.scatterWithTrendline': 'Dispersão com linha de tendência',
  'app.pages.interfaces.toolbar.chartType.others': 'Outros',
  'app.pages.interfaces.toolbar.chartType.waterfall': 'Cascata',
  'app.pages.interfaces.toolbar.chartType.funnel': 'Funil',
  'app.pages.interfaces.toolbar.chartType.timeline': 'Linha de tempo',
  'app.pages.interfaces.toolbar.chartType.treemap': 'Mapa de árvore',
  'app.pages.interfaces.toolbar.chartType.icicle': 'Gelo',
  'app.pages.interfaces.toolbar.chartType.funnelArea': 'Área de funil',
  'app.pages.interfaces.toolbar.chartType.histogram': 'Histograma',
  'app.pages.interfaces.toolbar.chartType.box': 'Caixa',
  'app.pages.interfaces.toolbar.chartType.violin': 'Violino',
  'app.pages.interfaces.toolbar.chartType.strip': 'Faixa',
  'app.pages.interfaces.toolbar.chartType.densityHeatmap': 'Mapa de calor de densidade',
  'app.pages.interfaces.toolbar.chartType.densityContour': 'Contorno de densidade',
  'app.pages.interfaces.toolbar.chartType.scatter3d': 'Dispersão 3D',
  'app.pages.interfaces.toolbar.chartType.line3d': 'Linha 3D',
  'app.pages.interfaces.toolbar.chartType.scatterMatrix': 'Matriz de dispersão',
  'app.pages.interfaces.toolbar.chartType.parallelCoordinates': 'Coordenadas paralelas',
  'app.pages.interfaces.toolbar.chartType.parallelCategories': 'Categorias paralelas',
  'app.pages.interfaces.toolbar.chartType.scatterMapbox': 'Mapa de dispersão',
  'app.pages.interfaces.toolbar.chartType.lineMapbox': 'Mapa de linha',
  'app.pages.interfaces.toolbar.chartType.choroplethMapbox': 'Mapa de coropleto',
  'app.pages.interfaces.toolbar.chartType.densityMapbox': 'Mapa de densidade',
  'app.pages.interfaces.toolbar.chartType.scatterPolar': 'Dispersão polar',
  'app.pages.interfaces.toolbar.chartType.linePolar': 'Linha polar',
  'app.pages.interfaces.toolbar.chartType.barPolar': 'Barra polar',
  'app.pages.interfaces.toolbar.chartType.scatterTernary': 'Dispersão ternária',
  'app.pages.interfaces.toolbar.chartType.lineTernary': 'Linha ternária',
  'app.pages.interfaces.toolbar.chartType.groups.basics': 'Básicos',
  'app.pages.interfaces.toolbar.chartType.groups.financial': 'Financeiro',
  'app.pages.interfaces.toolbar.chartType.groups.partOfWhole': 'Parte-de-todo',
  'app.pages.interfaces.toolbar.chartType.groups.1dDistributions': 'Distribuições 1D',
  'app.pages.interfaces.toolbar.chartType.groups.2dDistributions': 'Distribuições 2D',
  'app.pages.interfaces.toolbar.chartType.groups.3dimensional': '3-Dimensional',
  'app.pages.interfaces.toolbar.chartType.groups.multidimensional': 'Multidimensional',
  'app.pages.interfaces.toolbar.chartType.groups.tileMaps': 'Mapas de ladrilhos',
  'app.pages.interfaces.toolbar.chartType.groups.polarCharts': 'Gráficos polares',
  'app.pages.interfaces.toolbar.chartType.groups.ternaryCharts': 'Gráficos ternários',
  'app.pages.interfaces.toolbar.showComponentCode': 'Mostrar código do componente',
  'app.pages.interfaces.toolbar.openComponentCode': 'Abrir código do componente',
  'app.pages.interfaces.toolbar.clearFilters': 'Limpar filtros',
  'app.pages.interfaces.toolbar.componentCodeEditor': 'Editor de código do componente',
  'app.pages.interfaces.toolbar.menuFormat': 'Formato do menu',
  'app.pages.interfaces.toolbar.menuFormat.accordion': 'Acordeão',
  'app.pages.interfaces.toolbar.menuFormat.compact_menu': 'Menu compacto',
  'app.pages.interfaces.toolbar.menuFormat.boxes': 'Caixas',
  'app.pages.interfaces.toolbar.menuFormat.mini': 'Mini',
  'app.pages.interfaces.toolbar.menu.newItem': 'Novo item',
  'app.pages.interfaces.toolbar.menu.newAction': 'Nova ação',
  'app.pages.interfaces.toolbar.menu.addItem': 'Adicionar item do menu',
  'app.pages.interfaces.toolbar.menu.addAction': 'Adicionar ação',
  'app.pages.interfaces.toolbar.menu.removeItem': 'Remover item',
  'app.pages.interfaces.toolbar.menu.removeAction': 'Remover ação',
  'app.pages.interfaces.toolbar.menu.root': 'Raiz',
  'app.pages.interfaces.toolbar.menu.actionType': 'Tipo de ação',
  'app.pages.interfaces.toolbar.menu.navigateTo': 'Navegar para',
  'app.pages.interfaces.toolbar.menu.target': 'Target',
  'app.pages.interfaces.toolbar.menu.customPath': 'Caminho personalizado',
  'app.pages.interfaces.toolbar.menu.manualPath': 'Inserir o caminho manualmente',
  'app.pages.interfaces.toolbar.menu.currentTab': 'Aba atual',
  'app.pages.interfaces.toolbar.menu.newTab': 'Nova aba',
  'app.pages.interfaces.toolbar.menu.expanded': 'Expandido',
  'app.pages.interfaces.toolbar.menu.subtitle': 'Legenda',
  'app.pages.interfaces.toolbar.menu.openInterface': 'Abrir interface',
  'app.pages.interfaces.toolbar.menu.navigate': 'Navegação',
  'app.pages.interfaces.toolbar.menu.textColor': 'Cor do texto',
  'app.pages.interfaces.toolbar.menu.iconColor': 'Cor do ícone',
  'app.pages.interfaces.toolbar.menu.backgroundColor': 'Cor de fundo',
  'app.pages.interfaces.toolbar.menu.hoverColor': 'Cor de hover',
  'app.pages.interfaces.toolbar.menu.textTranslations': 'Traduções de texto',
  'app.pages.interfaces.toolbar.menu.subtitleTranslations': 'Traduções de legenda',
  'app.pages.interfaces.toolbar.menu.customTitleTranslations': 'Traduções de título personalizado',
  'app.pages.interfaces.componentHasCustomCodeMessage':
    'Este componente possui código personalizado, o que pode impedir que certas configurações sejam aplicadas.',
  'app.pages.interfaces.toolbar.openHtmlEditor': 'Abrir editor HTML',
  'app.pages.interfaces.toolbar.openDynamicHtmlEditor': 'Abrir editor HTML dinâmico',
  'app.pages.interfaces.toolbar.dynamicHtmlCustomization': 'Personalização HTML dinâmica',
  'app.pages.interfaces.toolbar.selectSectionToGo': 'Selecione a seção para ir',
  'app.pages.interfaces.toolbar.selectRunAppNode': 'Selecione o nó do aplicativo para executar',
  'app.pages.interfaces.toolbar.openInNewTab': 'Abrir em nova aba',
  'app.pages.interfaces.toolbar.openMenuEditor': 'Abrir editor do menu',
  'app.pages.interfaces.toolbar.autoOpenSingleAction':
    'Abrir automaticamente a única ação disponível',
  'app.pages.interfaces.toolbar.showSearchInput': 'Mostrar campo de pesquisa',
  'app.pages.interfaces.toolbar.exportComponent': 'Exportar componente',
  'app.pages.interfaces.toolbar.fileFormat': 'Formato de arquivo',
  'app.pages.interfaces.toolbar.numberFormat': 'Formato numérico',
  'app.pages.interfaces.toolbar.exportShape': 'Disposição',
  'app.pages.interfaces.toolbar.exportShapeSeen': 'Como aparece',
  'app.pages.interfaces.toolbar.exportShapeList': 'Em lista (uma linha por valor)',
  'app.pages.interfaces.tableSheet.failed': 'Não foi possível baixar a tabela como planilha',
  'app.pages.interfaces.tableSheet.failedBecause':
    'Não foi possível baixar a tabela como planilha: {reason}',
  'app.pages.interfaces.tableSheet.linkedName': '{title} (vinculado)',
  'app.pages.interfaces.tableSheet.openDownloaded': 'Abra o arquivo baixado no Excel',
  'app.pages.interfaces.toolbar.exportIncludeTotals': 'Incluir subtotais e totais',
  'app.pages.interfaces.toolbar.exportKeepFormats': 'Manter formato dos números ($, %, decimais)',
  'app.pages.interfaces.toolbar.columnSeparator': 'Separador de coluna',
  'app.pages.interfaces.toolbar.compressToDownload': 'Compactar arquivo para baixar',
  'app.pages.interfaces.toolbar.excludeNullAndZero': 'Excluir valores zero e nulos',
  'app.pages.interfaces.toolbar.fullNode': 'Nó completo',
  'app.pages.interfaces.toolbar.currentView': 'Visão atual',
  'app.pages.interfaces.toolbar.useTitlesInExport': 'Usar nomes visíveis nas colunas',
  'app.pages.interfaces.toolbar.includeNestedHeaders': 'Incluir todos os níveis de cabeçalho',
  'app.pages.interfaces.toolbar.fileName': 'Nome do arquivo',
  'app.pages.interfaces.toolbar.multiline': 'Multilinha',
  'app.pages.interfaces.toolbar.uppercase': 'Maiúsculas',
  'app.pages.interfaces.toolbar.fixedPositionOnTop': 'Posição fixa no topo',
  'app.pages.interfaces.toolbar.stickyHeader': 'Cabeçalho aderente',
  'app.pages.interfaces.toolbar.openFilterEditor': 'Abrir editor de filtro',
  'app.pages.interfaces.toolbar.visibilityController': 'Controlador de visibilidade',
  'app.pages.interfaces.toolbar.buttonFormat.default': 'Toda a largura',
  'app.pages.interfaces.toolbar.buttonFormat.compact': 'Compacto',
  'app.pages.app.instanceManager.editionAvailable': 'Edição disponível',
  'app.pages.app.instanceManager.processing': 'Processamento',
  'app.pages.app.instanceManager.info': 'Info',
  'app.pages.app.instanceManager.openAppsOnly': 'Só aplicativos abertos',
  'app.pages.app.instanceManager.scheduledTask': 'Tarefa agendada',
  'app.pages.app.instanceManager.hasOpenedBrowser': 'Tem o navegador aberto',
  'app.pages.app.instanceManager.lastUpdate': 'Última atualização: {lastUpdate}',
  'app.pages.app.instanceManager.useOfMemoryAndCPUByPOD': 'Uso de CPU e memória por POD',
  'app.pages.app.instanceManager.restartPodsInfo': 'Limpar dados de uso de CPU/Memória dos Pods',
  'app.pages.app.instanceManager.totalByPod': 'Total por pod',
  'app.pages.interfaces.chart': 'Gráfico',
  'app.pages.interfaces.indicator': 'Indicador',
  'app.pages.interfaces.interfaceDeleted': 'Interface excluída',
  'app.pages.interfaces.folderDeleted': 'Pasta excluída',
  'app.pages.interfaces.interfaceDuplicated': 'Interface duplicada',
  'app.pages.interfaces.folderDuplicated': 'Pasta duplicada',
  'app.pages.interfaces.viewAsChart': 'Ver como gráfico',
  'app.pages.interfaces.viewAsTable': 'Ver como tabela',
  'app.pages.interfaces.defaultInterface': 'Interface padrão',
  'app.pages.interfaces.tooManyComponents':
    'Esta interface contém um grande número de componentes. Considere dividi-la em visualizações menores para melhorar a organização e a manutenibilidade.',
  'app.pages.interfaces.closeAllTabs': 'Fechar todas as abas',
  'app.pages.interfaces.noTabsOpened': 'Não há mais abas abertas',
  'app.pages.interfaces.closeSelectedTab': 'Fechar a guia selecionada',
  'app.pages.interfaces.openTabActions': 'Abrir ações de guia',
  'app.pages.interfaces.compareAllScenarios': 'Comparar cenários em todos os componentes',
  'app.pages.interfaces.openDefaultInterface': 'Abrir interface padrão',
  'app.pages.interfaces.closeAllButThis': 'Fechar abas, exceto a selecionada',
  'app.pages.interfaces.importInterface': 'Importar interfaces ou pastas',
  'app.pages.interfaces.interfaceImportedSuccessfully': 'Importação concluída com sucesso',
  'app.pages.interfaces.exportInterfaceSuccess': 'Interface exportada com sucesso',
  'app.pages.interfaces.exportInterfacesSuccess': 'Interfaces exportadas com sucesso',
  'app.pages.interfaces.exportFolderSuccess': 'Pasta exportada com sucesso',
  'app.pages.interfaces.exportFoldersSuccess': 'Pastas exportadas com sucesso',
  'app.pages.interfaces.interfaceCopied': 'Interface copiada com sucesso',
  'app.pages.interfaces.interfaceMoved': 'Interface movida com sucesso',
  'app.pages.interfaces.deleteFolder': 'Excluir pasta',
  'app.pages.interfaces.deleteInterfaces': 'Excluir interfaces',
  'app.pages.interfaces.folderCopied': 'Pasta copiada com sucesso',
  'app.pages.interfaces.folderMoved': 'Pasta movida com sucesso',
  'app.pages.interfaces.interfacePermissionChanged': 'Permissões de interface alteradas',
  'app.pages.interfaces.htmlPreview': 'Pré-visualização HTML',
  'app.pages.interfaces.attribute': 'Atributo',
  'app.pages.interfaces.attributeValue': 'Valor do atributo',
  'app.pages.interfaces.typeActionValue': 'Valor de tipo de ação',
  'app.pages.interfaces.typeActionValue.modifyTypeActionValue': 'Modificar valor de tipo de ação',
  'app.pages.interfaces.runAppNode': 'Executar nó do aplicativo',
  'app.pages.interfaces.sendHtmlAttributeToNode': 'Enviar atributo HTML para o nó',
  'app.pages.interfaces.attributesFromNode': 'Atributos do nó',
  'app.pages.interfaces.childrenFromNode': 'Filho do nó',
  'app.pages.interfaces.addNodeResultLikeChildren': 'Adicionar resultado do nó como elemento filho',
  'app.pages.interfaces.getAttributesFromNode': 'Obter atributos do nó',
  'app.pages.interfaces.selectNodeToReceiveHtmlAttribute':
    'Selecione o nó que receberá o atributo HTML',
  'app.pages.interfaces.sourceAttribute': 'Atributo HTML',
  'app.pages.interfaces.functionParameter': 'Parâmetro da função',
  'app.pages.interfaces.targetAttribute': 'Atributo de destino',
  'app.pages.interfaces.targetAttributeValue': 'Valor do atributo de destino',
  'app.pages.interfaces.toolbar.runNodeToPreviewResult':
    'Executar nó para pré-visualizar resultado',
  'app.pages.interfaces.toolbar.insertHereYourHtmlCode': 'Insira aqui seu código HTML',
  'app.pages.interfaces.toolbar.previewAvailableAfterTypingCode':
    'Pré-visualização disponível após digitar o código',
  'app.pages.interfaces.toolbar.runPreviewHtml': 'Executar pré-visualização HTML',
  'app.pages.interfaces.htmlEditor.inlineChangedOtherPart': 'O agente alterou apenas a aba {part}.',
  'app.pages.interfaces.toolbar.inputValue.dataType': 'Tipo de dado',
  'app.pages.interfaces.toolbar.inputValue.rule': 'Regra',
  'app.pages.interfaces.toolbar.inputValue.rule.notRange': 'Fora de alcance',
  'app.pages.interfaces.toolbar.inputValue.rule.textLength': 'Comprimento do texto',
  'app.pages.interfaces.toolbar.inputValue.rule.any': 'Qualquer',
  'app.pages.interfaces.toolbar.inputValue.customErrorMessage': 'Mensagem de erro personalizada',

  // Interface pivot
  'app.pages.interfaces.pivot.x': 'X',
  'app.pages.interfaces.pivot.y': 'Y',
  'app.pages.interfaces.pivot.z': 'Z',
  'app.pages.interfaces.pivot.facet_row': 'Linha de facetas',
  'app.pages.interfaces.pivot.facet_column': 'Coluna de facetas',
  'app.pages.interfaces.pivot.text': 'Texto',
  'app.pages.interfaces.pivot.animation_frame': 'Quadro de animação',
  'app.pages.interfaces.pivot.animation_group': 'Grupo de animação',
  'app.pages.interfaces.pivot.error_x': 'Erro X',
  'app.pages.interfaces.pivot.error_x_minus': 'Erro X menos',
  'app.pages.interfaces.pivot.error_y': 'Erro Y',
  'app.pages.interfaces.pivot.error_y_minus': 'Erro Y menos',
  'app.pages.interfaces.pivot.error_z': 'Erro Z',
  'app.pages.interfaces.pivot.error_z_minus': 'Erro Z menos',
  'app.pages.interfaces.pivot.latitude': 'Latitude',
  'app.pages.interfaces.pivot.longitude': 'Longitude',
  'app.pages.interfaces.pivot.r': 'R',
  'app.pages.interfaces.pivot.theta': 'Theta',
  'app.pages.interfaces.pivot.measure_1': 'Medida 1',
  'app.pages.interfaces.pivot.measure_2': 'Medida 2',
  'app.pages.interfaces.pivot.measure_3': 'Medida 3',
  'app.pages.interfaces.pivot.color': 'Cor',
  'app.pages.interfaces.pivot.size': 'Tamanho',
  'app.pages.interfaces.pivot.base': 'Base',
  'app.pages.interfaces.pivot.symbol': 'Símbolo',
  'app.pages.interfaces.pivot.line_group': 'Grupo de linha',
  'app.pages.interfaces.pivot.line_dash': 'Traço de linha',
  'app.pages.interfaces.pivot.pattern_shape': 'Forma padrão',
  'app.pages.interfaces.pivot.dimensions': 'Dimensões',
  'app.pages.interfaces.pivot.locations': 'Localizações',
  'app.pages.interfaces.pivot.names': 'Nomes',
  'app.pages.interfaces.pivot.values': 'Valores',
  'app.pages.interfaces.pivot.x_start': 'X inicial',
  'app.pages.interfaces.pivot.x_end': 'X final',
  'app.pages.interfaces.pivot.path': 'Caminho',
  'app.pages.interfaces.pivot.parents': 'Pais',
  'app.pages.interfaces.pivot.ids': 'IDs',
  'app.pages.interfaces.pivot.chart_type_1': 'Tipo de gráfico 1',
  'app.pages.interfaces.pivot.chart_type_2': 'Tipo de gráfico 2',
  'app.pages.interfaces.pivot.dimension': 'Dimensão',
  'app.pages.interfaces.pivot.measure': 'Medida',
  'app.pages.interfaces.pivot.rows': 'Linhas',
  'app.pages.interfaces.pivot.columns': 'Colunas',
  'app.pages.interfaces.pivot.measures': 'Medidas',
  'app.pages.interfaces.pivot.series': 'Series',
  'app.pages.interfaces.pivot.sum': 'Soma',
  'app.pages.interfaces.pivot.avg': 'Média',
  'app.pages.interfaces.pivot.min': 'Mínimo',
  'app.pages.interfaces.pivot.max': 'Máximo',
  'app.pages.interfaces.pivot.count': 'Contagem',
  'app.pages.interfaces.pivot.': 'Não',
  'app.pages.interfaces.pivot.agg': 'Agregação',
  'app.pages.interfaces.pivot.newMeasure': 'Nova medida',
  'app.pages.interfaces.pivot.newMeasureName': 'Nome da nova medida',
  'app.pages.interfaces.pivot.selectHierarchy': 'Selecionar hierarquia',
  'app.pages.interfaces.pivot.editCalculatedMeasure': 'Editar medida calculada',
  'app.pages.interfaces.pivot.removeCalculatedMeasure': 'Excluir medida calculada',
  'app.pages.interfaces.pivot.removeCalculatedMeasureMessage':
    'Tem certeza de que deseja excluir "{field}"?',
  'app.pages.interfaces.pivot.function': 'Função',
  'app.pages.interfaces.pivot.calculationMode': 'Modo de cálculo',
  'app.pages.interfaces.pivot.histnorm': 'Normalização do histograma',
  'app.pages.interfaces.pivot.box': 'Caixa',
  'app.pages.interfaces.pivot.marginal': 'Marginal',
  'app.pages.interfaces.pivot.calculatedMeasure': 'Medida calculada',
  'app.pages.interfaces.pivot.calculatedItem': 'Item calculado',
  'app.pages.interfaces.pivot.editCalculatedItem': 'Editar item calculado',
  'app.pages.interfaces.pivot.removeCalculatedItem': 'Excluir item calculado',
  'app.pages.interfaces.pivot.removeCalculatedItemMessage':
    'Tem certeza de que deseja excluir "{item}"?',
  'app.pages.interfaces.pivot.itemAlreadyExists': 'O item já existe',
  'app.pages.interfaces.pivot.addSubtotal': 'Adicionar subtotal',
  'app.pages.interfaces.pivot.editSubtotal': 'Editar subtotal',
  'app.pages.interfaces.pivot.removeSubtotal': 'Excluir subtotal',
  'app.pages.interfaces.pivot.addSubtotalFor': 'Adicionar subtotal para',
  'app.pages.interfaces.pivot.editSubtotalFor': 'Editar subtotal para',
  'app.pages.interfaces.pivot.subtotalTypeHierarchical':
    'Hierárquico (baseado na hierarquia completa de linhas)',
  'app.pages.interfaces.pivot.subtotalTypeByElement':
    'Por elemento (um subtotal para cada trecho de valores consecutivos iguais)',
  'app.pages.interfaces.pivot.includeSingleElementSegments': 'Incluir trechos de um único elemento',
  'app.pages.interfaces.pivot.subtotalAggregationMethod': 'Método de agregação',
  'app.pages.interfaces.pivot.sortAscending': 'Ordenar de forma ascendente',
  'app.pages.interfaces.pivot.sortDescending': 'Ordenar de forma descendente',
  'app.pages.interfaces.pivot.removeSorting': 'Excluir ordenação',
  'app.pages.interfaces.pivot.customSortValues': 'Ordenação personalizada de valores',
  'app.pages.interfaces.pivot.sortValuesFor': 'Ordenar valores para',
  'app.pages.interfaces.pivot.resetCustomSort': 'Restaurar ordenação personalizada',
  'app.pages.interfaces.pivot.itemHasCustomSort': 'O item tem um ordenamento personalizado',
  'app.pages.interfaces.pivot.sortByIndexNode': 'Ordenar por nó índice',
  'app.pages.interfaces.pivot.selectIndexNode': 'Selecionar um nó índice',
  'app.pages.interfaces.pivot.noIndexNodesFounded': 'Nenhum nó índice encontrado',
  'app.pages.interfaces.pivot.multiSortTitle': 'Ordem personalizada',
  'app.pages.interfaces.pivot.multiSortOrderBy': 'Ordenar por',
  'app.pages.interfaces.pivot.multiSortThenBy': 'Depois por',
  'app.pages.interfaces.pivot.multiSortAscending': 'Ordem ascendente',
  'app.pages.interfaces.pivot.multiSortDescending': 'Ordem descendente',
  'app.pages.interfaces.pivot.multiSortAddOrder': 'Adicionar ordem',

  //Code widget
  'app.pages.app.code.widget.code.saveAndRun': 'Salvar e Rodar Código',
  'app.pages.app.code.widget.code.formatCode': 'Formatar código',
  'app.pages.app.code.widget.code.viewCodeDifferences': 'Ver diferenças de código',
  'app.pages.app.code.widget.code.hideCodeDifferences': 'Ocultar diferenças de código',
  'app.pages.app.code.widget.code.askAi': 'Perguntar à IA',

  //result widget
  'app.pages.app.code.widget.result.defaultview.saved':
    'A visão padrão do nó foi salva corretamente.',
  'app.pages.app.code.widget.result.notCalculated': 'O nó não é calculado',
  'app.pages.app.code.widget.result.loading': 'Carregando resultados..',
  'app.pages.app.code.widget.code.loading': 'Carregando código..',
  'app.pages.app.code.widget.result.changeToPreviewWidget': 'Mudar para widget de pré-visualização',

  //Preview widget
  'app.pages.app.code.widget.preview.resultType': 'Tipo de resultado',
  'app.pages.app.code.widget.preview.indexes': 'Índices',
  'app.pages.app.code.widget.preview.preview': 'Preview',
  'app.pages.app.code.widget.preview.clickToOpenSparkUI': 'Clique aqui para abrir o Spark UI',
  'app.pages.app.code.widget.preview.sparkui': 'Spark UI',
  'app.pages.app.code.widget.preview.changeToResultWidget': 'Mudar para widget de resultado',
  'app.pages.app.code.widget.preview.getNodePreview': 'Obter pré-visualização do nó',
  'app.pages.app.code.widget.preview.loading': 'Carregando pré-visualização..',
  'app.pages.app.code.widget.preview.noPreview': 'Não há pré-visualização disponível',

  //Console widget
  'app.pages.app.code.widget.console.preserveLog': 'Preservar log',
  'app.pages.app.code.widget.console.clearLogs': 'Limpar logs',
  'app.pages.app.code.widget.console.closeConsole': 'Fechar console',
  'app.pages.app.code.widget.console.showConsole': 'Abrir console',
  'app.pages.app.code.widget.console.clearErrors': 'Apagar erros',
  'app.pages.app.code.widget.console.copyError': 'Copiar erro',
  'app.pages.app.code.widget.console.errorCopied': 'Erro copiado',
  'app.pages.app.code.widget.console.performanceAnalysis': 'Análise de desempenho',
  'app.pages.app.code.widget.console.performance': 'Desempenho',
  'app.pages.app.code.widget.console.percentOfTime': '% do tempo',
  'app.pages.app.code.widget.console.fromDynamic': 'De dynamic',
  'app.pages.app.code.widget.console.maxMemory': 'Memória máxima',
  'app.pages.app.code.widget.console.kind': 'Tipo',
  'app.pages.app.code.widget.console.title': 'Título',
  'app.pages.app.code.widget.console.identifier': 'Identificador',
  'app.pages.app.code.widget.console.kindNode': 'Nó',
  'app.pages.app.code.widget.console.kindComponent': 'Componente',
  'app.pages.app.code.widget.console.kindInterface': 'Interface',
  'app.pages.app.code.widget.console.usedMemory': 'Memória usada',
  'app.pages.app.code.widget.console.processingTime': 'Tempo de processamento',
  'app.pages.app.code.widget.console.enableAnalysis': 'Habilitar análise',
  'app.pages.app.code.widget.console.disableAnalysis': 'Desabilitar análise',
  'app.pages.app.code.widget.console.clearResults': 'Limpar resultados',
  'app.pages.app.code.widget.console.logs': 'Logs',
  'app.pages.app.code.widget.console.resetAppResults': 'Resetar resultados do aplicativo',
  'app.pages.app.code.widget.console.exportPerformanceAnalysisCsv':
    'Exportar análise de desempenho como CSV',
  'app.pages.app.code.widget.console.exportPerformanceAnalysisExcel':
    'Exportar análise de desempenho como Excel',
  'app.pages.app.code.widget.console.performanceAnalysisDownloaded':
    'A análise de desempenho foi baixada',
  'app.pages.app.code.widget.console.performanceAnalysisDownloadError':
    'Não foi possível gerar o arquivo da análise de desempenho',

  //Task manager
  'app.pages.app.taskManager.task': 'Administrador de tarefas',
  'app.pages.app.taskManager.addTaskScheduled': 'Criar tarefa agendada',
  'app.pages.app.taskManager.editTaskScheduled': 'Editar tarefa agendada',
  'app.pages.app.taskManager.createdBy': 'Criado por',
  'app.pages.app.taskManager.executorUser': 'Usuário executor',
  'app.pages.app.taskManager.lastRunAt': 'Última execução às',
  'app.pages.app.taskManager.nextExecution': 'Próxima execução',
  'app.pages.app.taskManager.lastStatus': 'Último status',
  'app.pages.app.taskManager.saveNeedsEveryStep':
    'Complete os campos obrigatórios de todas as etapas antes de salvar',
  'app.pages.app.taskManager.updateMode': 'Modo',
  'app.pages.app.taskManager.updateModeInterval': 'Por intervalo',
  'app.pages.app.taskManager.updateModeLive': 'Live',
  'app.pages.app.taskManager.appPool': 'App pool',
  'app.pages.app.taskManager.schedulerType': 'Tipo de calendário',
  'app.pages.app.taskManager.params': 'Parâmetros',
  'app.pages.app.taskManager.enabled': 'Ativada',
  'app.pages.app.taskManager.showTaskLog': 'Mostrar log da tarefa',
  'app.pages.app.taskManager.addAppPool': 'Criar app pool',
  'app.pages.app.taskManager.interval': 'Intervalo',
  'app.pages.app.taskManager.clocked': 'Cronometrada',
  'app.pages.app.taskManager.taskDeleted': 'Tarefa excluída',
  'app.pages.app.taskManager.deleteTask': 'Excluir tarefa {name}',
  'app.pages.app.taskManager.deleteTaskMessage': 'Tem certeza de que deseja excluir a tarefa?',
  'app.pages.app.taskManager.taskActivated': 'Tarefa ativada',
  'app.pages.app.taskManager.taskDeactivated': 'Tarefa desativada',
  'app.pages.app.taskManager.taskAddedToQueue': 'A tarefa foi adicionada à fila de execução',
  'app.pages.app.taskManager.editAppPool': 'Editar app pool',
  'app.pages.app.taskManager.taskLogs': 'Logs da tarefa',
  'app.pages.app.taskManager.createdAt': 'Criado em',
  'app.pages.app.taskManager.state': 'Status',
  'app.pages.app.taskManager.lastTaskExecutions': 'Última execução da tarefa',
  'app.pages.app.taskManager.runTask': 'Rodar tarefa',
  'app.pages.app.taskManager.runTaskConfirmTitle': 'Rodar tarefa {name}',
  'app.pages.app.taskManager.runTaskConfirmMessage':
    'Tem certeza de que deseja rodar a tarefa {name}?',
  'app.pages.app.taskManager.taskAlreadyRunning': 'A tarefa já está em execução',
  'app.pages.app.taskManager.taskRunningSince':
    'A tarefa já está em execução: foi executada em {date} hs.',
  'app.pages.app.taskManager.removeTaskFromInProgressState':
    'Remover tarefa do estado "em progresso"',
  'app.pages.app.taskManager.taskRemovedFromInProgressState':
    'Tarefa removida do estado "em progresso"',
  'app.pages.app.taskManager.advancedFilters': 'Filtro avançado',
  'app.pages.app.taskManager.taskLogsDetails': 'Detalhes dos logs da tarefa',
  'app.pages.app.taskManager.refreshLogs': 'Atualizar logs',
  'app.pages.app.taskManager.taskDidNotRunYet': 'A tarefa ainda não foi executada',
  'app.pages.app.taskManager.description': 'Descrição',
  'app.pages.app.taskManager.activity': 'Atividade',
  'app.pages.app.taskManager.info': 'Informação',
  'app.pages.app.taskManager.periodicTaskLogNotFound': 'Não há logs da tarefa',
  'app.pages.app.taskManager.success': 'Êxito',
  'app.pages.app.taskManager.failure': 'Falha',
  'app.pages.app.taskManager.maxDateError': 'A data máxima não pode ser anterior à data mínima',
  'app.pages.app.taskManager.minDate': 'Data mínima',
  'app.pages.app.taskManager.maxDate': 'Data máxima',
  'app.pages.app.taskManager.timeZones': 'Fuso horário',
  'app.pages.app.taskManager.clearForm': 'Limpar formulário',
  'app.pages.app.taskManager.insertTheTaskName': 'Inserir o nome da tarefa',
  'app.pages.app.taskManager.disabled': 'Desativada',
  'app.pages.app.taskManager.days': 'Dia',
  'app.pages.app.taskManager.hours': 'Hora',
  'app.pages.app.taskManager.minutes': 'Minuto',
  'app.pages.app.taskManager.seconds': 'Segundos',
  'app.pages.app.taskManager.microseconds': 'Microssegundos',
  'app.pages.app.taskManager.every': 'Cada',
  'app.pages.app.taskManager.period': 'Período',
  'app.pages.app.taskManager.everyPlaceholder': 'Por favor, insira um valor inteiro',
  'app.pages.app.taskManager.appPath': 'Caminho do aplicativo',
  'app.pages.app.taskManager.generalOptions': 'Opções gerais',
  'app.pages.app.taskManager.scheduler': 'Agendador',
  'app.pages.app.taskManager.everyMinute': 'Todos os minutos',
  'app.pages.app.taskManager.minutesPlaceholder': 'Selecione os minutos',
  'app.pages.app.taskManager.everyHour': 'Todas as horas',
  'app.pages.app.taskManager.hoursPlaceholder': 'Selecione as horas',
  'app.pages.app.taskManager.dayMonths': 'Dia do mês',
  'app.pages.app.taskManager.everyDayOfMonths': 'Todos os dias do mês',
  'app.pages.app.taskManager.everyMonths': 'Todos os meses',
  'app.pages.app.taskManager.everyDays': 'Todos os dias',
  'app.pages.app.taskManager.dayMonthsPlaceholder': 'Selecione os dias do mês',
  'app.pages.app.taskManager.months': 'Mês',
  'app.pages.app.taskManager.monthsPlaceholder': 'Selecione os meses',
  'app.pages.app.taskManager.daysPlaceholder': 'Selecione os dias',
  'app.pages.app.taskManager.january': 'Janeiro',
  'app.pages.app.taskManager.february': 'Fevereiro',
  'app.pages.app.taskManager.march': 'Março',
  'app.pages.app.taskManager.april': 'Abril',
  'app.pages.app.taskManager.may': 'Maio',
  'app.pages.app.taskManager.june': 'Junho',
  'app.pages.app.taskManager.july': 'Julho',
  'app.pages.app.taskManager.august': 'Agosto',
  'app.pages.app.taskManager.september': 'Setembro',
  'app.pages.app.taskManager.october': 'Outubro',
  'app.pages.app.taskManager.november': 'Novembro',
  'app.pages.app.taskManager.december': 'Dezembro',
  'app.pages.app.taskManager.monday': 'Segunda-feira',
  'app.pages.app.taskManager.tuesday': 'Terça-feira',
  'app.pages.app.taskManager.wednesday': 'Quarta-feira',
  'app.pages.app.taskManager.thursday': 'Quinta-feira',
  'app.pages.app.taskManager.friday': 'Sexta-feira',
  'app.pages.app.taskManager.saturday': 'Sábado',
  'app.pages.app.taskManager.sunday': 'Domingo',
  'app.pages.app.taskManager.at': 'Às ',
  'app.pages.app.taskManager.on': '{on} ',
  'app.pages.app.taskManager.in': 'de ',
  'app.pages.app.taskManager.pastHour': 'após ',
  'app.pages.app.taskManager.andOn': 'e na ',
  'app.pages.app.taskManager.and': 'e',
  'app.pages.app.taskManager.reset': 'Redefinir',
  'app.pages.app.taskManager.nameIsRequired': 'O nome da tarefa é necessário',
  'app.pages.app.taskManager.nameMaxLength': 'O tamanho máximo do nome é {number} caracteres',
  'app.pages.app.taskManager.schedulerTypeIsRequired': 'O tipo de Agendador é necessário',
  'app.pages.app.taskManager.periodIsRequired': 'Período é necessário',
  'app.pages.app.taskManager.everyIsRequired': 'Intervalo de tempo é necessário',
  'app.pages.app.taskManager.everyMustBeInt': 'Intervalo de tempo deve ser um número inteiro',
  'app.pages.app.taskManager.everyMaxLength': 'Intervalo de tempo não pode ser maior que {number}',
  'app.pages.app.taskManager.clockedIsRequired': 'Hora do relógio é necessária',
  'app.pages.app.taskManager.nodeOrInterfaceIsRequired':
    'Obrigatório: selecione pelo menos um nó ou uma interface. Você pode selecionar ambos.',
  'app.pages.app.taskManager.appPathIsRequired': 'Caminho do aplicativo é necessário',
  'app.pages.app.taskManager.type': 'Tipo',
  'app.pages.app.taskManager.label': 'Rótulo',
  'app.pages.app.taskManager.defaultValue': 'Valores padrão',
  'app.pages.app.taskManager.source': 'Fonte',
  'app.pages.app.taskManager.paramsTable': 'Tabela de parâmetros',
  'app.pages.app.taskManager.noParamsData': 'Não há Parâmetros',
  'app.pages.app.taskManager.select': 'Selecionar',
  'app.pages.app.taskManager.input': 'Entrada',
  'app.pages.app.taskManager.checkbox': 'Caixa de seleção',
  'app.pages.app.taskManager.paramNameIsRequired': 'O nome de Parâmetro é necessário',
  'app.pages.app.taskManager.labelIsRequired': 'Rótulo é necessário',
  'app.pages.app.taskManager.paramNameInvalid':
    'Deve conter letras minúsculas e números. Espaços em branco e travessões não são permitidos',
  'app.pages.app.taskManager.paramNamePlaceholder': 'Insira o nome de Parâmetro',
  'app.pages.app.taskManager.labelPlaceholder': 'Insira o rótulo',
  'app.pages.app.taskManager.defaultValuePlaceholder': 'Insira o Valor padrão',
  'app.pages.app.taskManager.sourcePlaceholder': 'Insira a fonte',
  'app.pages.app.taskManager.taskNameExists': 'O nome de tarefa já existe',
  'app.pages.app.taskManager.taskCreated': 'Tarefa criada',
  'app.pages.app.taskManager.taskUpdated': 'Tarefa atualizada',
  'app.pages.app.taskManager.keepForEveryone': 'Manter para todos',
  'app.pages.app.taskManager.keepForDepartments': 'Manter para os departamentos',
  'app.pages.app.taskManager.keepForUser': 'Manter para o usuário',
  'app.pages.app.taskManager.actionOnDone': 'Ação após a conclusão',
  'app.pages.app.taskManager.status.created': 'Criado',
  'app.pages.app.taskManager.taskFinishedTitle': 'Tarefa agendada finalizada',
  'app.pages.app.taskManager.taskFinishedMessage': '{name} finalizou com status: {status}',
  'app.pages.app.taskManager.status.progress': 'Em progresso',
  'app.pages.app.taskManager.status.info': 'Informação',
  'app.pages.app.taskManager.status.warning': 'Aviso',
  'app.pages.app.taskManager.status.failure': 'Falha',
  'app.pages.app.taskManager.status.failed': 'Falhou',
  'app.pages.app.taskManager.status.retry': 'Tentar novamente',
  'app.pages.app.taskManager.status.success': 'Êxito',
  'app.pages.app.taskManager.status.passed': 'Aprovado',
  'app.pages.app.taskManager.status.revoked': 'Revogado',
  'app.pages.app.taskManager.status.started': 'Iniciado',
  'app.pages.app.taskManager.status.pending': 'Pendente',
  'app.pages.app.taskManager.status.received': 'Recebido',
  'app.pages.app.taskManager.instances': 'Instância',
  'app.pages.app.taskManager.enableInstanceExpire': 'Habilitar instância expira',
  'app.pages.app.taskManager.expireAt': 'Expira às',
  'app.pages.app.taskManager.instanceExpiration': 'Expiração de instâncias',
  'app.pages.app.taskManager.expirationModeNone': 'Não expiram',
  'app.pages.app.taskManager.expirationModeTimeOfDay': 'A uma hora do dia',
  'app.pages.app.taskManager.expirationModeMaxAge': 'Após um período de tempo',
  'app.pages.app.taskManager.expirationModeHelp': 'Como funciona cada modo de expiração',
  'app.pages.app.taskManager.expirationModeNoneHelp':
    'Não expiram: as instâncias ficam no pool até que um usuário as reivindique.',
  'app.pages.app.taskManager.expirationModeTimeOfDayHelp':
    'A uma hora do dia: todas as instâncias são recicladas ao chegar essa hora, todos os dias.',
  'app.pages.app.taskManager.expirationModeMaxAgeHelp':
    'Após um período de tempo: cada instância é reciclada ao completar esse período, contado desde que entrou no pool.',
  'app.pages.app.taskManager.periodMinutes': 'Minutos',
  'app.pages.app.taskManager.periodHours': 'Horas',
  'app.pages.app.taskManager.periodDays': 'Dias',
  'app.pages.app.taskManager.expireAfter': 'Expira após',
  'app.pages.app.taskManager.maxAgePositive': 'Informe um período maior que zero',
  'app.pages.app.taskManager.maxAgeTooShort':
    'As instâncias não podem expirar em menos de {minutes} minutos',
  'app.pages.app.taskManager.sectionPool': 'Pool',
  'app.pages.app.taskManager.sectionCapacity': 'Capacidade',
  'app.pages.app.taskManager.sectionExpiration': 'Expiração',
  'app.pages.app.taskManager.poolEnabled': 'Pool habilitado',
  'app.pages.app.taskManager.instancesHelp': 'Instâncias mantidas prontas',
  'app.pages.app.taskManager.keepForEveryoneHelp':
    'Qualquer usuário da empresa pode reivindicar uma instância',
  'app.pages.app.taskManager.keepForDepartmentsHelp':
    'Qualquer membro dos departamentos escolhidos pode reivindicar uma instância',
  'app.pages.app.taskManager.keepForUserHelp': 'A instância fica reservada para um único usuário',
  'app.pages.app.taskManager.timezoneScopeBoth':
    'Aplica-se à hora de expiração e aos períodos de atividade abaixo',
  'app.pages.app.taskManager.timezoneScopeExpiration': 'Aplica-se à hora de expiração abaixo',
  'app.pages.app.taskManager.timezoneScopePeriods': 'Aplica-se aos períodos de atividade abaixo',
  'app.pages.app.taskManager.summaryTitle': 'Este pool vai',
  'app.pages.app.taskManager.summaryKeepForEveryone':
    'Manter {instances} instâncias prontas para qualquer usuário da empresa',
  'app.pages.app.taskManager.summaryKeepForDepartments':
    'Manter {instances} instâncias prontas para os departamentos escolhidos',
  'app.pages.app.taskManager.summaryKeepForUser':
    'Manter uma instância pronta para o usuário escolhido, a menos que esta versão do aplicativo já esteja aberta para esse usuário',
  'app.pages.app.taskManager.summaryKeepUpToForDepartments':
    'Manter até {instances} instâncias aguardando os departamentos escolhidos',
  'app.pages.app.taskManager.summaryMaxOpenInstances':
    'Parar de criar novas quando houver {max} abertas no total, até que alguém feche uma',
  'app.pages.app.taskManager.maxOpenInstancesEnabled': 'Limitar instâncias abertas',
  'app.pages.app.taskManager.maxOpenInstances': 'Máximo abertas ao mesmo tempo',
  'app.pages.app.taskManager.maxOpenInstancesHelp':
    'Conta as do pool e as que os membros dos departamentos abrem',
  'app.pages.app.taskManager.maxOpenInstancesPositive':
    'O máximo deve ser um número inteiro positivo',
  'app.pages.app.taskManager.maxOpenInstancesBelowInstances':
    'Informe pelo menos o número de instâncias prontas',
  'app.pages.app.taskManager.summaryExpireMaxAge':
    'Reciclar cada instância {age} depois que ela entra no pool',
  'app.pages.app.taskManager.summaryUnitMinutes':
    '{every, plural, one {# minuto} other {# minutos}}',
  'app.pages.app.taskManager.summaryUnitHours': '{every, plural, one {# hora} other {# horas}}',
  'app.pages.app.taskManager.summaryUnitDays': '{every, plural, one {# dia} other {# dias}}',
  'app.pages.app.taskManager.summaryExpireTimeOfDay':
    'Reciclar todas as instâncias às {time}, todos os dias, {timezone}',
  'app.pages.app.taskManager.summaryExpireNever':
    'Nunca reciclar instâncias: ficam até que um usuário as reivindique',
  'app.pages.app.taskManager.summaryActivePeriods': 'Funcionar apenas {periods}, {timezone}',
  'app.pages.app.taskManager.summaryPeriodShape': '{days}, de {from} até {to}',
  'app.pages.app.taskManager.summaryPeriodCount': '{count} períodos',
  'app.pages.app.taskManager.summaryTakenDownOutside': 'Desligar o pool fora desses horários',
  'app.pages.app.taskManager.summaryAlwaysOn': 'Funcionar o dia inteiro, todos os dias',
  'app.pages.app.taskManager.activePeriodsEnabled': 'Limitar a períodos de atividade',
  'app.pages.app.taskManager.activePeriodsHelp':
    'Fora desses períodos o pool é desligado e nenhuma instância nova é criada',
  'app.pages.app.taskManager.timezone': 'Fuso horário',
  'app.pages.app.taskManager.activePeriodFrom': 'De',
  'app.pages.app.taskManager.activePeriodTo': 'Até',
  'app.pages.app.taskManager.activePeriodCrossesMidnight': 'Cruza a meia-noite',
  'app.pages.app.taskManager.addActivePeriod': 'Adicionar período',
  'app.pages.app.taskManager.removeActivePeriod': 'Remover período',
  'app.pages.app.taskManager.activePeriodsRequired': 'Adicione ao menos um período',
  'app.pages.app.taskManager.activePeriodDaysRequired': 'Escolha ao menos um dia',
  'app.pages.app.taskManager.activePeriodSameBounds':
    'O início e o fim não podem ser o mesmo horário',
  'app.pages.app.taskManager.selectModelFIle': 'Selecione o arquivo do modelo',
  'app.pages.app.taskManager.node': 'Nó',
  'app.pages.app.taskManager.noNodesFounded': 'Não existem nós',
  'app.pages.app.taskManager.clockedWithTz': 'Cronometrada UTC {tz}',
  'app.pages.app.taskManager.appPoolCreated': 'App pool criada',
  'app.pages.app.taskManager.appPoolUpdated': 'App pool atualizada',
  'app.pages.app.taskManager.actionIsRequired': 'Ação após a conclusão é necessária',
  'app.pages.app.taskManager.instancesPositive':
    'O valor das instâncias deve ser um número positivo',
  'app.pages.app.taskManager.instancesIsRequired': 'Instâncias são necessárias',
  'app.pages.app.taskManager.departmentsAreRequired': 'Selecione pelo menos um departamento',
  'app.pages.app.taskManager.userIsRequired': 'O usuário é necessário',
  'app.pages.app.taskManager.users': 'Usuário',
  'app.pages.app.taskManager.usersPlaceholder': 'Selecione um usuário',
  'app.pages.app.taskManager.timezoneIsRequired': 'Fuso horário é necessário',
  'app.pages.app.taskManager.noTasksFound': 'Nenhuma tarefa encontrada',
  'app.pages.app.taskManager.taskUser': 'Usuário da tarefa',
  'app.pages.app.taskManager.systemTask': 'Sistema',
  'app.pages.app.taskManager.noPermissionsToListTasks':
    'Você não tem permissões suficientes para listar tarefas agendadas',
  'app.pages.app.taskManager.resources': 'Recursos',
  'app.pages.app.taskManager.instanceTimeoutInSeconds': 'Tempo limite da instância em segundos',
  'app.pages.app.taskManager.minTimeRequiredMessage': 'O tempo mínimo necessário é de 120 segundos',
  'app.pages.app.taskManager.useDepartment': 'Recursos do departamento',
  'app.pages.app.taskManager.taskId': 'Id da tarefa',
  'app.pages.app.taskManager.scheduleParams': 'Parâmetros do agendamento',
  'app.pages.app.taskManager.taskParams': 'Parâmetros da tarefa',
  'app.pages.app.taskManager.notificationUsers': 'Usuários a notificar',
  'app.pages.app.taskManager.scheduleId': 'Id do agendamento',
  'app.pages.app.taskManager.currentAppOnly': 'Apenas deste aplicativo',
  'app.pages.app.taskManager.showSearch': 'Mostrar busca',
  'app.pages.app.taskManager.hideDisabledTasks': 'Ocultar tarefas desativadas',
  'app.pages.app.taskManager.automaticUpdate': 'Atualização automática',
  'app.pages.app.taskManager.automaticallyUpdate': 'Atualizar automaticamente',
  'app.pages.app.taskManager.automaticUpdateEverySeconds': 'A cada (segundos)',
  'app.pages.app.taskManager.showSystemTasks': 'Mostrar tarefas do sistema',
  'app.pages.app.taskManager.viewResources': 'Ver recursos',
  'app.pages.app.taskManager.manual': 'Manual',
  'app.pages.app.taskManager.emailNotificationMode': 'Modo de notificação por email',
  'app.pages.app.taskManager.emailNotificationAlways': 'Enviar emails sempre',
  'app.pages.app.taskManager.emailNotificationOnFailure': 'Enviar emails apenas em caso de falha',
  'app.pages.app.taskManager.emailNotificationOnSuccess': 'Enviar emails apenas em caso de sucesso',

  //Running node
  'app.pages.app.runningNodeModel.runningNode': 'Nó rodando',
  'app.pages.app.runningNodeModel.stopping': 'Parando',
  'app.pages.app.runningNodeModel.stuckTitle':
    'O aplicativo não respondeu à solicitação de parada.',
  'app.pages.app.runningNodeModel.stuckMessage': 'Escolha uma ação ou continue aguardando:',
  'app.pages.app.runningNodeModel.stuckOption1': 'Salvar alterações e forçar parada (recomendado)',
  'app.pages.app.runningNodeModel.stuckOption2':
    'Forçar parada (alterações não salvas podem ser perdidas)',
  'app.pages.app.runningNodeModel.forceStop': 'Forçar parada',
  'app.pages.app.runningNodeModel.saveAndForceStop': 'Salvar alterações e forçar parada',
  'app.pages.app.runningNodeModel.phaseKilling': 'Fechando instância...',
  'app.pages.app.runningNodeModel.phaseCreating': 'Criando nova instância...',
  'app.pages.app.runningNodeModel.phaseOpening': 'Abrindo aplicativo...',

  //Assets recovery
  'app.pages.app.assetsRecovery.brokenTitle': 'O aplicativo não pôde ser reaberto corretamente',
  'app.pages.app.assetsRecovery.brokenMessage':
    'Foi detectado um problema ao reabrir o aplicativo. É possível que faltem o menu, as interfaces ou as regras de negócio.',
  'app.pages.app.assetsRecovery.brokenInstructions':
    'Você pode tentar recuperá-lo a partir do último backup, ou ir ao FileManager: procure uma pasta chamada "assets_old#..." ao lado da pasta da versão do aplicativo e renomeie-a para "assets" para restaurar manualmente o último backup. Se não tiver certeza de como fazer isso, entre em contato com um responsável antes de fazer mais alterações.',
  'app.pages.app.assetsRecovery.recoverFromBackupButton': 'Recuperar do backup',
  'app.pages.app.assetsRecovery.goToFileManagerButton': 'Ir ao FileManager',

  //Saving app
  'app.pages.savingApp.savingApp': 'Salvando o aplicativo',

  //Interface Manager
  'app.pages.interfaceManager': 'Administrador de interfaces',
  'app.pages.interfaceManager.newInterface': 'Nova interface',
  'app.pages.interfaceManager.createNewInterface': 'Criar nova interface',
  'app.pages.interfaceManager.editInterface': 'Editar interface',
  'app.pages.interfaceManager.createNewFolder': 'Criar nova pasta',
  'app.pages.interfaceManager.name': 'Nome da interface',
  'app.pages.interfaceManager.interfaceType': 'Tipo de interface',
  'app.pages.interfaceManager.interfaceType.dragDrop': 'Interface de componentes',
  'app.pages.interfaceManager.interfaceType.dragDropHint':
    'Dashboard drag-and-drop composto por componentes do Pyplan (tabelas, gráficos, seletores, formulários).',
  'app.pages.interfaceManager.interfaceType.html': 'Interface HTML',
  'app.pages.interfaceManager.interfaceType.htmlHint':
    'HTML/JS personalizado em página inteira renderizado em um iframe sandboxed, com callbacks Python.',
  'app.pages.interfaceManager.emptyHtml.title': 'O que você quer construir?',
  'app.pages.interfaceManager.emptyHtml.subtitle':
    'Descreva o dashboard ou a UI que você tem em mente. O agente Developer vai gerar o HTML e o código Python para esta interface.',
  'app.pages.interfaceManager.emptyHtml.placeholder':
    'ex. "Uma tabela de vendas por região com um gráfico de barras ao lado"',
  'app.pages.interfaceManager.emptyHtml.send': 'Enviar para o Developer',
  'app.pages.interfaceManager.folderName': 'Nome da pasta',
  'app.pages.interfaceManager.deleteInterface': 'Excluir interfaces',
  'app.pages.interfaceManager.deleteFolder': 'Excluir pasta',
  'app.pages.interfaceManager.deleteInterfaceConfirmationText':
    'Tem certeza de que deseja excluir esta interface permanentemente?',
  'app.pages.interfaceManager.deleteFolderConfirmationText':
    'Tem certeza de que deseja excluir permanentemente esta pasta e todo o seu conteúdo?',
  'app.pages.interfaceManager.myInterfaces': 'Minhas interfaces',
  'app.pages.interfaceManager.noInterfaces':
    'Não há interfaces disponíveis. Crie uma usando o botão Criar',
  'app.pages.interfaceManager.deniedFor': 'Negado para',
  'app.pages.interfaceManager.allowedFor': 'Permitido para',
  'app.pages.interfaceManager.deniedForDetail': 'Negar acesso a',
  'app.pages.interfaceManager.slashNotAllowed':
    'Caractere inválido. "/" não permitido para o nome da interface',
  'app.pages.interfaceManager.interfaceNameRepeated': 'O nome da interface já existe',
  'app.pages.interfaceManager.removeDocumentation': 'Remover documentação',
  'app.pages.interfaceManager.removeDocumentationConfirm': 'Você quer remover a documentação?',
  'app.pages.interfaceManager.shareInterface': 'Compartilhar interface',
  'app.pages.interfaceManager.interfaceLinkCopied': 'Link da interface copiado',
  'app.pages.interfaceManager.copyInterfaceLink': 'Copiar link da interface',
  'app.pages.interfaceManager.interfaceLink': 'Link da interface',
  'app.pages.interfaceManager.interfacesLinks': 'Links de interfaces',
  'app.pages.interfaceManager.interfacesLinks.notFound': 'Nenhum link de interface encontrado',
  'app.pages.interfaceManager.activateInterfaceEndpoint': 'Ativar interface endpoint',
  'app.pages.interfaceManager.updateInterfaceLink': 'Atualizar link da interface',
  'app.pages.interfaceManager.interfaceLinkUpdated': 'Link da interface atualizado com sucesso',
  'app.pages.interfaceManager.deleteInterfaceLink': 'Excluir link da interface: {interfaceName}',
  'app.pages.interfaceManager.deleteInterfaceLinkConfirmation':
    'Tem certeza de que deseja excluir este link?',
  'app.pages.interfaceManager.interfaceLinkDeleted': 'Link da interface excluído com sucesso',
  'app.pages.interfaceManager.folderNameExists': 'O nome da pasta já existe',
  'app.pages.externalLink.customEndpointExists': 'O endpoint personalizado já existe',
  'app.pages.externalLink.passwordRequiredDescription': 'Por favor insira a senha para continuar',
  'app.pages.externalLink.hasPassword': 'Tem senha',
  'app.pages.externalLink.requirePassword': 'Requer senha',
  'app.pages.interfaceManager.basicInformation': 'Informação básica',

  //File manager
  'app.pages.FileManagerPage.download': 'Baixar',
  'app.pages.FileManagerPage.zipIt': 'Zipar',
  'app.pages.FileManagerPage.copyIn': 'Copiar',
  'app.pages.FileManagerPage.archive': 'Arquivo',
  'app.pages.FileManagerPage.denyAccess': 'Negar acesso',
  'app.pages.FileManagerPage.folder': 'Pasta',
  'app.pages.FileManagerPage.selectAll': 'Selecionar tudo',
  'app.pages.FileManagerPage.unSelectAll': 'Desmarcar tudo',
  'app.pages.FileManagerPage.models': 'Modelos (.ppl)',
  'app.pages.FileManagerPage.csv': 'CSV {extension}',
  'app.pages.FileManagerPage.templates': 'Documentos(.xls,.xlsx,.xlsm)',
  'app.pages.FileManagerPage.database': 'Banco de dados {extension}',
  'app.pages.FileManagerPage.modules': 'Módulos (.ppm)',
  'app.pages.FileManagerPage.interfaces': 'Interfaces',
  'app.pages.FileManagerPage.zipFiles': 'Arquivo Zip {extension}',
  'app.pages.FileManagerPage.jsonFiles': 'Arquivo Json {extension}',
  'app.pages.FileManagerPage.backup': 'Cópia de segurança (.old)',
  'app.pages.FileManagerPage.others': 'Outros',
  'app.pages.FileManagerPage.showHidden': 'Mostrar arquivos/pastas escondidas',
  'app.pages.FileManagerPage.filterBy': 'Filtrar por',
  'app.pages.FileManagerPage.model': 'Modelo',
  'app.pages.FileManagerPage.file': 'Arquivo',
  'app.pages.FileManagerPage.type': 'Tipo',
  'app.pages.FileManagerPage.location': 'Localização',
  'app.pages.FileManagerPage.opened': 'Aberto',
  'app.pages.FileManagerPage.size': 'Tamanho',
  'app.pages.FileManagerPage.getSize': 'Calcular tamanho',
  'app.pages.FileManagerPage.date': 'Data',
  'app.pages.FileManagerPage.access': 'Acesso',
  'app.pages.FileManagerPage.fileName': 'Nome de arquivo',
  'app.pages.FileManagerPage.folders': 'Pastas',
  'app.pages.FileManagerPage.files': 'Arquivos',
  'app.pages.FileManagerPage.root': 'Raiz',
  'app.pages.FileManagerPage.listView': 'Exibição de lista',
  'app.pages.FileManagerPage.mosaicView': 'Visualização em mosaico',
  'app.pages.FileManagerPage.folderEmpty': 'A pasta está vazia',
  'app.pages.FileManagerPage.denyAccessTo': 'Negar acesso',
  'app.pages.FileManagerPage.allowAccessTo': 'Permitir acesso',
  'app.pages.FileManagerPage.allowAccessOnlyTo': 'Permitir acesso somente a',
  'app.pages.FileManagerPage.folderExceptions': 'Exceções',
  'app.pages.FileManagerPage.folderExceptionsHint':
    'A restrição se aplica a todas as pastas chamadas "{folder}", exceto os caminhos listados abaixo.',
  'app.pages.FileManagerPage.folderExceptionsHintAllowOnly':
    'Os departamentos escolhidos podem ver todas as pastas chamadas {folder}, exceto os caminhos listados abaixo, que ficam restritos para todos.',
  'app.pages.FileManagerPage.noFolderExceptions':
    'Sem exceções: a restrição se aplica em todos os lugares.',
  'app.pages.FileManagerPage.folderExceptionMissing':
    'Esta pasta não existe mais, então a exceção não se aplica e a pasta está restrita novamente. Remova-a ou adicione o novo caminho.',
  'app.pages.FileManagerPage.addFolderException': 'Adicionar exceção para "{folder}"',
  'app.pages.FileManagerPage.pickFolderExceptionHint':
    'Escolha a pasta que deve continuar acessível. Somente pastas chamadas "{folder}" podem ser selecionadas.',
  'app.pages.FileManagerPage.exceptionMustMatchFolderName':
    'Essa pasta não se chama "{folder}", então a exceção nunca se aplicaria. Escolha uma pasta com esse nome exato.',
  'app.pages.FileManagerPage.exceptionAlreadyAdded': 'Esse caminho já está na lista.',
  'app.pages.FileManagerPage.addException': 'Adicionar exceção',
  'app.pages.FileManagerPage.selectedFolderException': 'Pasta selecionada:',
  'app.pages.FileManagerPage.noFolderSelected': 'nenhuma ainda',
  'app.pages.FileManagerPage.deletedMessage': '{name} excluído',
  'app.pages.FileManagerPage.wantToDeleteFolder': 'Tem certeza de que deseja excluir a pasta?',
  'app.pages.FileManagerPage.wantToDeleteFile': 'Tem certeza de que deseja excluir o arquivo?',
  'app.pages.FileManagerPage.deletedTitle': 'Excluir {name}',
  'app.pages.FileManagerPage.deleteFileTitle': 'Excluir arquivo',
  'app.pages.FileManagerPage.deleteFilesTitle': 'Excluir arquivos',
  'app.pages.FileManagerPage.deleteFolderTitle': 'Excluir pasta',
  'app.pages.FileManagerPage.deleteFoldersTitle': 'Excluir pastas',
  'app.pages.FileManagerPage.deleteFilesAndFoldersTitle': 'Excluir arquivos/pastas',
  'app.pages.FileManagerPage.wantToZipFile': 'Tem certeza de que deseja comprimir o arquivo?',
  'app.pages.FileManagerPage.zipFile': 'Comprimir {name}',
  'app.pages.FileManagerPage.unZipFile': 'Descomprimir {name}',
  'app.pages.FileManagerPage.fileZipped': '{name} comprimido',
  'app.pages.FileManagerPage.fileUnZipped': '{name} descomprimido',
  'app.pages.FileManagerPage.nodeChanged': 'Nome alterado para {name}',
  'app.pages.FileManagerPage.wantToUnZipFile': 'Tem certeza de que deseja descomprimir o arquivo?',
  'app.pages.FileManagerPage.unzip': 'Descomprimir',
  'app.pages.FileManagerPage.move': 'Mover',
  'app.pages.FileManagerPage.fileCloned': '{name} duplicado',
  'app.pages.FileManagerPage.createFolderTitle': 'Definir nome de pasta',
  'app.pages.FileManagerPage.folderCreated': 'Pasta criada',
  'app.pages.FileManagerPage.createFileTitle': 'Definir nome de arquivo',
  'app.pages.FileManagerPage.fileCreated': 'Arquivo criado',
  'app.pages.FileManagerPage.creatingFile': 'Criando arquivo',
  'app.pages.FileManagerPage.folderName': 'Nome de pasta',
  'app.pages.FileManagerPage.deletedFilesMessage': 'Arquivos ou pastas excluídos',
  'app.pages.FileManagerPage.copyFileIn': 'Copiar {name} em',
  'app.pages.FileManagerPage.upload': 'Upload',
  'app.pages.FileManagerPage.wantToDelete': 'Tem certeza de que deseja excluir:',
  'app.pages.FileManagerPage.duplicatedFiles': 'Arquivos duplicados',
  'app.pages.FileManagerPage.zipTitle': 'Comprimir arquivos',
  'app.pages.FileManagerPage.wantToZipFileS':
    'Tem certeza de que deseja comprimir os arquivos selecionados?',
  'app.pages.FileManagerPage.departmentsRestrictions': 'Departamento/s restrito',
  'app.pages.FileManagerPage.folderNameError':
    'O nome da pasta é obrigatório e não pode estar vazio.',
  'app.pages.FileManagerPage.folderNameErrorSlash': 'O nome da pasta não pode ter barra',
  'app.pages.FileManagerPage.newNameIsRequired': 'O nome é obrigatório e não pode estar vazio.',
  'app.pages.FileManagerPage.filesUploaded': 'Arquivos carregados',
  'app.pages.FileManagerPage.filesZipped': 'Arquivos compactados',
  'app.pages.FileManagerPage.zippingFiles': 'Compactando arquivos',
  'app.pages.FileManagerPage.filesToCopy': 'Arquivos para copiar',
  'app.pages.FileManagerPage.pasteHere': 'Colar aqui',
  'app.pages.FileManagerPage.pleaseSelectAFile':
    'Selecione um arquivo ou uma pasta e você vai ver seus detalhes aqui.',
  'app.pages.FileManagerPage.filesCopied': 'Arquivos copiados',
  'app.pages.FileManagerPage.filesMoved': 'Arquivos movidos',
  'app.pages.FileManagerPage.filesDownloaded': 'Arquivos baixados',
  'app.pages.FileManagerPage.copyCompletedSuccessfully': 'Cópia concluída com sucesso',
  'app.pages.FileManagerPage.moveCompletedSuccessfully': 'Movimentação concluída com sucesso',
  'app.pages.FileManagerPage.fileOperationCompletedSuccessfully':
    'Operação de arquivo concluída com sucesso',
  'app.pages.FileManagerPage.fileOperationFailed': 'A operação de arquivo falhou',
  'app.pages.FileManagerPage.fileOperationError': 'Ocorreu um erro durante a operação de arquivo',
  'app.pages.FileManagerPage.fileOperationInactivityTimeout':
    'A operação ainda está em andamento, mas não recebemos atualizações de progresso por muito tempo.',
  'app.pages.FileManagerPage.copySourceChanged':
    'Não foi possível concluir a cópia porque o aplicativo estava sendo salvo enquanto era copiado. Tente novamente em alguns minutos.',
  'app.pages.FileManagerPage.fileOperationStatusUnreachable':
    'O status da operação está temporariamente indisponível. Aguarde um momento e tente novamente.',
  'app.pages.FileManagerPage.uploading': 'Enviando...',
  'app.pages.FileManagerPage.uploaded': 'Carregado!',
  'app.pages.FileManagerPage.compressing': 'Comprimindo...',
  'app.pages.FileManagerPage.unzipping': 'Descompactando...',
  'app.pages.FileManagerPage.duplicating': 'Duplicando...',
  'app.pages.FileManagerPage.loadingLastPath': 'Carregando o último caminho..',
  'app.pages.FileManagerPage.uploadCancelled': 'Upload cancelado pelo usuário',
  'app.pages.FileManagerPage.deleting': 'Excluindo',
  'app.pages.FileManagerPage.creating': 'Criando a pasta',
  'app.pages.FileManagerPage.pastingFiles': 'Colando arquivos',
  'app.pages.FileManagerPage.configuringAccess': 'Configurando acesso',
  'app.pages.FileManagerPage.downloading': 'Baixando...',
  'app.pages.FileManagerPage.downloadReady': 'Download pronto',
  'app.pages.FileManagerPage.errorDownloading': 'Houve um erro ao baixar o arquivo',
  'app.pages.FileManagerPage.duplicateTitle': 'Duplicar {name}',
  'app.pages.FileManagerPage.wantToDuplicate':
    'Tem certeza de que deseja duplicar os arquivos selecionados?',
  'app.pages.FileManagerPage.dragDropFilesHere': 'Arraste e solte arquivos aqui ou',
  'app.pages.FileManagerPage.overWriteFileOrFolder': 'Substituir arquivo ou pasta',
  'app.pages.FileManagerPage.overWriteFileOrFolderMessage':
    'Tem certeza de que deseja substituir {name}?',
  'app.pages.FileManagerPage.clearClipboard': 'Esvaziar área de transferência',
  'app.pages.FileManagerPage.clipboardCleared': 'Área de transferência vazia',
  'app.pages.FileManagerPage.copyToWorkspaceTitle': 'Copiar para o espaço de trabalho',
  'app.pages.FileManagerPage.copyToWorkspaceMessage':
    'Tem certeza de que deseja copiar {name} para o seu espaço de trabalho?',
  'app.pages.FileManagerPage.copyingToWorkspace': 'Copiando para o espaço de trabalho',
  'app.pages.FileManagerPage.copiedToWorkspace': 'Copiado para o espaço de trabalho',
  'app.pages.FileManagerPage.openTextEditor': 'Abrir editor de texto',
  'app.pages.FileManagerPage.loadingFile': 'Carregando arquivo',
  'app.pages.FileManagerPage.savingFile': 'Salvando arquivo',
  'app.pages.FileManagerPage.fileSaved': 'Arquivo salvo',
  'app.pages.FileManagerPage.fileTooLargeToRead':
    'Arquivo muito grande para ler. Tamanho máximo: 1MB',
  'app.pages.FileManagerPage.copyUrl': 'Copiar url',
  'app.pages.FileManagerPage.urlCopied': 'URL copiado',
  'app.pages.FileManagerPage.errorUploading': 'Ocorreu um erro ao carregar o arquivo',
  'app.pages.FileManagerPage.errorUploadingFiles':
    'Não foi possível carregar os seguintes arquivos:',
  'app.pages.FileManagerPage.copyPath': 'Copiar caminho',
  'app.pages.FileManagerPage.goToContainingFolder': 'Ir para a pasta que o contém',
  'app.pages.FileManagerPage.pathCopied': 'Caminho copiado',
  'app.pages.FileManagerPage.copyingFiles': 'Copiando arquivos',
  'app.pages.FileManagerPage.movingFiles': 'Movendo arquivos',
  'app.pages.FileManagerPage.preparingDownload': 'Preparando download',
  'app.pages.FileManagerPage.processingFiles': 'Processando arquivos',

  //Actions (for logManager filter)
  'app.pages.managers.logManager.actions.openApp': 'Abrir aplicativo',
  'app.pages.managers.logManager.actions.navigateDiagram': 'Navegar diagrama',
  'app.pages.managers.logManager.actions.getArrows': 'Obter setas',
  'app.pages.managers.logManager.actions.getToolbars': 'Obter toolbars',
  'app.pages.managers.logManager.actions.lastOpenApps': 'Últimos aplicativos abertos',
  'app.pages.managers.logManager.actions.changeToOtherInstance':
    'Mudar para outra instância de modelo',
  'app.pages.managers.logManager.actions.getNodeProperties': 'Obter propriedades do nó',
  'app.pages.managers.logManager.actions.setNodeProperties': 'Definir propriedades do nó',
  'app.pages.managers.logManager.actions.setNodesProperties': 'Definir propriedades de nós',
  'app.pages.managers.logManager.actions.getNodeInputs': 'Obter entradas de nó',
  'app.pages.managers.logManager.actions.getNodeOutputs': 'Obter saídas de nó',
  'app.pages.managers.logManager.actions.searchNodes': 'Procurar nós',
  'app.pages.managers.logManager.actions.searchForAutocomplete': 'Procurar por autocomplete',
  'app.pages.managers.logManager.actions.previewNode': 'Pré-visualizar nó',
  'app.pages.managers.logManager.actions.getSelector': 'Obter seletor',
  'app.pages.managers.logManager.actions.setNodesSize': 'Definir o tamanho do nó',
  'app.pages.managers.logManager.actions.setNodesPosition': 'Definir a posição do nó',
  'app.pages.managers.logManager.actions.getNodeProfile': 'Obter perfil de nó',
  'app.pages.managers.logManager.actions.createNode': 'Criar nó',
  'app.pages.managers.logManager.actions.deleteNodes': 'Excluir nós',
  'app.pages.managers.logManager.actions.createAlias': 'Criar alias',
  'app.pages.managers.logManager.actions.createInputNode': 'Criar nó de entrada',
  'app.pages.managers.logManager.actions.copyNodes': 'Copiar nós',
  'app.pages.managers.logManager.actions.copyAsValues': 'Copiar como valores',
  'app.pages.managers.logManager.actions.moveNodes': 'Mover nós',
  'app.pages.managers.logManager.actions.stop': 'Parar',
  'app.pages.managers.logManager.actions.setNodeZ': 'Definir Z do nó',
  'app.pages.managers.logManager.actions.setNodeIdFromTitle':
    'Definir o id do nó a partir do título',
  'app.pages.managers.logManager.actions.executeForRefresh': 'Executar para atualizar',
  'app.pages.managers.logManager.actions.exportFlatNode': 'Exportar nó plano',
  'app.pages.managers.logManager.actions.exportCurrentNode': 'Exportar o nó atual',
  'app.pages.managers.logManager.actions.exportModuleToFile': 'Exportar módulo para arquivo',
  'app.pages.managers.logManager.actions.importModuleFromFile': 'Importar módulo de arquivo',
  'app.pages.managers.logManager.actions.getFilesForImportWizard':
    'Obter arquivos do assistente de importação',
  'app.pages.managers.logManager.actions.callWizard': 'Chamar o assistente',
  'app.pages.managers.logManager.actions.executeButton': 'Executar botão',
  'app.pages.managers.logManager.actions.isInBackground': 'Está em segundo plano',
  'app.pages.managers.logManager.actions.uploadFileToTemp': 'Fazer upload do arquivo para temp',
  'app.pages.managers.logManager.actions.installLibrary': 'Instalar biblioteca',
  'app.pages.managers.logManager.actions.listInstalledLibraries': 'Listar bibliotecas instaladas',
  'app.pages.managers.logManager.actions.uninstallLibrary': 'Desinstalar biblioteca',
  'app.pages.managers.logManager.actions.getInstallProgress': 'Obter progresso de instalação',
  'app.pages.managers.logManager.actions.getMainFolders': 'Obter pastas principais',
  'app.pages.managers.logManager.actions.getFiles': 'Obter arquivos',
  'app.pages.managers.logManager.actions.createFolder': 'Criar pasta',
  'app.pages.managers.logManager.actions.copyFileOrFolder': 'Copiar arquivo ou pasta',
  'app.pages.managers.logManager.actions.renameFile': 'Renomear arquivo',
  'app.pages.managers.logManager.actions.duplicateFiles': 'Duplicar arquivos',
  'app.pages.managers.logManager.actions.moveFiles': 'Mover arquivos',
  'app.pages.managers.logManager.actions.copyFiles': 'Copiar arquivos',
  'app.pages.managers.logManager.actions.deleteFiles': 'Excluir arquivos',
  'app.pages.managers.logManager.actions.upload': 'Fazer upload',
  'app.pages.managers.logManager.actions.unzipFile': 'Descompactar arquivo',
  'app.pages.managers.logManager.actions.zipFiles': 'Zipar arquivos',
  'app.pages.managers.logManager.actions.getHome': 'Obter o início',
  'app.pages.managers.logManager.actions.optimizeTemplates': 'Otimizar modelos',
  'app.pages.managers.logManager.actions.myReports': 'Meus relatórios',
  'app.pages.managers.logManager.actions.sharedWithMe': 'Relatórios compartilhados comigo',
  'app.pages.managers.logManager.actions.mySharedReports': 'Meus relatórios compartilhados',
  'app.pages.managers.logManager.actions.reportManager': 'Endpoint de relatórios',
  'app.pages.managers.logManager.actions.getNavigator': 'Relatórios - Obter navegador',
  'app.pages.managers.logManager.actions.bulkDelete': 'Relatórios - Excluir em massa',
  'app.pages.managers.logManager.actions.changeOrder': 'Relatórios - Alterar ordem',
  'app.pages.managers.logManager.actions.search': 'Relatórios - Procurar',
  'app.pages.managers.logManager.actions.duplicateItems': 'Relatórios - Duplicar itens',
  'app.pages.managers.logManager.actions.copyToMyReports':
    'Relatórios - Copiar para meus relatórios',
  'app.pages.managers.logManager.actions.setAsFav': 'Relatórios - Definir como favorito',
  'app.pages.managers.logManager.actions.dropOnReport': 'Relatórios - Soltar no relatório',
  'app.pages.managers.logManager.actions.exportItems': 'Relatórios - Exportar itens',
  'app.pages.managers.logManager.actions.importItems': 'Relatórios - Importar itens',
  'app.pages.managers.logManager.actions.publishItems': 'Relatórios - Publicar itens',
  'app.pages.managers.logManager.actions.shares': 'Obter shares', //que es get shares
  'app.pages.managers.logManager.actions.setShares': 'Definir shares', //que es set shares
  'app.pages.managers.logManager.actions.myDashboards': 'Meus painéis', //Uso "dashboards" o "painéis"
  'app.pages.managers.logManager.actions.companyDashboards': 'Painéis - painel da empresa',
  'app.pages.managers.logManager.actions.dashboardsSharedWithMe': 'Painéis - Compartilhados comigo',
  'app.pages.managers.logManager.actions.allMyDashboards': 'Painéis - Todos meus painéis',
  'app.pages.managers.logManager.actions.mySharedDashboards':
    'Painéis - Meus painéis compartilhados',
  'app.pages.managers.logManager.actions.dashboardById': 'Painéis - Por identificação',
  'app.pages.managers.logManager.actions.getNodeFullData': 'Painéis - Obter dados completos do nó',
  'app.pages.managers.logManager.actions.evaluateNode': 'Painéis - Avaliar nó',
  'app.pages.managers.logManager.actions.getOrCreate': 'Painéis - Obter ou criar',
  'app.pages.managers.logManager.actions.dashboardManager': 'Endpoints de painéis',
  'app.pages.managers.logManager.actions.dashboardBulkDelete': 'Painéis - Excluir em massa',
  'app.pages.managers.logManager.actions.dashboardChangeOrder': 'Painéis - Alterar ordem',
  'app.pages.managers.logManager.actions.getIndexValues': 'Painéis - Obter valores de índice',
  'app.pages.managers.logManager.actions.getNodeIndexes': 'Painéis - Obter índices de nó',
  'app.pages.managers.logManager.actions.isResultComputed': 'Painéis - O resultado está calculado',
  'app.pages.managers.logManager.actions.lastOpenDashboards': 'Painéis - Últimos painéis abertos',
  'app.pages.managers.logManager.actions.copy': 'Painéis - Copiar',
  'app.pages.managers.logManager.actions.getCubeMetadata':
    'Painéis - Pivô - Obter metadados de cubo', //como traducir cube
  'app.pages.managers.logManager.actions.getCubeValues': 'Painéis - Pivô - Obter valores de cubo',
  'app.pages.managers.logManager.actions.setCubeChanges':
    'Painéis - Pivô - Definir mudanças de cubo',
  'app.pages.managers.logManager.actions.getDimensionValues':
    'Painéis - Pivô - Obter valores de dimensão',
  'app.pages.managers.logManager.actions.tokenAuthEndpoints': 'Endpoints de Token Auth',
  'app.pages.managers.logManager.actions.sendPasswordResetEmail':
    'Enviar e-mail de redefinição de senha',
  'app.pages.managers.logManager.actions.passwordReset': 'Redefinição de senha',
  'app.pages.managers.logManager.actions.authEndpoints': 'Endpoints de Auth',
  'app.pages.managers.logManager.actions.createInstance': 'Criar instância', //uso sesion o instancia
  'app.pages.managers.logManager.actions.getInstance': 'Obter instância',
  'app.pages.managers.logManager.actions.logout': 'Fechar sessão',
  'app.pages.managers.logManager.actions.getAllInstances': 'Obter todas as instâncias',
  'app.pages.managers.logManager.actions.getMyInstances': 'Obter todas as minhas instâncias',
  'app.pages.managers.logManager.actions.killInstanceById': 'Matar instância por id',
  'app.pages.managers.logManager.actions.createNewInstance': 'Criar nova instância',
  'app.pages.managers.logManager.actions.useExternalLink': 'Usar link externo',
  'app.pages.managers.logManager.actions.getSystemResources': 'Obter recursos de sistema',
  'app.pages.managers.logManager.actions.requireLogout': 'Requer logout',
  'app.pages.managers.logManager.actions.getGeoData': 'Geo - Obter informações Geo',
  'app.pages.managers.logManager.actions.getGeoDetail': 'Geo - Obter detalhes Geo',
  'app.pages.managers.logManager.actions.getBubbleInfo': 'Geo - Obter informações sobre a bolha',
  'app.pages.managers.logManager.actions.inputForm': 'Formulários de entrada - Listar', //input o entradas
  'app.pages.managers.logManager.actions.getMetadata': 'Formulários de entrada - Obter metadados',
  'app.pages.managers.logManager.actions.getData': 'Formulários de entrada - Obter informação',
  'app.pages.managers.logManager.actions.setData': 'Formulários de entrada - Definir informação',
  'app.pages.managers.logManager.actions.result': 'Endpoints de Resultado',
  'app.pages.managers.logManager.actions.resultByNodeId': 'Resultado - Por identificador de nó',
  'app.pages.managers.logManager.actions.activities': 'Endpoints de atividades',
  'app.pages.managers.logManager.actions.groups': 'Endpoints de grupos',
  'app.pages.managers.logManager.actions.updateGroupsPermissions':
    'Grupos - Atualizar permissões de grupo',
  'app.pages.managers.logManager.actions.users': 'Endpoints de usuários',
  'app.pages.managers.logManager.actions.companies': 'Endpoints de empresas',
  'app.pages.managers.logManager.actions.preferenceByCode': 'Empresas - Preferências por código',
  'app.pages.managers.logManager.actions.preferences': 'Empresas - Preferências',
  'app.pages.managers.logManager.actions.usercompanies': 'Endpoints de empresas do usuário',
  'app.pages.managers.logManager.actions.listByCompanyId':
    'Empresas do usuário - Listar por identificador da empresa',
  'app.pages.managers.logManager.actions.userPreferenceByCode':
    'Empresas do usuário - Preferências por código',
  'app.pages.managers.logManager.actions.userPreferences': 'Empresas do usuário - Preferências',
  'app.pages.managers.logManager.actions.permissions': 'Endpoints de permissões',
  'app.pages.managers.logManager.actions.departments': 'Endpoints de departamentos',
  'app.pages.managers.logManager.actions.byCurrentCompany': 'Departamentos - Pela empresa atual',
  'app.pages.managers.logManager.actions.denied': 'Departamentos - Negados',
  'app.pages.managers.logManager.actions.denyItems': 'Departamentos - Negar item',
  'app.pages.managers.logManager.actions.dashboardComments': 'Endpoints de comentários de painel',
  'app.pages.managers.logManager.actions.dashboardStyles': 'Endpoints de estilos de painel',
  'app.pages.managers.logManager.actions.diagramShortcut': 'Endpoints de atalhos de diagrama',
  'app.pages.managers.logManager.actions.preferenceModules': 'Endpoints de módulos de preferência',
  'app.pages.managers.logManager.actions.preferencesEndpoints': 'Endpoints de preferências',
  'app.pages.managers.logManager.actions.userCompanyPreferences':
    'Endpoints de preferências da empresa do usuário',
  'app.pages.managers.logManager.actions.companyPreferences':
    'Endpoints de preferências da empresa',
  'app.pages.managers.logManager.actions.apiEndpoints': 'Endpoints de API',
  'app.pages.managers.logManager.actions.reportExternalLink':
    'Endpoints de links externos dos relatórios',
  'app.pages.managers.logManager.actions.dashboardExternalLink':
    'Endpoints de links externos do painel',
  'app.pages.managers.logManager.actions.scheduler': 'Endpoints de agendador', //scheduler = agendador o agendador de tarefas
  'app.pages.managers.logManager.actions.getPythonTimezones': 'Agendador - Obter fusos horários',
  'app.pages.managers.logManager.actions.taskLog': 'Endpoints de log de tarefas',
  'app.pages.managers.logManager.actions.byPeriodicTask': 'Log de tarefas - Por tarefa periódica',
  'app.pages.managers.logManager.actions.filterLogs': 'Log de tarefas - Filtrar logs',
  'app.pages.managers.logManager.actions.logging': 'Endpoints de logging',
  'app.pages.managers.logManager.actions.restAuth': 'Endpoints de Rest Auth',
  'app.pages.managers.logManager.actions.accounts': 'Endpoints de contas',
  'app.pages.managers.logManager.actions.createNewApp': 'Criar novo aplicativo',
  'app.pages.managers.logManager.actions.setSelectorValue': 'Definir valor do seletor',
  'app.pages.managers.logManager.actions.getSelectorValue': 'Obter valor do seletor',
  'app.pages.managers.logManager.actions.getSelectorOptionsAndIndex':
    'Obter opções e índice do seletor',
  'app.pages.managers.logManager.actions.getSelectorParams': 'Obter parâmetros do seletor',
  'app.pages.managers.logManager.actions.getChoice': 'Obter choice',
  'app.pages.managers.logManager.actions.setChoiceValue': 'Definir valor do choice',
  'app.pages.managers.logManager.actions.getChoiceValue': 'Obter valor do choice',
  'app.pages.managers.logManager.actions.getChoiceOptions': 'Obter opções do choice',
  'app.pages.managers.logManager.actions.getChoiceOptionsAndIndex':
    'Obter opções e índice do choice',
  'app.pages.managers.logManager.actions.getChoiceParams': 'Obter parâmetros do choice',
  'app.pages.managers.logManager.actions.setInputScalarValue': 'Definir valor do input escalar',
  'app.pages.managers.logManager.actions.callFunction': 'Chamar função',
  'app.pages.managers.logManager.actions.getWorkspaceAndPublic': 'Obter workspace e público',
  'app.pages.managers.logManager.actions.searchFiles': 'Buscar arquivos',
  'app.pages.managers.logManager.actions.departmentsByCompanyId':
    'Departamentos - Por id de empresa',
  'app.pages.managers.logManager.actions.interfaces': 'Endpoints de interfaces',
  'app.pages.managers.logManager.actions.getAllInterfaces': 'Interfaces - Obter todas',
  'app.pages.managers.logManager.actions.listInterfaces': 'Interfaces - Listar',
  'app.pages.managers.logManager.actions.searchInterfaces': 'Interfaces - Buscar',
  'app.pages.managers.logManager.actions.createInterface': 'Interfaces - Criar',
  'app.pages.managers.logManager.actions.updateInterface': 'Interfaces - Atualizar',
  'app.pages.managers.logManager.actions.removeInterface': 'Interfaces - Remover',
  'app.pages.managers.logManager.actions.copyInterface': 'Interfaces - Copiar',
  'app.pages.managers.logManager.actions.moveInterface': 'Interfaces - Mover',
  'app.pages.managers.logManager.actions.duplicateInterface': 'Interfaces - Duplicar',
  'app.pages.managers.logManager.actions.exportInterfaces': 'Interfaces - Exportar',
  'app.pages.managers.logManager.actions.importInterface': 'Interfaces - Importar',
  'app.pages.managers.logManager.actions.createInterfaceFolder': 'Interfaces - Criar pasta',
  'app.pages.managers.logManager.actions.removeInterfaceFolder': 'Interfaces - Remover pasta',
  'app.pages.managers.logManager.actions.setInterfacePermission': 'Interfaces - Definir permissão',
  'app.pages.managers.logManager.actions.getInterfaceIndexValues':
    'Interfaces - Obter valores de índice',
  'app.pages.managers.logManager.actions.applyFormChanges': 'Aplicar alterações do formulário',
  'app.pages.managers.logManager.actions.applyTableChanges': 'Aplicar alterações da tabela',
  'app.pages.managers.logManager.actions.interfaceExternalLink':
    'Endpoints de link externo de interface',

  //Applications
  'app.pages.applications.createApp': 'Criar aplicativo',
  'app.pages.applications.applicationName': 'Nome do aplicativo',
  'app.pages.applications.fromScratch': 'Do zero',
  'app.pages.applications.fromScratchDescription': 'Começa com um exemplo simples de "Olá mundo"',
  'app.pages.applications.fromDataAnalytics': 'Análise de dados',
  'app.pages.applications.fromDataAnalyticsDescription':
    'Exemplo de um aplicativo de análise de dados',
  'app.pages.applications.fromBusinessPlanning': 'Planejamento de negócios',
  'app.pages.applications.fromBusinessPlanningDescription':
    'Exemplo de um aplicativo de planejamento de negócios',
  'app.pages.applications.applicationManager': 'Administrador de aplicativos',
  'app.pages.applications.deleteAppTitle': 'Excluir aplicativo',
  'app.pages.applications.deleteAppMessage': 'Tem certeza de que deseja excluir o aplicativo?',
  'app.pages.applications.results': 'Resultados',
  'app.pages.applications.applicationDeleted': 'Aplicativo excluído',
  'app.pages.applications.deletingApplication': 'Excluindo aplicativo',
  'app.pages.applications.applicationNameChanged': 'Nome do aplicativo alterado',
  'app.pages.applications.path': 'Caminho',
  'app.pages.applications.copyAppToWorkspaceTitle': 'Copiar aplicativo para o espaço de trabalho',
  'app.pages.applications.copyAppToWorkspaceMessage':
    'Tem certeza de que deseja copiar este aplicativo para o seu espaço de trabalho?',
  'app.pages.applications.appCopiedToWorkspace': 'O aplicativo foi copiado com sucesso em:',
  'app.pages.applications.copyingAppToWorkspace': 'Copiando aplicativo para o espaço de trabalho',
  'app.pages.applications.appImported': 'Aplicativo importado com sucesso',
  'app.pages.applications.createInPublic': 'Criar em espaço Public',
  'app.pages.applications.appCopied': 'Aplicativo copiado',
  'app.pages.applications.copyingAppToTeam': 'Copiando aplicativo para a equipe',
  'app.pages.applications.copyAppToPublicMessage':
    'Tem certeza de que deseja copiar este aplicativo para o espaço de trabalho Público?',
  'app.pages.applications.appCopiedToPublic': 'Aplicativo copiado para Public',
  'app.pages.applications.copyingAppToPublic': 'Copiando aplicativo para Public',
  'app.pages.applications.setThumbnail': 'Definir miniatura',
  'app.pages.applications.replaceThumbnail': 'Substituir miniatura',
  'app.pages.applications.removeThumbnail': 'Remover miniatura',
  'app.pages.applications.removeThumbnailMessage': 'Tem certeza de que deseja remover a miniatura?',
  'app.pages.applications.thumbnailRemoved': 'Miniatura removida',
  'app.pages.applications.thumbnailUploaded': 'Miniatura enviada',
  'app.pages.applications.loadingAppMessage': 'Carregando aplicativo',
  'app.pages.applications.folderDuplicated': 'Pasta duplicada',
  'app.pages.applications.deleteFolderMessage': 'Tem certeza de que deseja excluir a pasta?',
  'app.pages.applications.deleteFolderTitle': 'Excluir pasta',
  'app.pages.applications.folderDeleted': 'Pasta excluída',
  'app.pages.applications.folderCutted': 'Pasta cortada',
  'app.pages.applications.folderCopied': 'Pasta copiada',
  'app.pages.applications.elementsPasted': 'Elementos colados',
  'app.pages.applications.showHiddenFolders': 'Mostrar pastas ocultas',
  'app.pages.applications.copyAppSubMenu': 'Outras opções de cópia',
  'app.pages.applications.keepId': 'Manter id do aplicativo ',
  'app.pages.applications.directAccessLink': 'Link de acesso direto',
  'app.pages.applications.directAccessLinkCopied': 'Link de acesso direto copiado com sucesso',
  'app.pages.applications.directAccessLinkError': 'Não foi possível gerar o link de acesso direto',
  'app.pages.applications.directAccessLinkDialogTitle': 'Gerar link de acesso direto',
  'app.pages.applications.directAccessLinkDefaultVersion': 'Usar versão padrão',
  'app.pages.applications.generatedLink': 'Link gerado',
  'app.pages.applications.installOnPublic': 'Instalar no público',
  'app.pages.applications.generateDirectAccessLink': 'Gerar link',

  //Application Summary
  'app.pages.applications.id': 'Identificador do aplicativo',
  'app.pages.applications.version': 'Versão do aplicativo',
  'app.pages.applications.uri': 'Localização',
  'app.pages.applications.isPublic': 'Está na pasta pública',
  'app.pages.applications.canwrite': 'Tem permissão para escrever',
  'app.pages.applications.venvPath': 'Caminho do ambiente virtual',
  'app.pages.applications.pythonVersion': 'Versão do Python',
  'app.pages.applications.cpuArchitecture': 'Arquitetura do CPU',
  'app.pages.app.cpuArchitecture.x86': 'x86',
  'app.pages.app.cpuArchitecture.arm': 'ARM',

  //Icon selector
  'app.pages.iconSelector.iconType': 'Tipo de ícone',
  'app.pages.iconSelector.iconName': 'Nome do ícone',
  'app.pages.iconSelector.solid': 'Sólido',
  'app.pages.iconSelector.regular': 'Regular',

  //Versions
  'app.pages.versions.versionManager': 'Administrador de versões',
  'app.pages.versions.deleteVersionTitle': 'Excluir versão',
  'app.pages.versions.deleteVersionMessage':
    'Tem certeza de que deseja excluir a versão {version}?',
  'app.pages.versions.deleteVersionsMessage':
    'Tem certeza de que deseja excluir as versões {versions}?',
  'app.pages.versions.versionDeleted': 'A versão "{version}" foi excluída',
  'app.pages.versions.versionsDeleted': 'As versões "{versions}" foram excluídas',
  'app.pages.versions.deletingVersion': 'Excluindo versão',
  'app.pages.versions.createVersion': 'Criar versão',
  'app.pages.versions.fromVersion': 'Versão original',
  'app.pages.versions.versionCreated': 'A versão "{version}" foi criada com sucesso',
  'app.pages.versions.creationDate': 'Data de criação',
  'app.pages.versions.closingDate': 'Data de fechamento',
  'app.pages.versions.archiveDate': 'Data de arquivamento',
  'app.pages.versions.lastModifiedDate': 'Data da última modificação',
  'app.pages.versions.viewDetails': 'Ver detalhes',
  'app.pages.versions.detailsVersionTitle': 'Detalhes da versão',
  'app.pages.versions.closedBy': 'Fechada por',
  'app.pages.versions.archivedBy': 'Arquivada por',
  'app.pages.versions.lastModifiedBy': 'Última modificação por',
  'app.pages.versions.status.active': 'Ativa',
  'app.pages.versions.status.closed': 'Fechada',
  'app.pages.versions.status.archived': 'Arquivada',
  'app.pages.versions.status.unarchived': 'Desarquivada',
  'app.pages.versions.setAsDefaultVersion': 'Definir como versão padrão',
  'app.pages.versions.setPermission': 'Definir permissão',
  'app.pages.versions.versionPermissionChanged': 'Permissão da versão alterada',
  'app.pages.versions.hasDepartmentRestrictions':
    'Esta versão tem restrições de acesso por departamento',
  'app.pages.versions.isDefaultAppVersion': 'É a versão padrão do aplicativo',
  'app.pages.versions.setAsDefaultVersionMessage':
    'Tem certeza de que deseja definir a versão "{version}" como a versão padrão do aplicativo?',
  'app.pages.versions.defaultVersionChanged': 'A versão padrão foi alterada',
  'app.pages.versions.editProperties': 'Editar propriedades',
  'app.pages.versions.cannotDeleteReason':
    'Não é possível excluir a versão do aplicativo aberta atual',
  'app.pages.versions.versionModified': 'A versão {version} foi alterada com sucesso',
  'app.pages.versions.versionsModified': 'As versões {versions} foram alteradas com sucesso',
  'app.pages.versions.cannotModifyNameReason':
    'Não é possível alterar o nome da versão do aplicativo aberta atual',
  'app.pages.versions.updateVersionStatus': 'Atualizar estado da versão',
  'app.pages.versions.updateVersionStatusMessage':
    'Tem certeza de que deseja alterar o estado da versão {version} para "{newStatus}"?',
  'app.pages.versions.updateVersionsStatusMessage':
    'Tem certeza de que deseja alterar o estado das versões {versions} para "{newStatus}"?',
  'app.pages.versions.importVersions': 'Importar versões',
  'app.pages.versions.exportVersions': 'Exportar versões',
  'app.pages.versions.cannotChangeReason':
    'Não é possível alterar a versão do aplicativo aberta atual',
  'app.pages.versions.versionsImported': 'As versões enviadas foram importadas com sucesso',
  'app.pages.versions.uploadInstructions':
    'Fazer upload de um arquivo com extensão .zip que contenha a pasta de cada versão que deseja importar',
  'app.pages.versions.openAppVersion': 'Abrir versão do aplicativo',
  'app.pages.versions.openAppVersionOnNewInstance':
    'Abrir versão do aplicativo em uma nova instância',
  'app.pages.versions.excludeArchivedVersions': 'Excluir versões arquivadas',
  'app.pages.versions.versionSelectedScenariosUpdated':
    'Cenários selecionados da versão foram carregados com sucesso',
  'app.pages.versions.openAfterCreating': 'Abrir depois de criar',
  'app.pages.versions.versionGroup': 'Grupo da versão',
  'app.pages.versions.versionGroupPathHelp':
    'Use / para criar grupos aninhados, por exemplo Finanças/Orçamento/2026.',
  'app.pages.versions.uncategorized': 'Não agrupadas',
  'app.pages.versions.moreActions': 'Mais ações',
  'app.pages.versions.unsavedChangesMessage':
    'Qualquer alteração não salva da versão aberta será perdida',
  'app.pages.versions.versionExported': 'Versão exportada',
  'app.pages.versions.versionsExported': 'Versões exportadas',
  'app.pages.versions.nameExists': 'Nome da versão já existe',
  'app.pages.versions.openExistingVersion': 'Abrir versão existente',
  'app.pages.versions.createNewVersion': 'Criar versão nova',
  'app.pages.versions.manageVersions': 'Gerenciar versões',
  'app.pages.versions.createNewVersionFromThis': 'Criar nova versão a partir desta',
  'app.pages.versions.createNewVersionInMyWorkspace': 'Criar nova versão no meu espaço de trabalho',
  'app.pages.versions.createNewVersionInMyWorkspaceConfirmation':
    'Você não tem permissões de escrita no diretório do aplicativo selecionado. O aplicativo será copiado para seu espaço de trabalho (se não existir) e a nova versão será criada lá.',
  'app.pages.versions.newVersionName': 'Nome de nova versão',
  'app.pages.versions.sourceVersion': 'Versão de origem',
  'app.pages.versions.technicalVersion': 'Versão técnica',
  'app.pages.versions.technicalVersionFormatError':
    'Deve ter três grupos de dígitos separados por pontos (ex. 3.21.005)',
  'app.pages.versions.technicalVersionHelp':
    'Identificador de versão semântica: três grupos de dígitos separados por pontos, por exemplo 3.21.005.',
  'app.pages.versions.otherUserWithWritePermissions':
    'Esta versão está sendo usada atualmente por {user} com permissões de escrita',
  'app.pages.versions.inThisApplication': 'Neste aplicativo',
  'app.pages.versions.inAnotherApplication': 'Em outro aplicativo',
  'app.pages.versions.loadArchivedMetadata': 'Carregar metadados de versões arquivadas',
  'app.pages.versions.archivedMetadataLoaded': 'Metadados de versões arquivadas carregados',

  //Process manager
  'app.pages.app.processManager.addProcess': 'Criar processo',
  'app.pages.app.processManager.editProcess': 'Atualizar processo',
  'app.pages.app.processManager.duplicateProcess': 'Duplicar o processo',
  'app.pages.app.processManager.showDescription': 'Mostrar descrição',
  'app.pages.app.processManager.noDescriptionText': 'Não há uma descrição',
  'app.pages.app.processManager.processTodo': 'A fazer',
  'app.pages.app.processManager.process': 'Processo',
  'app.pages.app.processManager.subscribers': 'Assinantes',
  'app.pages.app.processManager.status': 'Status',
  'app.pages.app.processManager.description': 'Descrição',
  'app.pages.app.processManager.group': 'grupo',
  'app.pages.app.processManager.task': 'Tarefa',
  'app.pages.app.processManager.taskResponsible': 'Responsável pela tarefa',
  'app.pages.app.processManager.taskResponsibles': 'Responsáveis pela tarefa',
  'app.pages.app.processManager.taskActionType': 'Tipo de ação',
  'app.pages.app.processManager.isBlockedBy': 'Está bloqueada por',
  'app.pages.app.processManager.expiration': 'Expiração',
  'app.pages.app.processManager.expirationType': 'Tipo de expiração',
  'app.pages.app.processManager.createGroup': 'Criar grupo',
  'app.pages.app.processManager.editGroup': 'Editar grupo',
  'app.pages.app.processManager.groupsAndTasks': 'Grupos e tarefas',
  'app.pages.app.processManager.processWithoutGroups': 'Este processo ainda não tem grupos',
  'app.pages.app.processManager.processWithoutGroupsHint':
    'Um grupo reúne as tarefas de uma etapa — crie o primeiro para poder adicionar tarefas.',
  'app.pages.app.processManager.processWithoutGroupsNeedsName':
    'Defina primeiro o nome do processo e depois crie o primeiro grupo.',
  'app.pages.app.processManager.groupWithoutTasks': 'Ainda não há tarefas neste grupo',
  'app.pages.app.processManager.expirationDaysValue': '{days, plural, one {# dia} other {# dias}}',
  'app.pages.app.processManager.expirationHoursValue':
    '{hours, plural, one {# hora} other {# horas}}',
  'app.pages.app.processManager.expirationMinutesValue':
    '{minutes, plural, one {# minuto} other {# minutos}}',
  'app.pages.app.processManager.expirationFromProcess': 'desde o início do processo',
  'app.pages.app.processManager.expirationFromBlocker': 'desde a tarefa bloqueante',
  'app.pages.app.processManager.expirationImmediate': 'Imediato',
  'app.pages.app.processManager.sinceProcess': 'desde que o processo foi iniciado',
  'app.pages.app.processManager.sinceBlockingTaskCompleted':
    'desde que a tarefa bloqueante foi concluída',
  'app.pages.app.processManager.processCreated': 'Processo criado',
  'app.pages.app.processManager.processUpdated': 'Processo atualizado',
  'app.pages.app.processManager.processDuplicated': 'Processo duplicado',
  'app.pages.app.processManager.undefined': 'Indefinido',
  'app.pages.app.processManager.processDeleted': 'Processo excluído',
  'app.pages.app.processManager.processNotFound': 'Processo não encontrado',
  'app.pages.app.processManager.deleteProcess': 'Excluir processo',
  'app.pages.app.processManager.deleteProcessMessage':
    'Tem certeza de que deseja excluir este processo?',
  'app.pages.app.processManager.reviewers': 'Revisores',
  'app.pages.app.processManager.reviewerInterface': 'Interface de revisor',
  'app.pages.app.processManager.taskApp': 'Aplicativo',
  'app.pages.app.processManager.taskAppPlaceholder': 'O aplicativo do processo',
  'app.pages.app.processManager.taskAppDefault': 'Usa o aplicativo do processo',
  'app.pages.app.processManager.taskAppVersion': 'Versão',
  'app.pages.app.processManager.taskAppVersionIsDefault': '(hoje a padrão)',
  'app.pages.app.processManager.taskAppVersionDefault': 'Versão padrão',
  'app.pages.app.processManager.runAs': 'Executar como',
  'app.pages.app.processManager.noAgentUsers':
    'Para atribuir um agente, crie primeiro um usuário-agente no gerenciador de usuários.',
  'app.pages.app.processManager.responsibleAgent': 'Agente do responsável',
  'app.pages.app.processManager.reviewerAgent': 'Agente do revisor',
  'app.pages.app.processManager.selectAgent': 'Selecione um agente',
  'app.pages.app.processManager.peopleGroup': 'Pessoas',
  'app.pages.app.processManager.agentsGroup': 'Agentes',
  'app.pages.app.processManager.oneAgentResponsibleOnly':
    'Apenas um agente pode ser responsável por uma tarefa.',
  'app.pages.app.processManager.agentRequired': 'Escolha com qual agente esta tarefa é executada.',
  'app.pages.app.processManager.agentSelfApproval':
    'O agente revisor precisa ser diferente do que faz o trabalho.',
  'app.pages.app.processManager.personSelfReview':
    'Um responsável pela tarefa não pode ser também seu revisor.',
  'app.pages.app.processManager.agentWorking': 'Agente trabalhando',
  'app.pages.app.processManager.agentTooltip': 'Agente',
  'app.pages.managers.agentAccessTokens': 'Tokens de acesso',
  'app.pages.managers.isAgent': 'Este usuário é um agente',
  'app.pages.managers.isAgentHelp':
    'Um agente não pode fazer login e não tem senha. Pode ser atribuído a tarefas de um processo para que o trabalho seja feito por um agente.',
  'app.pages.app.processManager.expirationDays': 'Dias de validade',
  'app.pages.app.processManager.collaborators': 'Colaboradores',
  'app.pages.app.processManager.deleteGroupTitle': 'Tem certeza de que deseja excluir este grupo?',
  'app.pages.app.processManager.deleteGroupMessage': 'Contém as seguintes tarefas',
  'app.pages.app.processManager.deleteTaskTitle': 'Excluir esta tarefa?',
  'app.pages.app.processManager.deleteWaitingTasks':
    'Estas tarefas esperam pelo que você está excluindo. As que ficarem sem tarefa bloqueante mantêm a data de vencimento, que passa a ser contada a partir do início do processo, e podem começar imediatamente.',
  'app.pages.app.processManager.dueTypeNeedsBlocker': 'Escolha primeiro uma tarefa bloqueante',
  'app.pages.app.processManager.marginSummaryTitle': 'Alguns vencimentos não batem',
  'app.pages.app.processManager.marginSummaryNone':
    '“{task}” vence em {date}, ao mesmo tempo que “{blocker}”, pela qual precisa esperar.',
  'app.pages.app.processManager.marginSummaryNegative':
    '“{task}” vence em {taskDate}, mas “{blocker}”, pela qual precisa esperar, vence em {blockerDate} ({gap} depois).',
  'app.pages.app.processManager.dueAfterEndSummary':
    '“{task}” vence em {due}, depois do fim do processo, em {end}.',
  'app.pages.app.processManager.marginSummaryReview': 'Revisar',
  'app.pages.app.processManager.marginSummarySave': 'Salvar mesmo assim',
  'app.pages.app.processManager.marginNone':
    '“{blocker}”, que esta tarefa espera, vence {blockerDue} após o início do processo, assim como esta tarefa: não sobra tempo para fazê-la.',
  'app.pages.app.processManager.marginNegative':
    '“{blocker}”, que esta tarefa espera, vence {blockerDue} após o início do processo. Esta tarefa vence {gap} antes, sem ter podido começar.',
  'app.pages.app.processManager.marginFix': 'Contar os dias a partir da conclusão',
  'app.pages.app.processManager.addTask': 'Criar tarefa',
  'app.pages.app.processManager.editTask': 'Editar tarefa',
  'app.pages.app.processManager.taskStatus.not_ready_to_start': 'Não pronta para começar',
  'app.pages.app.processManager.taskStatus.not_started': 'Não iniciada',
  'app.pages.app.processManager.taskStatus.in_progress': 'Em andamento',
  'app.pages.app.processManager.taskStatus.pending_review': 'Pendente de revisão',
  'app.pages.app.processManager.taskStatus.completed': 'Concluída',
  'app.pages.app.processManager.restartProcess': 'Reiniciar processo',
  'app.pages.app.processManager.processRestarted': 'Processo reiniciado',
  'app.pages.app.processManager.autoCompleteOnDue': 'Autocompletar no vencimento',
  'app.pages.app.processManager.autoCompleteOnDueTooltip':
    'Marcar automaticamente a tarefa como concluída quando a data de vencimento for atingida.',
  'app.pages.app.processManager.scheduledTaskOnFinish': 'Tarefa ao finalizar',
  'app.pages.app.processManager.requireAllResponsibleCompletion':
    'Requerer que todos os responsáveis completem a tarefa',
  'app.pages.app.processManager.requireAllResponsibleCompletionTooltip':
    'Todos os responsáveis devem completar a tarefa antes que ela possa ser marcada como concluída. Se desativado, qualquer responsável pode completar a tarefa.',
  'app.pages.app.processManager.processExported': 'Processo exportado',
  'app.pages.app.processManager.processesExported': 'Processos exportados',
  'app.pages.app.processManager.importProcesses': 'Importar processos',
  'app.pages.app.processManager.importProcessesInstructions':
    'Selecione um arquivo de exportação de processos (.json) para importar',
  'app.pages.app.processManager.invalidImportFile': 'Arquivo de importação inválido',
  'app.pages.app.processManager.processesImported': 'Processos importados',
  'app.pages.app.processManager.importWarningsTitle': 'Avisos de importação',
  'app.pages.app.processManager.importWarningsProcess': 'Processo {processName}',
  'app.pages.app.processManager.importWarningsUnresolvedUsers': 'Usuários não resolvidos',
  'app.pages.app.processManager.importWarningsUnresolvedUserItem':
    'Tarefa {taskName} - {role}: {identifier}',
  'app.pages.app.processManager.importWarningsRoleResponsible': 'responsável',
  'app.pages.app.processManager.importWarningsRoleReviewer': 'revisor',
  'app.pages.app.processManager.importWarningsRoleCollaborator': 'colaborador',
  'app.pages.app.processManager.importWarningsRoleSubscriber': 'assinante',
  'app.pages.app.processManager.importWarningsUnresolvedAgents': 'Agentes não resolvidos',
  'app.pages.app.processManager.importWarningsUnresolvedAgentItem':
    'Tarefa "{taskName}": o agente "{agentCode}" não foi atribuído',
  'app.pages.app.processManager.importWarningsUnresolvedActions': 'Ações/interfaces não resolvidas',
  'app.pages.app.processManager.importWarningsUnresolvedActionItem': 'Tarefa {taskName} - {field}',
  'app.pages.app.processManager.importWarningsLostAutomations': 'Automações perdidas',
  'app.pages.app.processManager.importWarningsLostAutomationItem': 'Tarefa {taskName}',

  //Scenarios
  'app.pages.scenarios.scenarioManager': 'Administrador de cenários',
  'app.pages.scenarios.deleteScenarioTitle': 'Excluir cenário',
  'app.pages.scenarios.deleteScenarioMessage':
    'Tem certeza de que deseja excluir o cenário "{scenario}"?',
  'app.pages.scenarios.deleteScenariosMessage':
    'Tem certeza de que deseja excluir os cenários "{scenarios}"?',
  'app.pages.scenarios.scenarioDeleted': 'O cenário "{scenario}" foi excluído',
  'app.pages.scenarios.scenariosDeleted': 'Os cenários "{scenarios}" foram excluídos',
  'app.pages.scenarios.deletingScenario': 'Excluindo cenário',
  'app.pages.scenarios.createScenario': 'Criar cenário',
  'app.pages.scenarios.fromScenario': 'A partir do cenário',
  'app.pages.scenarios.scenarioCreated': 'O cenário "{scenario}" foi criado com sucesso',
  'app.pages.scenarios.lastModifiedDate': 'Última data de modificação',
  'app.pages.scenarios.editProperties': 'Editar propriedades',
  'app.pages.scenarios.scenarioModified': 'O cenário "{scenario}" foi alterado com sucesso',
  'app.pages.scenarios.importScenarios': 'Importar cenários',
  'app.pages.scenarios.exportScenario': 'Exportar cenários',
  'app.pages.scenarios.scenariosImported': 'Os cenários enviados foram importados com sucesso',
  'app.pages.scenarios.uploadInstructions':
    'Fazer upload de um arquivo com extensão .zip que contenha a pasta de cada versão (com uma pasta por cada cenário dentro) que deseja importar',
  'app.pages.scenarios.alias': 'Alias',
  'app.pages.scenarios.includedNodes': 'Nós incluídos',
  'app.pages.scenarios.includeNodesFrom': 'Incluir nós de',
  'app.pages.scenarios.currentInterface': 'Interface atual',
  'app.pages.scenarios.nodesToBeEvaluatedBeforehand': 'Nós a serem avaliados previamente',
  'app.pages.scenarios.nodesToBeEvaluatedAfterwards': 'Nós a serem avaliados posteriormente',
  'app.pages.scenarios.runScenarioAfterSave': 'Executar cenário após salvar',
  'app.pages.scenarios.addNode': 'Adicionar nó',
  'app.pages.scenarios.showCurrentVersionOnly': 'Mostrar só a versão atual',
  'app.pages.scenarios.scenarioAlreadyExists':
    'Já existe um cenário com este nome na versão "{version}"',
  'app.pages.scenarios.scenarioDuplicated': 'O cenário "{scenario}" foi duplicado com sucesso',
  'app.pages.scenarios.duplicateScenario': 'Duplicar cenário',
  'app.pages.scenarios.saveScenario': 'Salvar cenário',
  'app.pages.scenarios.cannotSaveScenarioReason':
    'Não é possível salvar cenários em uma versão não ativa',
  'app.pages.scenarios.cannotChangeScenarioReason':
    'Não é possível alterar cenários em uma versão não ativa',
  'app.pages.scenarios.existingScenario': 'Cenário existente',
  'app.pages.scenarios.createNewScenario': 'Criar novo cenário',
  'app.pages.scenarios.baseScenario': 'Cenário base',
  'app.pages.scenarios.scenarioSaved': 'O cenário "{scenario}" foi salvo com sucesso',
  'app.pages.scenarios.noNodesMessage':
    'O cenário escolhido não inclui nenhum nó para salvar. Edite este cenário no Administrador de Cenários para adicioná-los.',
  'app.pages.scenarios.selectScenarios': 'Selecionar cenários',
  'app.pages.scenarios.byInterfaceMode': 'Por interface',
  'app.pages.scenarios.scenariosForInterface': 'Cenários para a interface: {interfaceName}',
  'app.pages.scenarios.modeUpdated': 'Modo de seleção de cenários atualizado com sucesso',
  'app.pages.scenarios.selectedScenarios': 'Cenários selecionados',
  'app.pages.scenarios.scenarioExported': 'Cenário exportado com sucesso',
  'app.pages.scenarios.scenariosExported': 'Cenários exportados com sucesso',
  'app.pages.scenarios.scenariosManager': 'Administrador de cenários',
  'app.pages.scenarios.scenariosTemplates': 'Modelos de cenários',
  'app.pages.scenarios.createTemplate': 'Criar modelo',
  'app.pages.scenarios.editTemplate': 'Editar modelo',
  'app.pages.scenarios.duplicateTemplate': 'Duplicar modelo',
  'app.pages.scenarios.deleteTemplate': 'Excluir modelo',
  'app.pages.scenarios.scenarioTemplateSuccessfullyCreated': 'Modelo de cenário criado com sucesso',
  'app.pages.scenarios.scenarioTemplateSuccessfullyModified':
    'Modelo de cenário {template} alterado com sucesso',
  'app.pages.scenarios.deleteScenarioTemplateTitle': 'Excluir modelo de cenário',
  'app.pages.scenarios.deleteScenarioTemplateMessage':
    'Tem certeza de que deseja excluir o modelo de cenário "{scenarioTemplate}"?',
  'app.pages.scenarios.scenarioTemplateSuccessfullyDuplicated':
    'Modelo de cenário {scenarioTemplate} duplicado com sucesso',
  'app.pages.scenarios.scenarioTemplateNameAlreadyExists':
    'Já existe um modelo de cenário com este nome na versão {version}',
  'app.pages.scenarios.templateName': 'Nome do modelo',
  'app.pages.scenarios.scenarioNodesTemplate': 'Modelo de nós de cenário',
  'app.pages.scenarios.noOptionsTemplate': 'Não há opções de modelo',
  'app.pages.scenarios.addNewScenarioNodesTemplate': 'Adicionar novo modelo de nós de cenário',
  'app.pages.scenarios.destinationVersion': 'Versão de destino',
  'app.pages.scenarios.updateSelectedScenarios': 'Carregar cenários selecionados',
  'app.pages.scenarios.visibility.whoCanSee': 'Quem pode ver este cenário',
  'app.pages.scenarios.visibility.onlyMe': 'Só eu',
  'app.pages.scenarios.visibility.everyone': 'Todos',
  'app.pages.scenarios.visibility.byDepartments': 'Usuários de departamentos selecionados',
  'app.pages.scenarios.visibility.selectDepartments': 'Selecionar departamentos',
  'app.pages.scenarios.visibility.selectDepartmentsPlaceholder': 'Escolher departamentos...',
  'app.pages.scenarios.visibility.noDepartments': 'Não há departamentos disponíveis',
  'app.pages.scenarios.useCustomScenariosForInterface':
    'Seleção de cenários personalizada para a interface {interfaceName}',

  //My tasks
  'app.pages.app.myTasks.title': 'Minhas tarefas',
  'app.pages.app.myTasks.statusChanged': 'Estado alterado',
  'app.pages.app.myTasks.showComments': 'Mostrar comentários',
  'app.pages.app.myTasks.openTaskDetail': 'Ver o detalhe da tarefa e os comentários',
  'app.pages.app.myTasks.responsible': 'Responsável',
  'app.pages.app.myTasks.responsibles': 'Responsáveis',
  'app.pages.app.myTasks.deadline': 'Prazo final',
  'app.pages.app.myTasks.finished': 'Finalizada',
  'app.pages.app.myTasks.commentDeleted': 'Comentário excluído',
  'app.pages.app.myTasks.comments': 'Comentários',
  'app.pages.app.myTasks.deleteComment': 'Excluir comentário',
  'app.pages.app.myTasks.addComment': 'Adicionar comentário',
  'app.pages.app.myTasks.noAssignedTasks': 'Nenhuma tarefa atribuída',
  'app.pages.app.myTasks.requestChangesTitle': 'Devolver a tarefa',
  'app.pages.app.myTasks.requestChangesHelp':
    'A tarefa volta para quem é responsável por ela. O que você escrever é publicado como comentário e é a primeira coisa que essa pessoa vai ler.',
  'app.pages.app.myTasks.requestChangesAgentHint':
    'O agente responsável vai voltar a trabalhar com esta indicação.',
  'app.pages.app.myTasks.requestChangesLabel': 'O que precisa ser corrigido',
  'app.pages.app.myTasks.requestChangesConfirm': 'Devolver',
  'app.pages.app.myTasks.requestChangesDone': 'A tarefa voltou para o responsável',
  'app.pages.app.myTasks.process': 'Processo',
  'app.pages.app.myTasks.view': 'Visualização',
  'app.pages.app.myTasks.tableView': 'Tabela',
  'app.pages.app.myTasks.timelineView': 'Linha do tempo',
  'app.pages.app.myTasks.startedOn': 'começou em {date}',
  'app.pages.app.myTasks.closesOn': 'encerra em {date}',
  'app.pages.app.myTasks.cycleProgress': 'Progresso do processo',
  'app.pages.app.myTasks.tasksCompleted': '{completed} de {total} tarefas concluídas',
  'app.pages.app.myTasks.deadlineHealth': 'Situação dos prazos',
  'app.pages.app.myTasks.overdueTasks': 'vencidas',
  'app.pages.app.myTasks.atRiskTasks': 'em risco',
  'app.pages.app.myTasks.runway':
    'Encerra em {date} — restam {days, plural, one {# dia} other {# dias}}',
  'app.pages.app.myTasks.noCloseDate': 'Sem data de encerramento',
  'app.pages.app.myTasks.waitingOnMe': 'Aguardando por mim',
  'app.pages.app.myTasks.openTasksWithYou': 'tarefas abertas com você',
  'app.pages.app.myTasks.waitingDetail':
    '{agents, plural, =0 {nenhum agente trabalhando} one {# agente trabalhando agora} other {# agentes trabalhando agora}}, {blocked, plural, =0 {nenhuma aguardando um bloqueio} other {# aguardando um bloqueio}}',
  'app.pages.app.myTasks.allMustComplete': 'todos devem concluir',
  'app.pages.app.myTasks.anyCanComplete': 'qualquer um pode concluir',
  'app.pages.app.myTasks.deadlineCompleted': 'concluída',
  'app.pages.app.myTasks.deadlineOverdue':
    '{days, plural, one {# dia de atraso} other {# dias de atraso}}',
  'app.pages.app.myTasks.deadlineOverdueToday': 'vencida',
  'app.pages.app.myTasks.deadlineToday': 'hoje',
  'app.pages.app.myTasks.deadlineIn': '{days, plural, one {em # dia} other {em # dias}}',
  'app.pages.app.myTasks.timelineTaskColumn': 'Tarefa · responsáveis',
  'app.pages.app.myTasks.review': 'Revisão',
  'app.pages.app.myTasks.sharedTask': 'Tarefa compartilhada',
  'app.pages.app.myTasks.taskStatus': 'Status da tarefa',
  'app.pages.app.myTasks.reviewRound': 'Rodada {round}',
  'app.pages.app.myTasks.sentBackAt': 'Devolvida em {date} por {author}',
  'app.pages.app.myTasks.openNamed': 'Abrir {name}',
  'app.pages.app.myTasks.saveResults': 'Salvar resultados',
  'app.pages.app.myTasks.noComments': 'Ainda não há comentários',
  'app.pages.app.myTasks.send': 'Enviar',
  'app.pages.app.myTasks.commentRoleAgent': 'agente',
  'app.pages.app.myTasks.commentRoleReviewer': 'revisor',
  'app.pages.app.myTasks.commentRoleResponsible': 'responsável',
  'app.pages.app.myTasks.commentSentBack': 'devolvida para correção',
  'app.pages.app.myTasks.agentStarting': 'Iniciando…',
  'app.pages.app.myTasks.agentReportsBack': 'Informar o resultado e mover a tarefa',
  'app.pages.app.myTasks.agentReportsBackHint': 'deixa um comentário quando terminar',
  'app.pages.app.myTasks.agentRun': 'Execução {run}',
  'app.pages.app.myTasks.agentStartedAt': 'começou em {date}',
  'app.pages.app.myTasks.elapsedSeconds': '{seconds} s',
  'app.pages.app.myTasks.elapsedMinutes': '{minutes} min {seconds} s',
  'app.pages.app.myTasks.elapsedHours': '{hours} h {minutes} min',

  //General settings
  'app.pages.generalSettings.logsSettings': 'Configurações de logs',
  'app.pages.generalSettings.initialPrompt': 'Prompt inicial',
  'app.pages.generalSettings.customValue': 'Valor customizado',
  'app.pages.generalSettings.customValueRemoved': 'Valor customizado removido',
  'app.pages.generalSettings.customValueSaved': 'Valor customizado salvo com sucesso',
  'app.pages.generalSettings.paramsPlaceholder': 'Insira os parâmetros no formato json',

  //App Configuration
  'app.pages.app.appConfiguration': 'Configuração do aplicativo',
  'app.pages.app.installLibrariesOnOpen': 'Instalar bibliotecas ao iniciar',
  'app.pages.app.openDefaultVersionOnOpen': 'Abrir a versão padrão ao iniciar',
  'app.pages.app.openAsReadOnlyByDefault': 'Abrir como somente leitura por padrão',
  'app.pages.app.defaultTabOnOpen': 'Janela padrão ao abrir',
  'app.pages.app.applicationLanguage': 'Idioma do aplicativo',
  'app.pages.app.quickMenu': 'Menu Rápido',
  'app.pages.app.quickMenu.fromInterface': 'Da interface',
  'app.pages.app.quickMenu.noMenu': 'Nenhum menu encontrado',

  //External links
  'app.pages.externalLink.deleteMessage': 'Tem certeza de que deseja excluir o link externo?',
  'app.pages.externalLink.linkDeleted': 'Link externo excluído',
  'app.pages.externalLink.deleteTitle': 'Excluir link externo',
  'app.pages.externalLink.nodeId': 'Id do nó',
  'app.pages.externalLink.commonInstance': 'Instância comum',
  'app.pages.externalLink.apiEndpoint': 'API URL',
  'app.pages.externalLink.linkUpdated': 'Link externo atualizado',
  'app.pages.externalLink.customEndpoint': 'Endpoint personalizado',
  'app.pages.externalLink.customEndpointError': 'Endpoint personalizado já existe',
  'app.pages.externalLink.externalLinksNotFound': 'Não há links externos',
  'app.pages.externalLink.selectApiKey': 'Selecione uma chave API',
  'app.pages.externalLink.executor': 'Executor',
  'app.pages.externalLink.noApiEndpoints': 'Não há endpoints de API',

  //API keys manager
  'app.pages.apiKeysManager.alias': 'Pseudônimo',
  'app.pages.apiKeysManager.key': 'Chave',
  'app.pages.apiKeysManager.active': 'Ativa',
  'app.pages.apiKeysManager.lastKeyChange': 'Última mudança de chave',
  'app.pages.apiKeysManager.showApiKeys': 'Mostrar chaves API',
  'app.pages.apiKeysManager.createApiKeys': 'Criar chave API',
  'app.pages.apiKeysManager.editApiKeys': 'Editar chave API',
  'app.pages.apiKeysManager.deleteApiKeys': 'Excluir chave API',
  'app.pages.apiKeysManager.noApiKeys': 'Não há chaves API',
  'app.pages.apiKeysManager.apiKey': 'Chave API',
  'app.pages.apiKeysManager.deleteApiKeyMessage': 'Tem certeza de que deseja excluir a chave API?',
  'app.pages.apiKeysManager.apiKeyDeleted': 'Chave API excluída',
  'app.pages.apiKeysManager.apiKeyUpdated': 'Chave API atualizada',
  'app.pages.apiKeysManager.apiKeyCreated': 'Chave API criada',
  'app.pages.apiKeysManager.keyCopied': 'Chave copiada',
  'app.pages.apiKeysManager.saveKeyAlert':
    'Atenção! A chave API estará visível apenas nesta ocasião. Certifique-se de copiá-la agora mesmo',
  'app.pages.apiKeysManager.keyId': 'Id da chave',

  //App consolidation
  'app.pages.appConsolidation.sourceAppVersion': 'Versão do aplicativo de origem',
  'app.pages.appConsolidation.differences': 'Diferenças',
  'app.pages.appConsolidation.summary': 'Resumo',
  'app.pages.appConsolidation.businessRules': 'Regras do negócio',
  'app.pages.appConsolidation.includeAllModules': 'Incluir todos',
  'app.pages.appConsolidation.includeAllInterfaces': 'Incluir todas',
  'app.pages.appConsolidation.replaceMatchingNodes':
    'Substituir os nós coincidentes fora destes módulos',
  'app.pages.appConsolidation.versionMetadata': 'Metadados da versão',
  'app.pages.appConsolidation.itemAdded': '{name} adicionada/o',
  'app.pages.appConsolidation.itemDeleted': '{name} excluída/o',
  'app.pages.appConsolidation.itemEdited': '{name} editada/o',
  'app.pages.appConsolidation.itemsAdded': '{name} adicionadas/os',
  'app.pages.appConsolidation.itemsDeleted': '{name} excluídas/os',
  'app.pages.appConsolidation.itemsEdited': '{name} editadas/os',
  'app.pages.appConsolidation.noChanges': 'Sem mudanças',
  'app.pages.appConsolidation.confirmationDialogTitle': 'Confirmar alterações de consolidação',
  'app.pages.appConsolidation.confirmationDialogText1':
    'Tem certeza de que deseja confirmar as alterações?',
  'app.pages.appConsolidation.confirmationDialogText2':
    'As alterações aplicadas a {sections} são irreversíveis.',
  'app.pages.appConsolidation.compareDefinitionOnly': 'Comparar somente a definição',
  'app.pages.appConsolidation.versionFiles': 'Arquivos da versão',
  'app.pages.appConsolidation.appFiles': 'Arquivos do aplicativo',
  'app.pages.appConsolidation.appMetadata': 'Metadados do aplicativo',
  'app.pages.appConsolidation.scenarioFile': 'Arquivo de cenário',
  'app.pages.appConsolidation.scenarioFiles': 'Arquivos de cenários',
  'app.pages.appConsolidation.test': 'Test',
  'app.pages.appConsolidation.scenarios': 'Cenários',
  'app.pages.appConsolidation.tests': 'Tests',
  'app.pages.appConsolidation.skill': 'Skill',
  'app.pages.appConsolidation.skills': 'Skills',
  'app.pages.appConsolidation.htmlCode': 'HTML',
  'app.pages.appConsolidation.pythonCode': 'Código Python',

  //Office addin
  'app.pages.office.selectNode': 'Escolha um nó',

  //Notifications
  'app.pages.notifications.scheduler.taskFinished':
    'A tarefa {match1} finalizou com o estado {match2}',
  'app.pages.notifications.workflow.taskReady':
    'A tarefa {match1} do processo {match2} está pronta para começar',
  'app.pages.notifications.workflow.taskOverdueExtended':
    'A tarefa {match1} do processo {match2} está atrasada. Isso pode afetar a conclusão da sua tarefa {match3}',
  'app.pages.notifications.workflow.taskOverdue':
    'A tarefa {match1} do processo {match2} está atrasada',
  'app.pages.notifications.workflow.taskChangedStatus':
    'A tarefa {match1} do processo {match2} teve seu status alterado de {match3} para {match4}',
  'app.pages.notifications.workflow.processStarted': 'O processo {match1} foi iniciado',
  'app.pages.notifications.workflow.processUpToDateAgain':
    'O processo {match1} está novamente atualizado.',
  'app.pages.notifications.workflow.wroteComment':
    '{match1} escreveu o seguinte comentário na tarefa {match2} do processo {match3}: {match4}',
  'app.pages.notifications.title': 'Notificações',
  'app.pages.notifications.allNotifications': 'Todas',
  'app.pages.notifications.unReadNotifications': 'Não lida',
  'app.pages.notifications.noNotifications': 'Sem notificações',
  'app.pages.notifications.markAsRead': 'Marcar como Lida',
  'app.pages.notifications.maskAsUnread': 'Marcar como não lida',
  'app.pages.notifications.notificationDeleted': 'Notificação excluída',
  'app.pages.notifications.markAllAsRead': 'Marcar tudo como lido',
  'app.pages.notifications.yesterday': 'Ontem',
  'app.pages.notifications.unreadItem': 'Não lida',
  'app.pages.notifications.bellWithUnread': 'Notificações: {count} não lidas',
  'app.pages.notifications.moreOptions': 'Mais opções',
  'app.pages.notifications.filter': 'Filtrar',
  'app.pages.notifications.seeAll': 'Ver todas',
  'app.pages.notifications.onlyThisApp': 'Somente este app ({app})',
  'app.pages.notifications.onlyApp': 'Somente {app}',
  'app.pages.notifications.removeOnlyThisApp': 'Remover filtro: somente {app}',
  'app.pages.notifications.empty.noneTitle': 'Você não tem notificações',
  'app.pages.notifications.empty.noneBody':
    'Aqui você verá as mensagens que te enviarem e os avisos de processos e tarefas agendadas.',
  'app.pages.notifications.empty.noneInAppBody': 'Aqui você verá os avisos deste app.',
  'app.pages.notifications.empty.upToDateTitle': 'Você está em dia',
  'app.pages.notifications.empty.upToDateBody': 'Você não tem notificações não lidas.',
  'app.pages.notifications.empty.filteredTitle': 'Nada com este filtro',
  'app.pages.notifications.empty.filteredBody':
    'Tente outro filtro ou veja todas as suas notificações.',
  'app.pages.notifications.openApp.title': 'Abrir outro aplicativo',
  'app.pages.notifications.openApp.body': 'Para ver isto, <b>{app}</b> será aberto.',
  'app.pages.notifications.openApp.current': 'No momento você tem {app} aberto.',
  'app.pages.notifications.openApp.unsavedChanges':
    'Você tem alterações não salvas em <b>{app}</b>. Se abrir sem salvar, elas serão perdidas.',
  'app.pages.notifications.openApp.open': 'Abrir {app}',
  'app.pages.notifications.openApp.saveAndOpen': 'Salvar e abrir',
  'app.pages.notifications.openApp.openWithoutSaving': 'Abrir sem salvar',
  'app.pages.notifications.today': 'Hoje',
  'app.pages.notifications.delete': 'Excluir',
  'app.pages.notifications.messageDeleted': 'Mensagem excluída',
  'app.pages.notifications.back': 'Voltar',
  'app.pages.notifications.newMessagesHint':
    '{count, plural, one {Você tem # mensagem nova} other {Você tem # mensagens novas}}',
  'app.pages.notifications.removedUser': 'Usuário excluído',
  'app.pages.notifications.newMessage': 'Nova mensagem',
  'app.pages.notifications.inbox': 'Caixa de entrada',
  'app.pages.notifications.thisApp': 'Este app',
  'app.pages.notifications.allApps': 'Todos os apps',
  'app.pages.notifications.widget.allowCompose': 'Permitir escrever mensagens',
  'app.pages.notifications.seeAllInBell': 'Ver todas no sino',
  'app.pages.notifications.tab.received': 'Recebidas',
  'app.pages.notifications.tab.sent': 'Enviadas',
  'app.pages.notifications.filter.messages': 'Mensagens',
  'app.pages.notifications.filter.system': 'Sistema',
  'app.pages.notifications.empty.noSentTitle': 'Você não enviou mensagens',
  'app.pages.notifications.empty.noSentBody':
    'Com Nova mensagem você avisa algo a uma pessoa, a um departamento ou a uma equipe.',
  'app.pages.notifications.message.title': 'Mensagem',
  'app.pages.notifications.message.to': 'Para {to}',
  'app.pages.notifications.message.goTo': 'Ir para {target}',
  'app.pages.notifications.message.open': 'Abrir',
  'app.pages.notifications.sent.title': 'Mensagem enviada',
  'app.pages.notifications.sent.seenBy': 'Visto por {seen} de {total}',
  'app.pages.notifications.sent.people': 'Pessoas',
  'app.pages.notifications.sent.groupSeen': '{seen} de {total} viram',
  'app.pages.notifications.sent.seenAt': 'Visto · {when}',
  'app.pages.notifications.sent.pending': 'Pendente',
  'app.pages.notifications.sent.alsoByEmail': 'Também por e-mail',
  'app.pages.notifications.toast.received': '{sender} te enviou uma mensagem',
  'app.pages.notifications.toast.see': 'Ver',
  'app.pages.notifications.toast.sent':
    'Mensagem enviada para {count, plural, one {# pessoa} other {# pessoas}}',
  'app.pages.notifications.toast.seeSent': 'Ver enviadas',
  'app.pages.notifications.section.workflow': 'Minhas tarefas',
  'app.pages.notifications.section.scheduler': 'Tarefas agendadas',
  'app.pages.notifications.section.version_manager': 'Versões',
  'app.pages.notifications.section.scenario_manager': 'Cenários',
  'app.pages.notifications.section.file_manager': 'Arquivos',
  'app.pages.notifications.section.code': 'Código',
  'app.pages.notifications.section.automation_tests': 'Testes de automação',
  'app.pages.notifications.composer.people': 'Pessoas',
  'app.pages.notifications.composer.departments': 'Departamentos',
  'app.pages.notifications.composer.teams': 'Equipes',
  'app.pages.notifications.composer.members': '{count, plural, one {# membro} other {# membros}}',
  'app.pages.notifications.composer.overLimit':
    'Chega a mais de {limit} pessoas. Remova algum grupo.',
  'app.pages.notifications.composer.noReach': 'Ninguém desta seleção pode recebê-lo.',
  'app.pages.notifications.composer.noResults': 'Sem resultados para «{query}».',
  'app.pages.notifications.composer.to': 'Para',
  'app.pages.notifications.composer.addMore': 'Adicionar mais…',
  'app.pages.notifications.composer.toPlaceholder': 'Pessoas, departamentos ou equipes',
  'app.pages.notifications.composer.toHint':
    'Adicione pelo menos uma pessoa, um departamento ou uma equipe.',
  'app.pages.notifications.composer.message': 'Mensagem',
  'app.pages.notifications.composer.messagePlaceholder':
    'Escreva o aviso. Por exemplo: Liberei o plano, revisem a família Chocolates.',
  'app.pages.notifications.composer.atLimit': 'Você chegou ao máximo de 1000 caracteres.',
  'app.pages.notifications.composer.linkTo': 'Vincular a',
  'app.pages.notifications.composer.linkNone': 'Nenhum',
  'app.pages.notifications.composer.linkInterface': 'Interface',
  'app.pages.notifications.composer.linkSection': 'Seção',
  'app.pages.notifications.composer.noApp':
    'Para vincular a mensagem a uma interface ou seção, abra um aplicativo. Sem app, só o texto é enviado.',
  'app.pages.notifications.composer.alsoByEmail': 'Enviar também por e-mail',
  'app.pages.notifications.composer.advanced': 'Opções avançadas',
  'app.pages.notifications.composer.linkApp': 'Vincular a este aplicativo ({app})',
  'app.pages.notifications.composer.linkVersion': 'Abrir nesta versão ({version})',
  'app.pages.notifications.composer.send': 'Enviar',
  'app.pages.notifications.reply.label': 'Resposta',
  'app.pages.notifications.toast.replied': '{sender} respondeu sua mensagem',
  'app.pages.notifications.message.replies': 'Respostas',
  'app.pages.notifications.message.you': 'Você',
  'app.pages.notifications.message.replyTo': 'Responder a {name}',
  'app.pages.notifications.message.reply': 'Responder',
  'app.pages.notifications.message.unavailable': 'Esta mensagem não está mais disponível.',
  'app.pages.notifications.sent.tabReads': 'Leituras',
  'app.pages.notifications.sent.tabReplies': 'Respostas',
  'app.pages.notifications.sent.repliesCount':
    '{count, plural, one {# resposta} other {# respostas}}',
  'app.pages.notifications.sent.noReplies': 'Ainda não há respostas.',

  // AI Agents
  'app.pages.aiAgents.aiAgents': 'Agentes de IA',
  'app.pages.aiAgents.agentsUpdated': 'Agentes disponíveis atualizados',
  'app.pages.aiAgents.send': 'Enviar',
  'app.pages.aiAgents.newChat': 'Novo chat',
  'app.pages.aiAgents.memorySaved': 'Anotei isto na memória do aplicativo:',
  'app.pages.aiAgents.memoryManage': 'Administrar',
  'app.pages.aiAgents.downloadGeneratedFile': 'Baixar este arquivo',
  'app.pages.aiAgents.question.answer': 'Sobre «{question}»:',
  'app.pages.aiAgents.question.multiSelectHint': 'Selecione uma ou mais opções',
  'app.pages.aiAgents.question.confirm': 'Confirmar',
  'app.pages.aiAgents.question.other': 'Outro',
  'app.pages.aiAgents.question.otherPlaceholder': 'Escreva outra resposta',
  'app.pages.aiAgents.question.sendOther': 'Enviar resposta',
  'app.pages.aiAgents.showPrivacyStatement': 'Política de privacidade',
  'app.pages.aiAgents.chatSuccessfullyExported': 'Chat exportado com sucesso',
  'app.pages.aiAgents.dockToTheRight': 'Fixar à direita',
  'app.pages.aiAgents.dockToTheLeft': 'Fixar à esquerda',
  'app.pages.aiAgents.updateAvailableAgents': 'Atualizar agentes disponíveis',
  'app.pages.aiAgents.viewTraces': 'Ver rastreamentos',
  'app.pages.aiAgents.pinContextComponent': 'Fixar componente de contexto',
  'app.pages.aiAgents.ask': 'Perguntar',
  'app.pages.aiAgents.askAboutCoding': 'Descreva o código que você precisa',
  'app.pages.aiAgents.dictate': 'Ditar',
  'app.pages.aiAgents.inlineNoChanges': 'O agente não propôs alterações para este código.',
  'app.pages.aiAgents.cancelRecording': 'Cancelar',
  'app.pages.aiAgents.uploadFiles': 'Carregar arquivos',
  'app.pages.aiAgents.addInterfaceComponent': 'Adicionar componente da interface',
  'app.pages.aiAgents.pickComponentHint': 'Clique em um componente para adicioná-lo ao contexto',
  'app.pages.aiAgents.captureScreenArea': 'Capturar seção da tela',
  'app.pages.aiAgents.screenCaptureHint':
    'Arraste para selecionar a área a capturar. Pressione Esc para cancelar.',
  'app.pages.aiAgents.screenCapturePreparing': 'Preparando a captura...',
  'app.pages.aiAgents.screenCaptureError': 'Não foi possível capturar a área selecionada',
  'app.pages.aiAgents.uploadFilesDescription':
    'Carregar arquivos para adicionar contexto à conversa',
  'app.pages.aiAgents.filesUploaded': '{count} arquivo(s) carregado(s) com sucesso',
  'app.pages.aiAgents.contextUsageTooltip':
    'Uso de contexto: {percent}% ({used} de {budget} tokens). Ao atingir 100%, a conversa é compactada automaticamente, resumindo as mensagens mais antigas.',
  'app.pages.aiAgents.compactNow': 'Compactar conversa',
  'app.pages.aiAgents.compactingSession': 'Compactando conversa...',
  'app.pages.aiAgents.invalidFileType': 'Os arquivos permitidos devem ter extensão: {extensions}',
  'app.pages.aiAgents.fileTooLarge':
    'O arquivo "{fileName}" excede o tamanho máximo de {maxSize}MB',
  'app.pages.aiAgents.codeAssistant': 'Mostrar/ocultar assistente de código',
  'app.pages.aiAgents.unknownCodeClassification':
    'Só posso responder perguntas de código sobre Python.',
  'app.pages.aiAgents.sessionHistory': 'Histórico de sessões',
  'app.pages.aiAgents.restoreInterfaceChanges':
    'Também reverter as alterações da interface até este ponto',
  'app.pages.aiAgents.noSessionHistory': 'Sem sessões anteriores',
  'app.pages.aiAgents.disabledInSection': 'Este agente está desabilitado nesta seção',
  'app.pages.aiAgents.disabledRequiresAppOpen': 'Este agente precisa de um aplicativo aberto',
  'app.pages.aiAgents.aiDisabledTitle': 'Os recursos de IA não estão ativados',
  'app.pages.aiAgents.aiDisabledDescription':
    'Os recursos de IA não estão ativados para esta empresa. Entre em contato com o administrador para ativá-los em AI Settings.',
  'app.pages.aiAgents.aiDisabledPlaceholder': 'Os recursos de IA não estão ativados',
  'app.pages.aiAgents.customAgentsDisabledTitle': 'Este agente não está ativado',
  'app.pages.aiAgents.customAgentsDisabledDescription':
    'Os agentes personalizados não estão ativados para esta empresa, portanto os agentes definidos dentro deste aplicativo não podem ser usados. Escolha o agente Pyplan para continuar trabalhando, ou peça ao seu administrador para ativá-los em AI Settings.',
  'app.pages.aiAgents.customAgentsDisabledPlaceholder':
    'Este agente não está ativado para a sua empresa',
  'app.pages.aiAgents.tokenUsageMenuItem': 'Tokens de IA neste mês: {used} de {limit} ({percent}%)',
  'app.pages.aiAgents.tokenLimitReachedPlaceholder': 'Limite mensal de tokens de IA atingido',
  'app.pages.aiAgents.tokenLimitReachedTitle': 'Limite mensal de tokens de IA atingido',
  'app.pages.aiAgents.tokenLimitReachedDescription':
    'Esta empresa já usou todos os tokens de IA deste mês. Entre em contato com o administrador para aumentar ou remover o limite.',
  'app.pages.aiAgents.tokenUsageTooltip':
    'Você está se aproximando do seu limite de tokens de IA: {used} usados de {limit} ({percent}%)',
  'app.pages.aiAgents.tokenUsageAtLimitTooltip':
    'Você atingiu seu limite de tokens de IA: {used} usados de {limit}. A IA não está disponível até o próximo mês ou até que um administrador aumente o limite.',
  'app.pages.aiAgents.renameSession': 'Renomear sessão',
  'app.pages.aiAgents.deleteSession': 'Excluir sessão',
  'app.pages.aiAgents.editConversation': 'Editar conversa',
  'app.pages.aiAgents.restoreConversation': 'Restaurar conversa',
  'app.pages.aiAgents.restoreCheckpointConfirmation':
    'A mensagem selecionada voltará para o campo de entrada e ela, junto com as mensagens seguintes, será removida da conversa. Deseja continuar?',
  'app.pages.aiAgents.untitledSession': 'Sessão {date}',
  'app.pages.aiAgents.messages': 'mensagens',
  'app.pages.aiAgents.assistantComponentDeprecated': 'O componente de Assistente está obsoleto',

  // Secrets manager
  'app.pages.secretsManager.secretManager': 'Segredos',
  'app.pages.secretsManager.createSecret': 'Criar segredo',
  'app.pages.secretsManager.editSecret': 'Editar segredo',
  'app.pages.secretsManager.deleteSecret': 'Excluir segredo',
  'app.pages.secretsManager.deleteSecretConfirmation':
    'Tem certeza de que deseja excluir o segredo?',
  'app.pages.secretsManager.secretDeleted': 'Segredo excluído',
  'app.pages.secretsManager.secretUpdated': 'Segredo atualizado',
  'app.pages.secretsManager.secretCreated': 'Segredo criado',
  'app.pages.secretsManager.secretKey': 'Chave do segredo',
  'app.pages.secretsManager.secretValue': 'Valor do segredo',
  'app.pages.secretsManager.noSecrets': 'Nenhum segredo',
  'app.pages.secretsManager.secret': 'Segredo',
  'app.pages.secretsManager.allUsers': 'Todos os usuários',
  'app.pages.secretsManager.showSecretValue': 'Mostrar valor do segredo',
  'app.pages.secretsManager.hideSecretValue': 'Ocultar valor do segredo',
  'app.pages.secretsManager.secretKeyExists': 'Chave do segredo já existe',
  'app.pages.secretsManager.system': 'Sistema',

  // Application Analysis
  'app.pages.appAnalysis.analysisConfiguration': 'Configuração de análise',
  'app.pages.appAnalysis.detectNodesWithLargeDefinition': 'Detectar nós com definição grande',
  'app.pages.appAnalysis.detectingNodesWithLargeDefinition': 'Detectando nós com definição grande',
  'app.pages.appAnalysis.detectingNodesWithDeprecatedType': 'Detectando nós com tipo obsoleto',
  'app.pages.appAnalysis.detectingNotUsedNodes': 'Detectando nós não utilizados',
  'app.pages.appAnalysis.detectingAliasNodesWithoutOriginal':
    'Detectando nós alias sem nó original',
  'app.pages.appAnalysis.detectingEmptyModules': 'Detectando módulos vazios',
  'app.pages.appAnalysis.detectingMultiDimensionalDataArray':
    'Detectando dataarrays multidimensionais',
  'app.pages.appAnalysis.detectingLargeNodesEvaluationTime':
    'Detectando nós com tempo de avaliação grande',
  'app.pages.appAnalysis.detectingLargeInterfaces': 'Detectando interfaces grandes',
  'app.pages.appAnalysis.nodesWithLargeDefinitionDetected': 'Nós com definição grande detectados',
  'app.pages.appAnalysis.largeDefinitionNotFound':
    'Nenhum nó com mais de 50 linhas de código foi detectado',
  'app.pages.appAnalysis.largeDefinitionFound':
    'Foram detectados {count} nós com mais de 50 linhas de código',
  'app.pages.appAnalysis.detectNodesWithDeprecatedType': 'Detectar nós com tipo obsoleto',
  'app.pages.appAnalysis.nodesWithDeprecatedTypeDetected': 'Nós com tipo obsoleto detectados',
  'app.pages.appAnalysis.deprecatedTypeNotFound': 'Nenhum nó com tipo obsoleto foi detectado',
  'app.pages.appAnalysis.deprecatedTypeFound': 'Foram detectados {count} nós com tipo obsoleto',
  'app.pages.appAnalysis.detectNotUsedNodes': 'Detectar nós não utilizados',
  'app.pages.appAnalysis.notUsedNodesDetected': 'Nós não utilizados detectados',
  'app.pages.appAnalysis.notUsedNodesNotFound': 'Nenhum nó não utilizado foi detectado',
  'app.pages.appAnalysis.notUsedNodesFound': 'Foram detectados {count} nós não utilizados',
  'app.pages.appAnalysis.detectAliasNodesWithoutOriginal': 'Detectar nós alias sem nó original',
  'app.pages.appAnalysis.aliasNodesWithoutOriginalDetected': 'Nós alias sem nó original detectados',
  'app.pages.appAnalysis.aliasNodesWithoutOriginalNotFound':
    'Nenhum nó alias sem nó original foi detectado',
  'app.pages.appAnalysis.aliasNodesWithoutOriginalFound':
    'Foram detectados {count} nós alias sem nó original',
  'app.pages.appAnalysis.detectEmptyModules': 'Detectar módulos vazios',
  'app.pages.appAnalysis.emptyModulesDetected': 'Módulos vazios detectados',
  'app.pages.appAnalysis.emptyModulesNotFound': 'Nenhum módulo vazio foi detectado',
  'app.pages.appAnalysis.emptyModulesFound': 'Foram detectados {count} módulos vazios',
  'app.pages.appAnalysis.detectNodesWithNonExistingModule': 'Detectar nós com módulo inexistente',
  'app.pages.appAnalysis.nodesWithNonExistingModuleDetected':
    'Nós com módulo inexistente detectados',
  'app.pages.appAnalysis.nonExistingModuleNotFound':
    'Nenhum nó com módulo inexistente foi detectado',
  'app.pages.appAnalysis.nonExistingModuleFound':
    'Foram detectados {count} nós com módulo inexistente',
  'app.pages.appAnalysis.detectMultiDimensionalDataArray':
    'Detectar dataarrays multidimensionais com mais de: ',
  'app.pages.appAnalysis.multiDimensionalDataArrayDetected':
    'Dataarrays multidimensionais detectados',
  'app.pages.appAnalysis.multiDimensionalDataArrayNotFound':
    'Nenhum array de dados com mais de {dimensions} dimensões foi detectado',
  'app.pages.appAnalysis.multiDimensionalDataArrayFound':
    'Foram detectados {count} arrays de dados com mais de {dimensions} dimensões',
  'app.pages.appAnalysis.detectLargeNodesEvaluationTime':
    'Detectar nós com tempo de avaliação grande',
  'app.pages.appAnalysis.largeNodesEvaluationTimeDetected':
    'Nós com tempo de avaliação grande detectados',
  'app.pages.appAnalysis.largeNodesEvaluationTimeNotFound':
    'Nenhum nó com tempo de avaliação superior a 5 segundos foi detectado',
  'app.pages.appAnalysis.largeNodesEvaluationTimeGreaterThan5':
    'Foram encontrados nós com tempo de avaliação superior a 5 segundos',
  'app.pages.appAnalysis.largeNodesEvaluationTimeGreaterThan10':
    'Foram encontrados nós com tempo de avaliação superior a 10 segundos',
  'app.pages.appAnalysis.largeNodesEvaluationTimeGreaterThan20':
    'Foram encontrados nós com tempo de avaliação superior a 20 segundos',
  'app.pages.appAnalysis.detectLargeInterfaces': 'Detectar interfaces grandes',
  'app.pages.appAnalysis.largeInterfacesDetected': 'Interfaces grandes detectadas',
  'app.pages.appAnalysis.largeInterfacesNotFound':
    'Nenhuma interface com mais de 10 componentes foi detectada',
  'app.pages.appAnalysis.largeInterfacesMoreThan10':
    'Foram detectadas interfaces com mais de 10 componentes',
  'app.pages.appAnalysis.largeInterfacesLonger':
    'Foram detectadas interfaces com mais de 15 componentes',
  'app.pages.appAnalysis.detectLargeApplicationSize': 'Detectar tamanho grande do aplicativo',
  'app.pages.appAnalysis.largeApplicationSizeDetected': 'Tamanho grande do aplicativo detectado',
  'app.pages.appAnalysis.largeApplicationSizeNotFound': 'O tamanho do aplicativo é inferior a 1GB',
  'app.pages.appAnalysis.largeApplicationSizeGreaterThan1GB':
    'O tamanho do aplicativo é superior a 1GB',
  'app.pages.appAnalysis.detectLargeAppVersions': 'Detectar versões grandes do aplicativo',
  'app.pages.appAnalysis.largeAppVersionsDetected': 'Versões grandes do aplicativo detectadas',
  'app.pages.appAnalysis.largeAppVersionsNotFound':
    'Nenhuma versão do aplicativo com mais de 200MB de dados foi detectada',
  'app.pages.appAnalysis.largeAppVersionsGreaterThan200MB':
    'Foram detectadas versões do aplicativo com mais de 200MB de dados',
  'app.pages.appAnalysis.detectDashComponents': 'Detectar componentes Dash',
  'app.pages.appAnalysis.dashComponentsDetected': 'Componentes Dash detectados',
  'app.pages.appAnalysis.dashComponentsNotFound': 'Nenhum componente Dash foi detectado',
  'app.pages.appAnalysis.interfaceWithDashComponentsFound':
    'Foram detectadas {count} interfaces com componentes Dash',
  'app.pages.appAnalysis.runningAnalysis': 'Executando análise',
  'app.pages.appAnalysis.analysisReport': 'Relatório de análise',
  'app.pages.appAnalysis.runAnalysis': 'Executar análise',
  'app.pages.appAnalysis.newAnalysis': 'Nova análise',
  'app.pages.appAnalysis.analysisDate': 'Data de análise',
  'app.pages.appAnalysis.countOfLines': 'Contagem de linhas',
  'app.pages.appAnalysis.nodeClass': 'Classe de nó',
  'app.pages.appAnalysis.evaluationTime': 'Tempo de avaliação',
  'app.pages.appAnalysis.countOfComponents': 'Contagem de componentes',
  'app.pages.appAnalysis.nodesMustBeCalculated':
    'Os nós devem estar calculados para realizar esta análise',
  'app.pages.appAnalysis.copyAllAnalysisData': 'Copiar todos os dados de análise',
  'app.pages.appAnalysis.exportAnalysisCsv': 'Exportar análise como CSV',
  'app.pages.appAnalysis.exportAnalysisExcel': 'Exportar análise como Excel',
  'app.pages.appAnalysis.analysisReportDownloaded': 'Relatório de análise baixado',
  'app.pages.appAnalysis.applicationSize': 'Tamanho do aplicativo',
  'app.pages.appAnalysis.versionSize': 'Tamanho da versão',
  'app.pages.appAnalysis.componentName': 'Nome do componente',
  'app.pages.appAnalysis.versionPath': 'Caminho da versão',
  'app.pages.appAnalysis.applicationPath': 'Caminho do aplicativo',
  'app.pages.appAnalysis.detectBadPractices':
    'Detectar possíveis más práticas nas definições de nós',
  'app.pages.appAnalysis.detectBadPracticesInfo':
    'Informa o uso de self.model e invalidações manuais (invalidate, silentInvalidate, invalidateOutputs, invalidate_nodes) nas definições dos nós. São avisos para revisar: alguns usos, como em nós botão ou fluxos de carga de dados, são legítimos',
  'app.pages.appAnalysis.badPracticesDetected': 'Possíveis más práticas nas definições de nós',
  'app.pages.appAnalysis.badPracticesNotFound':
    'Nenhuma má prática foi detectada nas definições dos nós',
  'app.pages.appAnalysis.badPracticesFound':
    'Foram detectadas {count} possíveis más práticas nas definições dos nós. Revise-as: alguns usos podem ser legítimos',
  'app.pages.appAnalysis.practice': 'Prática',
  'app.pages.appAnalysis.lines': 'Linhas',
  'app.pages.appAnalysis.practiceSelfModel': 'Uso de self.model',
  'app.pages.appAnalysis.practiceManualInvalidation': 'Invalidação manual',

  //Upload manager
  'app.pages.app.uploadmanager.showBaseFile': 'Mostrar arquivo base',
  'app.pages.app.uploadmanager.showCurrentFile': 'Mostrar arquivo atual',
  'app.pages.app.uploadmanager.showLastModifiedDate': 'Mostrar última data de modificação',
  'app.pages.app.uploadmanager.showLastModifiedUser': 'Mostrar último usuário modificado',
  'app.pages.app.uploadmanager.addNewFileUploadItem':
    'Adicionar novo item de carregamento de arquivo',
  'app.pages.app.uploadmanager.baseFilePath': 'Caminho do arquivo base',
  'app.pages.app.uploadmanager.currentFilePath': 'Caminho do arquivo atual',
  'app.pages.app.uploadmanager.validationNode': 'Nó de validação (opcional)',
  'app.pages.app.uploadmanager.callbackNode': 'Nó de callback (opcional)',
  'app.pages.app.uploadmanager.invalidateNode': 'Nó a invalidar (opcional)',
  'app.pages.app.uploadmanager.runNodesOnRestore':
    'Executar nós de callback e invalidação ao restaurar um arquivo do histórico',
  'app.pages.app.uploadmanager.historyCount': 'Quantidade de históricos',
  'app.pages.app.uploadmanager.autoValidationTitle':
    'Validação automática com base no arquivo base',
  'app.pages.app.uploadmanager.toggleValidationOptions': 'Mostrar/ocultar validação automática',
  'app.pages.app.uploadmanager.validateSheets': 'Validar planilhas',
  'app.pages.app.uploadmanager.validateColumnNames': 'Validar nomes das colunas',
  'app.pages.app.uploadmanager.validateColumnTypes': 'Validar tipos das colunas',
  'app.pages.app.uploadmanager.preserveExistingFilename': 'Preservar nome de arquivo existente',
  'app.pages.app.uploadmanager.historyPath': 'Caminho para salvar histórico (opcional)',
  'app.pages.app.uploadmanager.navigateToInterface': 'Navegar para interface (opcional)',
  'app.pages.app.uploadmanager.displayOptionsTitle': 'Opções de visualização',
  'app.pages.app.uploadmanager.toggleDisplayOptions': 'Mostrar/ocultar opções de visualização',
  'app.pages.app.uploadmanager.showBaseDownload': 'Mostrar botão de baixar do arquivo base',
  'app.pages.app.uploadmanager.showUpload': 'Mostrar botão de carregar',
  'app.pages.app.uploadmanager.showDownload': 'Mostrar botão de baixar',
  'app.pages.app.uploadmanager.showHistory': 'Mostrar histórico de arquivos',
  'app.pages.app.uploadmanager.accessTitle': 'Acesso',
  'app.pages.app.uploadmanager.toggleAccessOptions': 'Mostrar/ocultar opções de acesso',
  'app.pages.app.uploadmanager.accessDescription':
    'Quem pode ver e enviar este arquivo. Usuários que podem editar interfaces também o veem no modo de edição.',
  'app.pages.app.uploadmanager.accessEveryone': 'Todos',
  'app.pages.app.uploadmanager.accessByDepartments': 'Por departamentos',
  'app.pages.app.uploadmanager.accessByUsers': 'Por usuários',
  'app.pages.app.uploadmanager.accessDepartments': 'Departamentos',
  'app.pages.app.uploadmanager.accessUsers': 'Usuários',
  'app.pages.app.uploadmanager.accessDepartmentsRequired': 'Selecione pelo menos um departamento',
  'app.pages.app.uploadmanager.accessUsersRequired': 'Selecione pelo menos um usuário',
  'app.pages.app.uploadmanager.accessDepartmentsUnavailable':
    'Não foi possível carregar os departamentos. Configurados: {departments}',
  'app.pages.app.uploadmanager.accessUnknownUser': 'Usuário não encontrado ({id})',
  'app.pages.app.uploadmanager.restrictedAccess': 'Acesso restrito',
  'app.pages.app.uploadmanager.restrictedAccessDepartments': 'Departamentos ({count})',
  'app.pages.app.uploadmanager.restrictedAccessUsers': 'Usuários ({count})',
  'app.pages.app.uploadmanager.restrictedAccessMore': '+{count} mais',
  'app.pages.app.uploadmanager.restrictedAccessNone': 'Ninguém atribuído',
  'app.pages.app.uploadmanager.restrictedAccessLoading': 'Carregando...',
  'app.pages.app.uploadmanager.selectHistoryPath': 'Selecionar caminho de histórico',
  'app.pages.app.uploadmanager.downloadBaseFile': 'Baixar arquivo base',
  'app.pages.app.uploadmanager.uploadFile': 'Carregar arquivo',
  'app.pages.app.uploadmanager.downloadFile': 'Baixar arquivo',
  'app.pages.app.uploadmanager.selectInterfaceForNavigation': 'Selecionar interface para navegação',
  'app.pages.app.uploadmanager.validatigFile': 'Validando arquivo',
  'app.pages.app.uploadmanager.basePathModeForFiles': 'Modo de caminho base para arquivos',
  'app.pages.app.uploadmanager.relativeToApplication': 'Relativo ao aplicativo',
  'app.pages.app.uploadmanager.relativeToVersion': 'Relativo à versão',
  'app.pages.app.uploadmanager.viewHistory': 'Ver histórico',
  'app.pages.app.uploadmanager.fileRestored': 'Arquivo restaurado',
  'app.pages.app.uploadmanager.fileRestoreError': 'Erro ao restaurar arquivo',
  'app.pages.app.uploadmanager.fileRestoredWithErrors': 'Arquivo restaurado com erros',
  'app.pages.app.uploadmanager.historyFiles': 'Arquivos de histórico',
  'app.pages.app.uploadmanager.restoringFile': 'Restaurando arquivo',
  'app.pages.app.uploadmanager.noHistoryFiles': 'Nenhum arquivo de histórico encontrado',
  'app.pages.app.uploadmanager.restoreFile': 'Restaurar arquivo',
  'app.pages.app.uploadmanager.confirmRestoreTitle': 'Confirmar restauração',
  'app.pages.app.uploadmanager.confirmRestoreContent':
    'Tem certeza de que deseja restaurar este arquivo? Esta ação substituirá o arquivo atual.',
  'app.pages.app.uploadmanager.downloadAllFiles': 'Baixar todos os arquivos',
  'app.pages.app.uploadmanager.fileDownloaded': 'Arquivo baixado',
  'app.pages.app.uploadmanager.fileDownloadError': 'Erro ao baixar arquivo',
  'app.pages.app.uploadmanager.confirmDeleteMessage':
    'Tem certeza de que deseja excluir este arquivo? Isso removerá o arquivo e seu histórico.',
  'app.pages.app.uploadmanager.noUploadItems': 'Nenhum item de upload encontrado',
  'app.pages.app.uploadmanager.baseFile': 'Arquivo base',
  'app.pages.app.uploadmanager.additionalInformationOfFile': 'Informações adicionais do arquivo',
  'app.pages.app.uploadmanager.fileSize': 'Tamanho do arquivo',
  'app.pages.app.uploadmanager.showFileSize': 'Mostrar tamanho do arquivo',
  'app.pages.app.uploadmanager.removeFile': 'Remover arquivo',
  'app.pages.app.uploadmanager.fileRemoved': 'Arquivo removido',
  'app.pages.app.uploadmanager.fileRemoveError': 'Erro ao remover arquivo',
  'app.pages.app.uploadmanager.confirmRemoveTitle': 'Confirmar remoção de arquivo',
  'app.pages.app.uploadmanager.confirmRemoveContent':
    'Tem certeza de que deseja remover o arquivo? Esta ação não pode ser desfeita.',
  'app.pages.app.uploadmanager.useFolderPath': 'Usar caminho de pasta',
  'app.pages.app.uploadmanager.currentFolderPath': 'Caminho da pasta atual',
  'app.pages.app.uploadmanager.viewFolderFiles': 'Ver arquivos da pasta',
  'app.pages.app.uploadmanager.folderFiles': 'Arquivos da pasta',
  'app.pages.app.uploadmanager.loadingFiles': 'Carregando arquivos da pasta...',
  'app.pages.app.uploadmanager.filePathMustBeFile':
    'O caminho do arquivo deve apontar para um arquivo, não para uma pasta',
  'app.pages.app.uploadmanager.selectFileModeFile': 'Selecionar modo de arquivo',
  'app.pages.app.uploadmanager.selectFileModeFolder': 'Selecionar modo de pasta',
  'app.pages.app.uploadmanager.noFilesInFolder': 'Nenhum arquivo encontrado na pasta',
  'app.pages.app.uploadmanager.validationStartRow': 'Linha de início da validação',
  'app.pages.app.uploadmanager.unknownError': 'Erro desconhecido',
  'app.pages.app.uploadmanager.Temporary_file_does_not_exist': 'O arquivo temporário não existe',
  'app.pages.app.uploadmanager.Base_file_extension_mismatch':
    'Extensão do arquivo base não corresponde',
  'app.pages.app.uploadmanager.Validation_node_failed': 'O nó de validação falhou',
  'app.pages.app.uploadmanager.Validation_node_not_callable': 'O nó de validação não é chamável',
  'app.pages.app.uploadmanager.Base_file_does_not_exist': 'O arquivo base não existe',
  'app.pages.app.uploadmanager.Sheet_names_do_not_match': 'Os nomes das planilhas não correspondem',
  'app.pages.app.uploadmanager.Both_files_must_be_excel':
    'Ambos os arquivos devem ser arquivos do Excel',
  'app.pages.app.uploadmanager.Column_names_do_not_match': 'Os nomes das colunas não correspondem',
  'app.pages.app.uploadmanager.Column_type_mismatch': 'Incompatibilidade de tipo de coluna',
  'app.pages.app.uploadmanager.Uploaded_file_missing_columns':
    'O arquivo enviado está faltando colunas',
  'app.pages.app.uploadmanager.Uploaded_file_extra_columns': 'O arquivo enviado tem colunas extras',
  'app.pages.app.uploadmanager.History_directory_does_not_exist':
    'O diretório de histórico não existe',
  'app.pages.app.uploadmanager.Failed_to_move_file': 'Falha ao mover o arquivo',
  'app.pages.app.uploadmanager.Callback_node_not_callable': 'O nó de callback não é chamável',
  'app.pages.app.uploadmanager.Callback_node_failed': 'Erro ao executar o nó de callback',
  'app.pages.app.uploadmanager.Invalidate_node_failed': 'Erro ao invalidar o nó',
  'app.pages.app.uploadmanager.File_uploaded_successfully': 'Arquivo enviado com sucesso',
  'app.pages.app.uploadmanager.Upload_item_not_found':
    'O item de arquivo não existe mais neste componente',
  'app.pages.app.uploadmanager.Upload_item_access_denied':
    'Você não tem acesso para enviar este arquivo',

  // AI Agents
  'app.aiAgents.agentStatus.WAITING': 'Esperando',
  'app.aiAgents.agentStatus.REASONING': 'Raciocinando',
  'app.aiAgents.agentStatus.SEARCHING': 'Procurando',
  'app.aiAgents.agentStatus.GENERATING': 'Gerando',
  'app.aiAgents.agentStatus.RESPONDING': 'Respondendo',
  'app.aiAgents.agentStatus.USING_TOOL': 'Usando ferramenta',
  'app.aiAgents.agentStatus.EXECUTING_TOOL': 'Executando ferramenta',
  'app.aiAgents.agentStatus.COMPLETED': 'Concluído',
  'app.aiAgents.agentStatus.INDEXING_DOCUMENTS': 'Indexando documentos',
  'app.aiAgents.agentStatus.EXECUTING_CONTEXT_NODES': 'Executando nós de contexto',
  'app.aiAgents.agentStatus.COMPACTING': 'Compactando',
  'app.aiAgents.reasoning.title': 'Raciocínio',
  'app.aiAgents.toolCall.used': 'Ferramenta usada:',
  'app.aiAgents.activity.working': 'Trabalhando…',
  'app.aiAgents.activity.reasoning': 'raciocinando',
  'app.aiAgents.activity.steps': '{count, plural, one {# passo} other {# passos}}',
  'app.aiAgents.activity.reasoned': 'Raciocinou',
  'app.pages.aiSettings.title': 'Configurações de IA',
  'app.pages.aiSkills.title': 'Skills e memória',
  'app.pages.mcpUsage.title': 'Uso de MCP',
  'app.pages.mcpUsage.client': 'Cliente',
  'app.pages.mcpUsage.action': 'Ação',
  'app.pages.mcpUsage.application': 'Aplicativo',
  'app.pages.mcpUsage.result': 'Resultado',
  'app.pages.mcpUsage.detail': 'Detalhe',
  'app.pages.mcpUsage.noEvents': 'Nenhuma atividade MCP registrada para estes filtros',
  'app.pages.mcpUsage.includeInternal': 'Incluir assistente interno',
  'app.pages.mcpUsage.includeInternalHint':
    'O assistente do Pyplan usa os mesmos endpoints MCP. Fica oculto por padrão para que esta página mostre apenas os clientes externos.',
  'app.pages.mcpUsage.outcome.ok': 'OK',
  'app.pages.mcpUsage.outcome.denied': 'Negado',
  'app.pages.mcpUsage.outcome.invalid': 'Inválido',
  'app.pages.mcpUsage.outcome.gone': 'App fechado',
  'app.pages.mcpUsage.outcome.unavailable': 'IA desligada',
  'app.pages.mcpUsage.outcome.error': 'Erro',
  'app.pages.mcpUsage.clientType.mcpToken': 'Cliente MCP',
  'app.pages.mcpUsage.clientType.pat': 'Token de acesso',
  'app.pages.mcpUsage.clientType.session': 'Sessão do Pyplan',
  'app.pages.mcpUsage.clientType.internal': 'Assistente interno',
  'app.pages.mcpUsage.clientType.unknown': 'Desconhecido',
  'app.pages.mcpUsage.summary': 'Resumo',
  'app.pages.mcpUsage.totalCalls': 'Chamadas',
  'app.pages.mcpUsage.activeUsers': 'Usuários',
  'app.pages.mcpUsage.appsTouched': 'Aplicativos',
  'app.pages.mcpUsage.errorRate': 'Taxa de erro',
  'app.pages.mcpUsage.deniedRate': 'Negadas',
  'app.pages.mcpUsage.writeRate': 'Escritas',
  'app.pages.mcpUsage.errorRateHint': 'Chamadas que falharam dentro do Pyplan ({count} de {total})',
  'app.pages.mcpUsage.deniedRateHint':
    'Chamadas recusadas por falta de permissão ({count} de {total})',
  'app.pages.mcpUsage.writeRateHint':
    'Chamadas de tools que alteram o aplicativo ({count} de {total})',
  'app.pages.mcpUsage.topTools': 'Tools mais usadas',
  'app.pages.mcpUsage.failingTools': 'Tools que mais falham',
  'app.pages.mcpUsage.topClients': 'Clientes',
  'app.pages.mcpUsage.topUsers': 'Usuários',
  'app.pages.mcpUsage.topApps': 'Aplicativos',
  'app.pages.mcpUsage.topEndpoints': 'Operações',
  'app.pages.mcpUsage.topSkills': 'Skills mais carregadas',
  'app.pages.mcpUsage.activity': 'Atividade',
  'app.pages.mcpUsage.failedLabel': '{count} com falha',
  'app.pages.mcpUsage.noData': 'Sem dados',
  'app.pages.mcpUsage.showSummary': 'Mostrar resumo',
  'app.pages.mcpUsage.hideSummary': 'Ocultar resumo',
  'app.pages.mcpUsage.showMoreIndicators': 'Mais indicadores',
  'app.pages.mcpUsage.hideMoreIndicators': 'Menos indicadores',
  'app.pages.aiCosts.title': 'Custos de IA',
  'app.pages.aiCosts.periodFrom': 'De',
  'app.pages.aiCosts.periodTo': 'Até',
  'app.pages.aiCosts.clearFilters': 'Limpar filtros',
  'app.pages.aiCosts.exportCsv': 'Exportar CSV',
  'app.pages.aiCosts.exportCsvTooltip': 'Uma linha por empresa, mês, atribuição e modelo',
  'app.pages.aiCosts.unpricedSuffix': '{tokens} sem tarifa',
  'app.pages.aiCosts.company': 'Empresa',
  'app.pages.aiCosts.period': 'Período',
  'app.pages.aiCosts.clientCost': 'Faturável ao cliente',
  'app.pages.aiCosts.internalCost': 'Interno',
  'app.pages.aiCosts.totalCost': 'Total',
  'app.pages.aiCosts.totalsAllRows': 'Total — {count} linhas no total',
  'app.pages.aiCosts.tokens': 'Tokens',
  'app.pages.aiCosts.runs': 'Execuções',
  'app.pages.aiCosts.noData': 'Nenhum consumo de IA registrado para este período.',
  'app.pages.aiCosts.unpricedWarningTitle': 'Estes valores estão subestimados',
  'app.pages.aiCosts.unpricedWarningBody':
    'Alguns modelos consumiram tokens sem tarifa configurada, portanto foram custeados em zero. Carregue suas tarifas em AI Pricing e os valores ficarão corretos a partir de então — o consumo passado permanece em zero.',
  'app.pages.aiCosts.unpricedModelLine': '{model} ({provider}): {tokens} tokens — {companies}',
  'app.pages.aiCosts.internalNote':
    'O uso interno vem dos domínios de e-mail permitidos em AI Settings. Não é faturável e não consome a cota da empresa.',
  'app.pages.aiCosts.modelBreakdown': 'Detalhamento por modelo',
  'app.pages.aiCosts.model': 'Modelo',
  'app.pages.aiCosts.attribution': 'Atribuição',
  'app.pages.aiCosts.invalidPeriod': 'Use o formato YYYY-MM',
  'app.pages.aiSkills.newSkill': 'Novo skill',
  'app.pages.aiSkills.editSkill': 'Editar skill',
  'app.pages.aiSkills.deleteConfirmMessage': 'Tem certeza de que deseja excluir este skill?',
  'app.pages.aiSkills.noSkillsFound': 'Nenhum skill encontrado',
  'app.pages.aiSkills.noAppOpenMessage':
    'Abra um aplicativo para ver e gerenciar seus skills. Por enquanto, apenas os skills da empresa são exibidos.',
  'app.pages.aiSkills.name': 'Nome',
  'app.pages.aiSkills.level': 'Nível',
  'app.pages.aiSkills.category': 'Categoria',
  'app.pages.aiSkills.content': 'Conteúdo (SKILL.md)',
  'app.pages.aiSkills.levelCompany': 'Empresa',
  'app.pages.aiSkills.levelApp': 'Aplicativo',
  'app.pages.aiSkills.nameHelp': 'Letras, números, espaços, hífens, sublinhados e pontos.',
  'app.pages.aiSkills.back': 'Voltar aos skills',
  'app.pages.aiSkills.import': 'Importar',
  'app.pages.aiSkills.export': 'Exportar',
  'app.pages.aiSkills.deleteConfirmTitle': 'Confirmar exclusão',
  'app.pages.aiSkills.successDeleted': 'Excluído com sucesso',
  'app.pages.aiSkills.successCreated': 'Criado com sucesso',
  'app.pages.aiSkills.successUpdated': 'Atualizado com sucesso',
  'app.pages.aiSkills.fieldRequired': 'Campo obrigatório',
  'app.pages.aiSkills.tabSkills': 'Skills',
  'app.pages.aiSkills.tabMemory': 'Memória',
  'app.pages.aiSkills.newMemory': 'Nova memória',
  'app.pages.aiSkills.editMemory': 'Editar memória',
  'app.pages.aiSkills.deleteMemoryConfirmMessage':
    'Tem certeza de que deseja excluir esta memória?',
  'app.pages.aiSkills.noMemoriesFound': 'Este aplicativo ainda não aprendeu nada',
  'app.pages.aiSkills.memoryText': 'Memória',
  'app.pages.aiSkills.memoryAgent': 'Agente',
  'app.pages.aiSkills.memoryAgentHelp':
    'Somente este agente a lê. Cada agente tem sua própria memória.',
  'app.pages.aiSkills.memoryUpdated': 'Atualizada',
  'app.pages.aiSkills.memoryStaleHint':
    'Faz muito tempo que não é alterada. Verifique se ainda é válida.',
  'app.pages.aiSkills.memoryTextHelp':
    'Uma orientação sobre como trabalhar neste aplicativo. {count}/{max}',
  'app.pages.aiSkills.memoryTooLong': 'Uma memória pode ter no máximo {max} caracteres',
  'app.pages.aiSkills.memoryCountForAgent': '{count} de {max} memórias de {agent}',
  'app.pages.aiSkills.memoryCountAllAgents':
    '{count, plural, one {# memória} other {# memórias}} em {agents, plural, one {# agente} other {# agentes}}',
  'app.pages.aiSkills.allAgents': 'Todos',
  'app.pages.aiSkills.categoryWorkflow': 'Forma de trabalho',
  'app.pages.aiSkills.memoryAppliesTo': 'Aplica-se em',
  'app.pages.aiSkills.memoryAppliesToHelp': 'Só é passada ao chat enquanto se trabalha ali.',
  'app.pages.aiSkills.sectionAll': 'Todas as seções',
  'app.pages.aiSkills.sectionCode': 'Diagrama e código',
  'app.pages.aiSkills.sectionInterfaces': 'Interfaces',
  'app.pages.aiSkills.memoryOrigin': 'Aprendida de {source}, na conversa',
  'app.pages.aiSkills.sourceRework': 'ter tido que refazer o trabalho',
  'app.pages.aiSkills.sourceCorrection': 'uma correção',
  'app.pages.aiSkills.sourceFailure': 'falhas repetidas',
  'app.pages.aiSkills.sourceUserRequest': 'um pedido explícito',
  'app.pages.aiSkills.categoryStyle': 'Estilo',
  'app.pages.aiSkills.categoryPitfall': 'Erro frequente',
  'app.pages.aiSkills.noAppOpenMemoryMessage':
    'Abra um aplicativo para ver e administrar sua memória.',
  'app.pages.aiSkills.memoryDisabledMessage':
    'A memória está desligada para esta empresa, portanto os agentes não a leem nem a escrevem. As memórias abaixo são mantidas e voltarão a ser usadas se ela for ligada novamente.',
  'app.pages.aiSettings.currentCompany': 'Empresa atual',
  'app.pages.aiSettings.agentPreferencesTab': 'Preferências de agentes',
  'app.pages.aiSettings.appTranslationsTab': 'Traduções do app',
  'app.pages.aiSettings.appTranslationsDefault': 'Parâmetros de tradução',
  'app.pages.aiSettings.appTranslationsSaveSuccess':
    'As configurações de tradução foram salvas com sucesso',
  'app.pages.aiSettings.invalidJson': 'Formato JSON inválido',
  'app.pages.aiSettings.saveSuccess': 'As configurações de IA foram salvas com sucesso',
  'app.pages.aiSettings.availabilityTab': 'Disponibilidade',
  'app.pages.aiSettings.availabilityCompanyTitle': 'Empresa atual',
  'app.pages.aiSettings.availabilityGlobalTitle': 'Valor global padrão',
  'app.pages.aiSettings.aiEnabled': 'Recursos de IA ativados',
  'app.pages.aiSettings.aiEnabledHelp':
    'Ao desativar, todos os recursos de IA são desligados para esta empresa, incluindo o uso de MCP.',
  'app.pages.aiSettings.useGlobalLimit': 'Usar o limite global ({value})',
  'app.pages.aiSettings.customAgentsEnabled': 'Agentes personalizados ativados',
  'app.pages.aiSettings.customAgentsEnabledHelp':
    'Quando desativado, os agentes definidos dentro dos aplicativos não podem ser usados, nem por chat nem por MCP. O agente Pyplan integrado continua funcionando.',
  'app.pages.aiSettings.agentsInProcessesEnabled': 'Agentes em processos ativados',
  'app.pages.aiSettings.agentsInProcessesEnabledHelp':
    'Quando desativado, não é possível atribuir agentes às tarefas de um processo e os já atribuídos não são executados. O chat não é afetado.',
  'app.pages.aiSettings.globalAlwaysEnabledHelp':
    'Os recursos de IA e os agentes personalizados estão sempre ativados globalmente. Desative-os por empresa no painel à esquerda.',
  'app.pages.aiSettings.monthlyTokenLimit': 'Limite mensal de tokens',
  'app.pages.aiSettings.monthlyTokenLimitHelp':
    '0 significa ilimitado. Um aviso é exibido a partir de 80%.',
  'app.pages.aiSettings.monthlyTokenLimitInvalid': 'Informe um número inteiro de 0 ou mais',
  'app.pages.aiSettings.tokensUsedThisMonth': 'Usado neste mês',
  'app.pages.aiSettings.tokensUnlimited': 'ilimitado',
  'app.pages.aiSettings.fullAccessEmailDomains': 'Domínios de e-mail com acesso total',
  'app.pages.aiSettings.fullAccessEmailDomainsHelp':
    'Domínios separados por vírgula que ignoram o interruptor de IA e o limite de tokens em todas as empresas. As permissões de função continuam valendo. Somente global.',
  'app.pages.aiSettings.availabilitySaveSuccess': 'A disponibilidade de IA foi salva com sucesso',
  // App tests
  'app.pages.app.sidebarMenu.createApplicationTest': 'Criar teste de aplicativo',
  'app.pages.app.sidebarMenu.editApplicationTest': 'Editar teste de aplicativo',
  'app.pages.app.sidebarMenu.deleteApplicationTest': 'Excluir teste de automação',
  'app.pages.app.sidebarMenu.duplicateApplicationTest': 'Duplicar teste de automação',
  'app.pages.applicationTests.checkType': 'Checar tipo',
  'app.pages.applicationTests.equalTo': 'Igual a',
  'app.pages.applicationTests.between': 'Entre',
  'app.pages.applicationTests.noEvaluationError': 'Sem erro de avaliação',
  'app.pages.applicationTests.expectedValue': 'Valor esperado',
  'app.pages.applicationTests.precondition': 'Pré-condição',
  'app.pages.applicationTests.selectorValues': 'Valores do seletor',
  'app.pages.applicationTests.addSelector': 'Adicionar seletor',
  'app.pages.applicationTests.addPrecondition': 'Adicionar pré-condição',
  'app.pages.applicationTests.areYouSureToDeleteApplicationTest':
    'Tem certeza de que deseja excluir os seguintes testes: {names}?',
  'app.pages.applicationTests.areYouSureToRunApplicationTests':
    'Tem certeza de que deseja executar os seguintes testes: {names}?',
  'app.pages.applicationTests.lastExecutionStatus': 'Último status de execução',
  'app.pages.applicationTests.lastExecutionDate': 'Última data de execução',
  'app.pages.applicationTests.testDeletedSuccessfully': 'Teste excluído com sucesso',
  'app.pages.applicationTests.testCreatedSuccessfully': 'Teste criado com sucesso',
  'app.pages.applicationTests.testUpdatedSuccessfully': 'Teste atualizado com sucesso',
  'app.pages.applicationTests.testDuplicatedSuccessfully': 'Teste duplicado com sucesso',
  'app.pages.applicationTests.runApplicationTests': 'Executar testes de aplicativo',
  'app.pages.applicationTests.mainMenuInterfaces': 'Menu principal de interfaces',
  'app.pages.applicationTests.newName': 'Novo nome',
  'app.pages.applicationTests.executeTests': 'Executar testes',
  'app.pages.applicationTests.executeTestsWithNames': 'Executar testes: {names}',
  'app.pages.applicationTests.sendEmails': 'Enviar e-mails sempre',
  'app.pages.applicationTests.emailRecipients': 'Destinatários de e-mail',
  'app.pages.applicationTests.sendOnFailureOnly': 'Enviar e-mails apenas em caso de falha',
  'app.pages.applicationTests.testExecutedSuccessfully': 'Teste agendado para execução',
  'app.pages.applicationTests.selectNodes': 'Selecionar nós',
  'app.pages.applicationTests.viewPreconditions': 'Ver pré-condições',
  'app.pages.applicationTests.settings': 'Configurações',
  'app.pages.applicationTests.areYouSureToExecuteTests':
    'Tem certeza de que deseja executar os testes selecionados?',
  'app.pages.applicationTests.settingsSavedSuccessfully': 'Configurações salvas com sucesso',
  'app.pages.applicationTests.testTypes': 'Tipos de teste',
  'app.pages.applicationTests.configureNodes': 'Configurar nós',
  'app.pages.applicationTests.permissions': 'Permissões',
  'app.pages.applicationTests.configurePermissions': 'Configurar permissões',
  'app.pages.applicationTests.permissionAssertionsCount':
    '{count, plural, one {# asserção} other {# asserções}}',
  'app.pages.applicationTests.permissionsInfo':
    'Cada asserção é avaliada para cada departamento do teste, como se o usuário pertencesse apenas a esse departamento. Os perfis de quem executa o teste são ignorados.',
  'app.pages.applicationTests.addPermissionAssertion': 'Adicionar asserção',
  'app.pages.applicationTests.noPermissionAssertions': 'Nenhuma asserção configurada',
  'app.pages.applicationTests.permissionItemType': 'Tipo',
  'app.pages.applicationTests.permissionItem': 'Item',
  'app.pages.applicationTests.expectedAccess': 'Acesso esperado',
  'app.pages.applicationTests.accessAllowed': 'Com acesso',
  'app.pages.applicationTests.accessDenied': 'Sem acesso',
  'app.pages.applicationTests.removePermissionAssertion': 'Remover asserção',
  'app.pages.applicationTests.permissionVersion': 'Versão',
  'app.pages.applicationTests.permissionType.folder': 'Pasta',
  'app.pages.applicationTests.permissionType.application': 'Aplicação',
  'app.pages.applicationTests.permissionType.application_version': 'Versão da aplicação',
  'app.pages.applicationTests.permissionType.interface': 'Interface',
  'app.pages.applicationTests.permissionType.interface_folder': 'Pasta de interface',
  'app.pages.applicationTests.permissionType.module': 'Módulo',
  'app.pages.applicationTests.noPreconditionsAdded': 'Nenhuma pré-condição adicionada',
  'app.pages.applicationTests.noNodesSelected': 'Nenhum nó selecionado',
  'app.pages.applicationTests.removeFilters': 'Remover filtros',
  'app.pages.applicationTests.viewLogs': 'Ver logs',
  'app.pages.applicationTests.executionTime': 'Tempo de execução',
  'app.pages.applicationTests.executionLogs': 'Logs de execução',
  'app.pages.applicationTests.viewTest': 'Ver teste',
  'app.pages.applicationTests.testExecutedOn': 'Teste executado em {date}',
  'app.pages.applicationTests.testExecutedInSeconds': 'em {duration} segundos',
  'app.pages.applicationTests.preconditionInfo':
    '(Opcional) Pré-condições a serem atendidas antes de executar o teste. Você pode adicionar nós seletor e valores esperados para esses nós.',
  'app.pages.applicationTests.automationTests': 'Testes de Automação',
  'app.pages.applicationTests.testNoExecutedYet': 'O teste ainda não foi executado',
  'app.pages.applicationTests.step': 'Passo',
  'app.pages.applicationTests.areYouSureToExecuteSingleTest':
    'Tem certeza de que deseja executar o teste?',
  'app.pages.applicationTests.executeSingleTest': 'Executar teste',
  'app.pages.applicationTests.hideDetails': 'Ocultar detalhes',
  'app.pages.applicationTests.noLogsAvailable': 'Nenhum log disponível',
  'app.pages.applicationTests.testPassed': 'Aprovado',
  'app.pages.applicationTests.testFailed': 'Reprovado',
  'app.pages.applicationTests.testSuccess': 'Bem-sucedida',
  'app.pages.applicationTests.usersToNotify': 'Usuários a notificar',
  'app.pages.applicationTests.notificationMode': 'Modo de notificação',
  'app.pages.applicationTests.noNotification': 'Sem notificação',
  // HTML EDITOR
  'app.pages.htmlEditor.insertTemplate': 'Inserir modelo',
  'app.pages.htmlEditor.templates': 'Modelos',
  'app.pages.htmlEditor.saveTemplate': 'Salvar modelo',
  'app.pages.htmlEditor.replaceExisting': 'Substituir existente',
  'app.pages.htmlEditor.manageTemplates': 'Gerenciar modelos',
  'app.pages.htmlEditor.createNewTemplate': 'Criar novo modelo',
  'app.pages.htmlEditor.renameOrDeleteTemplates': 'Renomear ou excluir modelos',
  'app.pages.htmlEditor.copyFormatting': 'Copiar formatação',
  'app.pages.htmlEditor.template': 'Modelo',
  'app.pages.htmlEditor.templateSavedSuccessfully': 'Modelo salvo com sucesso.',
  'app.pages.htmlEditor.templateReplacedSuccessfully': 'Modelo substituído com sucesso.',
  'app.pages.htmlEditor.templateRenamedSuccessfully': 'Modelo renomeado com sucesso.',
  'app.pages.htmlEditor.templateDeletedSuccessfully': 'Modelo excluído com sucesso.',
  'app.pages.htmlEditor.noTemplatesToManage': 'Não há modelos para gerenciar.',
  'app.pages.htmlEditor.noTemplatesDefined': 'Não há modelos definidos.',
  'app.pages.htmlEditor.htmlTemplates': 'Modelos HTML',
  'app.pages.htmlEditor.showCodeAssistant': 'Mostrar assistente de código',

  // AI Traces
  'app.pages.aiTraces.traces': 'Rastreamentos',
  'app.pages.aiTraces.title': 'Rastreamentos de IA',
  'app.pages.aiTraces.userSessionsTitle': 'Sessões de IA por usuário',
  'app.pages.app.sidebarMenu.aiSessions': 'Sessões de IA',
  'app.pages.aiTraces.workflow': 'Fluxo de trabalho',
  'app.pages.aiTraces.agent': 'Agente',
  'app.pages.aiTraces.provider': 'Provedor',
  'app.pages.aiTraces.tokens': 'Tokens',
  'app.pages.aiTraces.inputTokens': 'Tokens de entrada',
  'app.pages.aiTraces.outputTokens': 'Tokens de saída',
  'app.pages.aiTraces.totalTokens': 'Tokens totais',
  'app.pages.aiTraces.cachedTokens': 'Tokens em cache',
  'app.pages.aiTraces.reasoningTokens': 'Tokens de raciocínio',
  'app.pages.aiTraces.duration': 'Duração',
  'app.pages.aiTraces.environment': 'Ambiente',
  'app.pages.aiTraces.groupId': 'Sessão',
  'app.pages.aiTraces.downloadReport': 'Baixar relatório de rastreamentos',
  'app.pages.aiTraces.reportDownloaded': 'Relatório de rastreamentos baixado',
  'app.pages.aiTraces.noTraces': 'Nenhum rastreamento encontrado',
  'app.pages.aiTraces.filterProvider': 'Filtrar por provedor',
  'app.pages.aiTraces.filterAgent': 'Filtrar por agente',
  'app.pages.aiTraces.filterStatus': 'Filtrar por status',
  'app.pages.aiTraces.dateFrom': 'Data inicial',
  'app.pages.aiTraces.dateTo': 'Data final',
  'app.pages.aiTraces.allProviders': 'Todos os provedores',
  'app.pages.aiTraces.allAgents': 'Todos os agentes',
  'app.pages.aiTraces.allStatuses': 'Todos os status',
  'app.pages.aiTraces.spanDetail': 'Detalhe do span',
  'app.pages.aiTraces.spanId': 'ID do span',
  'app.pages.aiTraces.startedAt': 'Início',
  'app.pages.aiTraces.endedAt': 'Fim',
  'app.pages.aiTraces.noData': 'Nenhum dado disponível para este span.',
  'app.pages.aiTraces.spans': 'Spans',
  'app.pages.aiTraces.stopped': 'Interrompido',
  'app.pages.aiTraces.stopExecution': 'Interromper execução',
  'app.pages.aiTraces.stopExecutionConfirmTitle': 'Interromper a execução?',
  'app.pages.aiTraces.stopExecutionConfirmContent':
    'O agente será solicitado a parar o mais rápido possível. Chamadas de ferramentas pendentes ainda podem ser concluídas antes que a execução pare. Continuar?',
  'app.pages.aiTraces.stopExecutionSuccess':
    'Solicitação de interrupção enviada. O agente vai parar em breve.',
  'app.pages.aiTraces.stopExecutionError': 'Não foi possível interromper a execução do agente.',
  'app.pages.aiTraces.stopExecutionNotInProgress': 'A execução não está mais em andamento.',
  'app.pages.aiTraces.selectSpan': 'Selecione um span para ver seus detalhes',
  'app.pages.aiTraces.noSpans': 'Nenhum span disponível',
  'app.pages.aiTraces.instructions': 'Instruções',
  'app.pages.aiTraces.systemInstructions': 'Instruções do sistema',
  'app.pages.aiTraces.configuration': 'Configuração',
  'app.pages.aiTraces.topP': 'Top P',
  'app.pages.aiTraces.reasoningEffort': 'Esforço de raciocínio',
  'app.pages.aiTraces.reasoningSummary': 'Resumo do raciocínio',
  'app.pages.aiTraces.functionCall': 'Chamada de função',
  'app.pages.aiTraces.functionName': 'Nome da função',
  'app.pages.aiTraces.arguments': 'Argumentos',
  'app.pages.aiTraces.functions': 'Funções',
  'app.pages.aiTraces.handoff': 'Transferência',
  'app.pages.aiTraces.fromAgent': 'Do agente',
  'app.pages.aiTraces.toAgent': 'Para agente',
  'app.pages.aiTraces.guardrail': 'Guardrail',
  'app.pages.aiTraces.triggered': 'Acionado',
  'app.pages.aiTraces.handoffs': 'Transferências',
  'app.pages.aiTraces.responseId': 'ID da resposta',
  'app.pages.aiTraces.rawData': 'Dados brutos',
  'app.pages.aiTraces.tokenSummary': 'Resumo de tokens',
  'app.pages.aiTraces.sessionDetails': 'Detalhes da sessão',
  'app.pages.aiTraces.viewSessionDetails': 'Ver detalhes da sessão',
  'app.pages.aiTraces.sessions': 'Sessões',
  'app.pages.aiTraces.sessionTitle': 'Título',
  'app.pages.aiTraces.sessionId': 'ID da sessão',
  'app.pages.aiTraces.unknownUser': 'Desconhecido',
  'app.pages.aiTraces.session': 'Sessão',
  'app.pages.aiTraces.lastActivity': 'Última atividade',
  'app.pages.aiTraces.traceCount': 'Rastreamentos',
  'app.pages.aiTraces.sessionCount': 'Sessões',
  'app.pages.aiTraces.cacheRatio': 'Cache',
  'app.pages.aiTraces.agents': 'Agentes',
  'app.pages.aiTraces.models': 'Modelos',
  'app.pages.aiTraces.elapsed': 'Tempo decorrido',
  'app.pages.aiTraces.viewConversation': 'Ver conversa',
  'app.pages.aiTraces.unpricedWarning':
    '{count, plural, one {# rastreamento usou} other {# rastreamentos usaram}} um modelo sem preço configurado: o custo exibido é menor que o real.',
  'app.pages.aiTraces.retentionNotice':
    'Abrange os rastreamentos dos últimos {days} dias. Para faturamento, use o relatório de custos de IA.',
  'app.pages.aiTraces.noSessions': 'Nenhuma sessão encontrada',
  'app.pages.aiTraces.noUsers': 'Nenhum usuário encontrado',
  'app.pages.aiTraces.sessionNotFound': 'A sessão não tem rastreamentos no período selecionado',
  'app.pages.aiTraces.sessionDialogTitle': 'Conversa da sessão',
  'app.pages.aiTraces.noSessionMessages': 'Nenhuma mensagem foi encontrada para esta sessão.',
  'app.pages.aiTraces.sessionLoadError': 'Não foi possível carregar a conversa da sessão.',
  'app.pages.aiTraces.temperature': 'Temperatura',
  'app.pages.aiTraces.appVersion': 'Versão do aplicativo',
  'app.pages.aiTraces.costSummary': 'Resumo de custos',
  'app.pages.aiTraces.inputCost': 'Custo de entrada',
  'app.pages.aiTraces.outputCost': 'Custo de saída',
  'app.pages.aiTraces.cachedCost': 'Custo de cache',
  'app.pages.aiTraces.totalCost': 'Custo total',

  // AI Pricing
  'app.pages.aiProvider.title': 'Provedores de IA',
  'app.pages.aiModel.title': 'Modelos de IA',
  'app.pages.aiPricing.title': 'Preços de IA',
  'app.pages.aiPricing.providersTab': 'Provedores',
  'app.pages.aiPricing.pricingTab': 'Preços',
  'app.pages.aiPricing.newProvider': 'Novo provedor',
  'app.pages.aiPricing.editProvider': 'Editar provedor',
  'app.pages.aiPricing.newModel': 'Novo modelo',
  'app.pages.aiPricing.editModel': 'Editar modelo',
  'app.pages.aiPricing.newTier': 'Novo nível de preços',
  'app.pages.aiPricing.editTier': 'Editar nível de preços',
  'app.pages.aiPricing.deleteConfirmTitle': 'Confirmar exclusão',
  'app.pages.aiPricing.deleteConfirmMessage': 'Tem certeza de que deseja excluir este item?',
  'app.pages.aiPricing.successCreated': 'Criado com sucesso',
  'app.pages.aiPricing.successUpdated': 'Atualizado com sucesso',
  'app.pages.aiPricing.successDeleted': 'Excluído com sucesso',
  'app.pages.aiPricing.filterByModel': 'Filtrar por modelo',
  'app.pages.aiPricing.allModels': 'Todos os modelos',
  'app.pages.aiPricing.noProvidersFound': 'Nenhum provedor encontrado',
  'app.pages.aiPricing.noModelsFound': 'Nenhum modelo encontrado',
  'app.pages.aiPricing.noTiersFound': 'Nenhum nível de preços encontrado',
  'app.pages.aiPricing.modelCode': 'Código do modelo',
  'app.pages.aiPricing.tokensMin': 'Tokens mín',
  'app.pages.aiPricing.tokensMax': 'Tokens máx',
  'app.pages.aiPricing.inputPrice': 'Preço entrada',
  'app.pages.aiPricing.cachePrice': 'Preço cache',
  'app.pages.aiPricing.outputPrice': 'Preço saída',
  'app.pages.aiPricing.pricePerMillionTokens': 'Preço por milhão de tokens',
  'app.pages.aiPricing.tokensMaxMustBeGreater': 'O máximo deve ser maior que o mínimo',
  'app.pages.aiPricing.unlimited': 'Ilimitado',
  'app.pages.aiPricing.successChangedStatus': 'Status do modelo alterado com sucesso',

  // nextMcp
  'app.pages.nextMcp.authorizeMcpAccess': 'Autorizar acesso MCP',
  'app.pages.nextMcp.mcpRequestAccess':
    'Um cliente MCP está solicitando acesso à sua conta Pyplan ({username}).',
  'app.pages.nextMcp.mcpRequestAccessNoUser':
    'Um cliente MCP está solicitando acesso à sua conta Pyplan.',
  'app.pages.nextMcp.company': 'Empresa',
  'app.pages.nextMcp.authorize': 'Autorizar',
  'app.pages.nextMcp.missingOAuthParams':
    'Parâmetros OAuth ausentes. Por favor reinicie o fluxo a partir do seu cliente MCP.',
  'app.pages.nextMcp.noActiveCompanies': 'Seu usuário não tem empresas ativas.',
  'app.pages.nextMcp.aiDisabledForCompany':
    'Os recursos de IA não estão ativados para esta empresa, portanto ela não pode ser vinculada a um cliente MCP. Entre em contato com o administrador para ativá-los.',
  'app.pages.nextMcp.unableToLoadSession':
    'Não foi possível carregar sua sessão do Pyplan. Por favor tente novamente.',
  'app.pages.nextMcp.noTokenReturned': 'A API do Pyplan não retornou um token DRF',
  'app.pages.nextMcp.unexpectedCallback': 'Resposta inesperada do callback',
  'app.pages.nextMcp.authorizationFailed': 'A autorização falhou',

  // Test applications
  'app.pages.testApplications.testApplications': 'Teste de aplicativos',
  'app.pages.testApplications.applicationPath': 'Aplicativo',
  'app.pages.testApplications.version': 'Versão',
  'app.pages.testApplications.lastExecutionDate': 'Data da última execução',
  'app.pages.testApplications.lastExecutionStatus': 'Status da última execução',
  'app.pages.testApplications.enabled': 'Habilitado',
  'app.pages.testApplications.actions': 'Ações',
  'app.pages.testApplications.run': 'Executar',
  'app.pages.testApplications.addApplication': 'Adicionar aplicativo',
  'app.pages.testApplications.editConfiguration': 'Editar configuração',
  'app.pages.testApplications.emailSectionTitle': 'Envio de e-mail ao finalizar',
  'app.pages.testApplications.removeApplication': 'Remover aplicativo',
  'app.pages.testApplications.viewLogs': 'Ver registros',
  'app.pages.testApplications.defaultVersion': 'Versão padrão',
  'app.pages.testApplications.selectApplication': 'Selecione um aplicativo',
  'app.pages.testApplications.selectApplicationHelper':
    'Escolha um aplicativo no gerenciador de arquivos para registrá-lo para testes.',
  'app.pages.testApplications.responsibles': 'Responsáveis',
  'app.pages.testApplications.sendOnFailureOnly': 'Enviar e-mails somente em caso de falha',
  'app.pages.testApplications.applicationAdded': 'Aplicativo adicionado com sucesso',
  'app.pages.testApplications.applicationRemoved': 'Aplicativo removido com sucesso',
  'app.pages.testApplications.configurationSaved': 'Configuração salva com sucesso',
  'app.pages.testApplications.runScheduled': 'Testes agendados para execução',
  'app.pages.testApplications.areYouSureToRemove':
    'Tem certeza de que deseja remover os seguintes aplicativos: {names}',
  'app.pages.testApplications.noApplicationsRegistered': 'Nenhum aplicativo registrado para testes',
  'app.pages.testApplications.executionLogs': 'Registros de execução',
  'app.experience.newExperience': 'Nova experiência',
  'app.experience.switchedToNext':
    'Você está usando a nova experiência. As seções atualizadas mostram o novo design; as demais serão atualizadas aos poucos.',
  'app.experience.switchedToNextWithoutViews':
    'Você está usando a nova experiência. O novo design será habilitado aos poucos em cada seção.',
  'app.experience.switchError': 'Não foi possível alterar a experiência. Tente novamente.',
  'app.pages.home.subtitle': 'Abra suas aplicações e continue de onde parou.',
  'app.pages.home.openInstances': 'Instâncias abertas',
  'app.pages.home.moreWorkspaces': 'Mais {count}',
  'app.pages.home.searchWorkspaces': 'Buscar espaços de trabalho',
  'app.pages.home.view': 'Visualização',
  'app.pages.home.listView': 'Visualização em lista',
  'app.pages.home.gridView': 'Visualização em grade',
  'app.pages.home.emptyWorkspace': 'Não há aplicações neste espaço de trabalho.',
  'app.pages.home.appOptions': 'Opções da aplicação',
  'app.pages.home.workspace': 'Espaço de trabalho'
}

export default messages
